/**
 * SITE_FACING: eproPreviewHeader|sponsors.languageDisplayName
 */
export default {
  "eproPreviewHeader.fullSurvey": "Full Survey",
  "eproPreviewHeader.surveyParts": "Survey Parts",
  "eproPreviewHeader.surveyCouldntBePreviewed": "Survey Couldn't Be Previewed",
  "eproPreviewHeader.unableToCreatePreview":
    "Sorry, we weren't able to create the preview. Please confirm that the survey JSON is valid and contact support if you continue to see this error.",
  "eproPreviewHeader.language": "Language",
  "eproPreviewHeader.changeLanguage": "Change Language",
  "eproPreviewHeader.selectLanguageDescription":
    "Select the languages you want to view the survey in.",
  "eproPreviewHeader.cancel": "Cancel",
  "eproPreviewHeader.siteLanguage": "Site Language",
  "eproPreviewHeader.caregiverLanguage": "Caregiver Language",
  "eproPreviewHeader.participantLanguage": "Participant Language",
  "eproPreviewHeader.notApplicable": "Not applicable",
  "eproPreviewHeader.deviceOptions": "Device Options",
  "eproPreviewHeader.selectDeviceDescription":
    "Set a preview size by choosing a device or using custom dimensions.",
  "eproPreviewHeader.apply": "Apply",
  "eproPreviewHeader.previewSize": "Preview Size",
  "eproPreviewHeader.edit": "Edit",
  "eproPreviewHeader.reset": "Reset",
  "eproPreviewHeader.setPreviewSize": "Set Preview Size",
  "eproPreviewHeader.deviceSize": "Device Size",
  "eproPreviewHeader.width": "Width",
  "eproPreviewHeader.height": "Height",
  "eproPreviewHeader.smallPhone": "Small Phone",
  "eproPreviewHeader.mediumPhone": "Medium Phone",
  "eproPreviewHeader.largePhone": "Large Phone",
  "eproPreviewHeader.smallTablet": "Small Tablet",
  "eproPreviewHeader.mediumTablet": "Medium Tablet",
  "eproPreviewHeader.largeTablet": "Large Tablet",
  "eproPreviewHeader.smallLaptop": "Small Laptop",
  "eproPreviewHeader.mediumLaptop": "Medium Laptop",
  "eproPreviewHeader.largeLaptop": "Large Laptop",
  "eproPreviewHeader.fullscreen": "Full Screen",
  "eproPreviewHeader.custom": "Custom",
  "eproPreviewHeader.updateLanguage": "Update Language",
  "eproPreviewHeader.update": "Update",
  "eproPreviewHeader.rotateDevice": "Rotate Device",
  "eproPreviewHeader.surveyPreview": "Survey Preview",
  "eproPreviewHeader.previewSurveyWarningAlert":
    "This is a preview survey. Responses are not saved.",
  "eproPreviewHeader.close": "Close",
  "eproPreviewHeader.submittedPreviewMessage":
    "You successfully submitted the survey as a respondent. You are now viewing the read-only submitted survey as a site user.",
  "eproPreviewHeader.surveyPartCompleted": "Survey Part Completed",
  "eproPreviewHeader.surveyPartCompletedDescription":
    "<container>You successfully submitted a survey part as a respondent. Typically, respondents are navigated to the tasks page after they submit a part and would return later to finish other parts. <bottom>You will now view the next part of the survey.</bottom></container>",
  "eproPreviewHeader.ok": "OK",
  "tokens.tokens": "Tokens",
  "tokens.youMustEnterAValue": "You must enter a value.",
  "tokens.useOnlyAlphanumericCharactersAndSymbols":
    "Use only alphanumeric characters and symbols.",
  "tokens.libraryBanner":
    "<b>Tokens</b> are dynamic values that you can use in the JSON for this survey. Create the token first and then add it to the survey. A study builder can change the value of the token if needed.",
  "tokens.studioBanner":
    "<b>Tokens</b> are dynamic values that are used in this survey. Expand a token to update the value.",
  "tokens.name": "Name",
  "tokens.uniqueName": "Name must be unique in the current survey.",
  "tokens.nameCharacters":
    "Name must only contain letters, numbers, underscores (_), and dashes (-).",
  "tokens.noReservedTokenName": `Name cannot begin with a reserved token name.`,
  "tokens.description": "Description",
  "tokens.value": "Value",
  "tokens.save": "Save",
  "tokens.stopEditing": "Stop Editing",
  "tokens.tokensBannerInManageSurvey":
    "This survey uses tokens from a library survey template. You can review these from the {tokensButton} section in the Tools menu.",
  "tokens.cancel": "Cancel",
  "tokens.createNewToken": "Create New Token",
  "tokens.edit": "Edit",
  "tokens.editTitle": "Edit {tokenName}",
  "tokens.expandTitle": "Expand {tokenName}",
  "tokens.collapseTitle": "Collapse {tokenName}",
  "tokens.deleteTitle": "Delete {tokenName}",
  "tokens.tokenRemoved": "{name} Removed",
  "tokens.selectUndo": "Select Undo to restore {name}.",
  "tokens.undo": "Undo",
  "customExports.heading": "Custom Exports",
  "customExports.subHeading":
    "Create and save custom exports to run in Study Home or schedule with an export job.",
  "customExports.addExport": "Add Export",
  "customExports.createNew": "Create New",
  "customExports.createNewDescription": "Create a new export specification",
  "customExports.createFromExisting": "Create from Existing",
  "customExports.createFromExistingDescription":
    "Upload a specification from another export",
  "customExports.uploadSpecification": "Upload Specification",
  "customExports.uploadSpecificationDescription":
    "Upload a specification file from another export to create this export. To download a specification file, open an export and select <b>Export Specification</b>.",
  "customExports.browse": "Browse",
  "customExports.browseOrDragAndDrop":
    "<link>Click to browse</link> or drag and drop a file",
  "customExports.fileFormatsAccepted": "File Formats Accepted:",
  "customExports.maxFileSizeLabel": "Max File Size:",
  "customExports.tooManyFiles": "You can only upload one file at a time.",
  "customExports.invalidImportFile":
    "This file does not meet the requirements. Resize or reformat it and try again.",
  "customExports.invalidCustomExportConfig":
    "This file does not meet the requirements. Re-export the specification and try uploading again.",
  "customExports.continue": "Continue",
  "customExports.editExport": "Edit Export",
  "customExports.leavePageMessage":
    "Do you want to leave this page? Changes you made may not be saved.",
  "customExports.saveAsDraft": "Save as Draft",
  "customExports.publish": "Publish",
  "customExports.cancel": "Cancel",
  "customExports.deleteDraft": "Delete Draft",
  "customExports.deleteDraftDescription":
    "Deleting this draft will remove it from your list of custom exports. This action cannot be undone.",
  "customExports.discardDraft": "Discard Draft",
  "customExports.discardDraftDescription":
    "Discarding your draft will delete only the changes that have not been published. Your active export will remain unchanged and cannot be deleted.",
  "customExports.discardUnpublishedChanges": "Discard Unpublished Changes",
  "customExports.availableColumns": "Available Columns",
  "customExports.filter": "Filter",
  "customExports.sort": "Sort",
  "customExports.filterDescription":
    "Manage which data is included in your export by defining filter criteria.",
  "customExports.addFilter": "Add Filter",
  "customExports.editFilter": "Edit Filter",
  "customExports.removeFilter": "Remove Filter",
  "customExports.filterLogic": "Filter Logic",
  "customExports.enterFilterValue": "Enter Filter Value",
  "customExports.filterType": "Filter Type",
  "customExports.filterValue": "Filter Value",
  "customExports.addValue": "Add Value",
  "customExports.chipInputHelper":
    "Add a value and press <b>ENTER</b>. You can add multiple values.",
  "customExports.column": "Column",
  "customExports.type": "Type",
  "customExports.value": "Value",
  "customExports.delete": "Delete",
  "customExports.clearAll": "Clear All ",
  "customExports.addColumnTitle": "Add {columnName}",
  "customExports.addAllColumns": "Add All",
  "customExports.added": "Added",
  "customExports.search": "Search",
  "customExports.clear": "Clear",
  "customExports.sortDescription":
    "Manage how your export is sorted. Drag and drop rows to change their order. You can sort by a maximum of 5 items.",
  "customExports.moveSort": "Move Sort",
  "customExports.addSort": "Add Sort",
  "customExports.removeSort": "Remove Sort",
  "customExports.sortAscending": "Sort Ascending",
  "customExports.sortDescending": "Sort Descending",
  "customExports.specification": "Specification",
  "customExports.zeroStateHeading": "No Exports Created",
  "customExports.zeroStateDescription": "Create an export to get started.",
  "customExports.specificationDescription":
    "Manage the columns that appear in your export and how they are labeled. Drag-and-drop rows to rearrange their order within the document.",
  "customExports.specificationEmptyDescription":
    "Data columns that you add to your export will appear here.",
  "customExports.addColumns": "Add Columns",
  "customExports.columnName": "Column Name",
  "customExports.columnLabel": "Column Label",
  "customExports.columnLabelTooltip":
    "You can include the {{domain}} token in the column label. When the export runs, a separate file will be created for each domain.",
  "customExports.removeColumn": "Remove Column",
  "customExports.moveColumn": "Move Column",
  "customExports.column.name": "Name",
  "customExports.column.description": "Description",
  "customExports.column.lastPublishedOn": "Last Published On",
  "customExports.column.availableInStudyHome": "Available In Study Home",
  "customExports.column.status": "Status",
  "customExports.status.active": "Active",
  "customExports.status.draft": "Draft",
  "customExports.status.unpublishedChanges": "Unpublished Changes",
  "customExports.editIconTitle": "Edit Custom Export",
  "customExports.yes": "Yes",
  "customExports.no": "No",
  "customExports.exportName": "Export Name",
  "customExports.description": "Description",
  "customExports.exportFilename": "Export Filename",
  "customExports.exportFilenameTooltip":
    "You can include {{date}}, {{datetime}}, and {{domain}} tokens in a filename. When the export runs, the tokens are replaced with the current date, datetime, or domain.",
  "customExports.makeAvailableInStudyHome": "Available in Study Home",
  "customExports.makeAvailableInStudyHomeTooltip":
    "Choose whether to make the export usable in Study Home. Active exports are always available through Export Jobs, regardless of this setting.",
  "customExports.previewExport": "Preview Export",
  "customExports.exportPreview": "Export Preview",
  "customExports.preview": "Preview",
  "customExports.previewDescription":
    "This preview shows only the first 10 rows of data and does not apply any sorting.",
  "customExports.noPreviewData": "No data available to preview",
  "customExports.exportSpecification": "Export Specification",
  "customExports.exportSpecificationDisabledReason":
    "You can export the specification after saving it.",
  "customExports.validation.required": "This field is required.",
  "customExports.validation.filenameToken":
    "Only date, datetime and domain tokens can be used.",
  "customExports.validation.filenameInvalidDomainToken":
    "To use the domain token, you must use the domain token within one of the columns.",
  "customExports.validation.filenameMissingDomainToken":
    "This export will be split into one file per domain, so the domain token must be used in the filename.",
  "customExports.validation.filenameSpecialCharacterError":
    "Filename cannot contain special characters or white space.",
  "customExports.validation.columnLabelInvalidToken":
    "Only the domain token can be used.",
  "customExports.validation.columnLabelInvalidDomainTokenUsage":
    "The domain token can only be used on Survey and Question columns.",
  "customExports.save": "Save",
  "customExports.select": "Select",
  "exports.sideNavLabel": "Exports Navigation",
  "exportJobs.SEE_MORE": "SEE MORE",
  "exportJobs.disconnected": "Disconnected",
  "exportJobs.ruleHasBeenDisconnected": "Rule Has Been Disconnected",
  "exportJobs.ruleHasBeenDisconnectedMessage":
    "The rule required to run this job has been disconnected. To resolve this issue, add a conditional action to the rule, change the export selection or deactivate this job.",
  "exportJobs.rule": "Rule",
  "exportJobs.connected": "Connected",
  "exportJobs.triggeredRuleExports": "Triggered Rule-Exports",
  "exportJobs.triggeredRuleExportsDescription":
    "The export you've selected is triggered by the following rule:",
  "exportJobs.viewRule": "View Rule",
  "exportJobs.OR": "OR",
  "exportJobs.triggeredRuleExport": "Triggered Rule Export",
  "exportJobs.triggeredRuleExportDescription":
    "Only one triggered rule export may be added to an export job. They cannot be combined with other types of exports.",
  "exportJobs.heading": "Export Jobs",
  "exportJobs.cancelPasswordChange": "Cancel Password Change",
  "exportJobs.changePassword": "Change Password",
  "exportJobs.subheader":
    "You may have up to 10 active connections at a time, only one of which may be an active CDB connection.",
  "exportJobs.createJob": "Create Job",
  "exportJobs.editJob": "Edit Job",
  "exportJobs.createJobActions": "Create Job Actions",
  "exportJobs.ftpConnection": "FTP Connection",
  "exportJobs.cdbConnection": "CDB Connection",
  "exportJobs.zeroStateHeading": "No Export Jobs",
  "exportJobs.zeroStateDescription":
    "Start by adding an export job to this study.",
  "exportJobs.exportJobSuccessfullyRunNoName": "Export job successfully run",
  "exportJobs.exportJobFailedToRunNoName": "Export job failed to run",
  "exportJobs.exportJobSuccessfullyRun": "{exportJobName} successfully run",
  "exportJobs.exportJobFailedToRun": "{exportJobName} failed to run",
  "exportJobs.exportJobDeactivated": "Export job deactivated",
  "exportJobs.exportJobActivated": "Export job activated",
  "exportJobs.passwordRequired":
    "The password is required to activate this job.",
  "exportJobs.deactivate": "Deactivate",
  "exportJobs.cancel": "Cancel",
  "exportJobs.activateThisJob": "Activate This Job",
  "exportJobs.nameMustBeUnique": "Job Name must be unique.",
  "exportJobs.cannotActivateThisJob": "Cannot Activate this Job",
  "exportJobs.ok": "OK",
  "exportJobs.cannotActivateThisJobDescription":
    "You may have up to 10 active connections at a time, only one of which may be an active CDB connection. You must deactivate a different connection before you can activate this one.",
  "exportJobs.done": "Done",
  "exportJobs.deactivateThisJob": "Deactivate This Job",
  "exportJobs.deactivateThisJobModalDescription":
    "If you deactivate this job, the data will no longer be exported to the destination folder within your server. To reactivate the job, you will need to reestablish the connection to the server by reentering the authentication credentials.",
  "exportJobs.ruleTriggered": "Rule-triggered: {ruleName}",
  "exportJobs.disconnectedTriggeringRuleTooltip":
    "This job will not run due to a disconnected rule. Edit or deactivate this job to resolve.",
  "exportJobs.ruleTriggeredJobsCannotBeRunManually":
    "Rule-triggered jobs cannot be run manually.",
  "exportJobs.failed": "Failed",
  "exportJobs.active": "Active",
  "exportJobs.inactive": "Inactive",
  "exportJobs.editIconTitle": "Edit Job",
  "exportJobs.runIconTitle": "Run Job",
  "exportJobs.name": "Name",
  "exportJobs.type": "Type",
  "exportJobs.serverUrl": "Server URL",
  "exportJobs.destinationFolder": "Destination Folder",
  "exportJobs.nextExpectedRun": "Next Expected Run",
  "exportJobs.restricted": "Restricted",
  "exportJobs.restrictedTooltip":
    "Export jobs with “Yes” in this column contain restricted data.",
  "exportJobs.lastRun": "Last Run",
  "exportJobs.connectionType": "Connection Type",
  "exportJobs.jobName": "Job Name",
  "exportJobs.port": "Port",
  "exportJobs.username": "Username",
  "exportJobs.password": "Password",
  "exportJobs.oneTablePerSurvey": "Display one table per survey",
  "exportJobs.timestampsInUtc": "Display system timestamps in UTC",
  "exportJobs.timestampsInUtcTooltipLabel":
    "Enabling this will export system timestamps in UTC. Disabling will export system timestamps in the local timezone it was collected in.",
  "exportJobs.dataTypes": "Data Types",
  "exportJobs.dataTypesDescription":
    "Select at least one data type to include in the export. You can include {{date}} and {{datetime}} tokens in the file name. When the export runs, the tokens are replaced with the current date or date and time.",
  "exportJobs.serverCredentials": "Server Credentials",
  "exportJobs.authenticationCredentials": "Authenticate Server Connection",
  "exportJobs.authenticationType": "Authentication Type",
  "exportJobs.generatePublicKey": "Generate Public Key",
  "exportJobs.dataChanges": "Data Changes",
  "exportJobs.exportJobSchedule": "Export Job Schedule",
  "exportJobs.exportJobScheduleDescription":
    "Define a frequency and a start date for this export job.",
  "exportJobs.exportJobScheduleButton": "Change Schedule",
  "exportJobs.schedule": "Schedule",
  "exportJobs.formattedSchedule":
    "Every {intervalValue} {intervalUnit} starting {date}",
  "exportJobs.selectHours": "Hours",
  "exportJobs.selectDays": "Days",
  "exportJobs.selectWeeks": "Weeks",
  "exportJobs.selectMonths": "Months",
  "exportJobs.hours": "hours",
  "exportJobs.hour": "hour",
  "exportJobs.days": "days",
  "exportJobs.day": "day",
  "exportJobs.weeks": "weeks",
  "exportJobs.week": "week",
  "exportJobs.months": "months",
  "exportJobs.month": "month",
  "exportJobs.close": "close",
  "exportJobs.repeatsEvery": "Repeats Every",
  "exportJobs.startDate": "Start Date",
  "exportJobs.startTime": "Start Time",
  "exportJobs.startDateTimeError": "Start date and time must be in the future.",
  "exportJobs.ftpFrequencyError":
    "Frequency must be longer than one hour and shorter than one month.",
  "exportJobs.cdbFrequencyError":
    "Frequency must be longer than six hours and shorter than one month.",
  "exportJobs.nextExpectedRunModalTitle": "Start Date and Time Have Passed",
  "exportJobs.nextExpectedRunModalMessage":
    "The selected start date and time have already passed. The next export will run on {nextExpectedRun}. How do you want to continue?",
  "exportJobs.saveSchedule": "Save Schedule",
  "exportJobs.selectNewSchedule": "Select New Schedule",
  "exportJobs.timeZone": "Timezone",
  "exportJobs.settings": "Settings",
  "exportJobs.settingsDescription":
    "You can include {{date}} and {{datetime}} tokens in the file name. When the export runs, the tokens are replaced with the current date or date and time.",
  "exportJobs.zipDescription": "Export the data types into one {zip} file",
  "exportJobs.logDescription": "Include a file with a log of the export",
  "exportJobs.addAFilenameError": "Add a filename.",
  "exportJobs.specialCharacterError":
    "Filename cannot contain special characters or white space.",
  "exportJobs.allowedTokens": "Only {allowedTokens} tokens can be used.",
  "exportJobs.containsRestrictedData": "Exports will contain restricted data",
  "exportJobs.omitsRestrictedData": "Exports will omit restricted data",
  "exportJobs.save": "Save",
  "exportJobs.testConnection": "Test Connection",
  "exportJobs.testServerConnection": "Test Server Connection",
  "exportJobs.testAgain": "Test Again",
  "exportJobs.noResults": "No Results to Display",
  "exportJobs.successful": "Connection Successful",
  "exportJobs.connectionFailed": "Connection Failed",
  "exportJobs.cannotFindServer": "Cannot find server",
  "exportJobs.publicKeyName": "Public Key Name",
  "exportJobs.publicKey": "Public Key",
  "exportJobs.downloadPubFile": "Download .pub File",
  "exportJobs.generateNewKey": "Generate New Key",
  "exportJobs.generateNewKeyDescription":
    "Add a unique name for this public key so that you may reference it for multiple jobs across your study. Key names can only contain letters, numbers, hyphens, and underscores.",
  "exportJobs.keyNameContainsInvalidChars":
    "Key names can only contain letters, numbers, hyphens, and underscores.",
  "exportJobs.keyNameUniqueness": "Public Key Name must be unique.",
  "exportJobs.copyPubicKey": "Copy Public Key",
  "exportJobs.copied": "Copied",
  "exportJobs.SSHKeypair": "SSH Keypair",
  "exportJobs.select": "Select",
  "exportJobs.usernameAndPassword": "Username and Password",
  "exportJobs.authenticationTypeError":
    "This authentication type is not allowed for the selected connection type.",
  "exportJobs.addExportsToJob": "Add Exports to Job",
  "exportJobs.addExportsToJobDescription":
    "Choose one or more exports to include in this job.",
  "exportJobs.selectExports": "Select Exports",
  "exportJobs.selectExportsDescription":
    "Select at least one export to include in the job.",
  "exportJobs.standard": "Standard",
  "exportJobs.freeDraw": "Free Draw",
  "exportJobs.siteMedia": "Site Media",
  "exportJobs.criteriaChecks": "Criteria Checks",
  "exportJobs.custom": "Custom",
  "exportJobs.confirmExports": "Confirm Exports",
  "exportJobs.editExports": "Edit Export",
  "exportJobs.filename": "Filename",
  "exportJobs.timestampDisplayedIn": "Timestamps Displayed In",
  "exportJobs.saveChanges": "Save Changes",
  "exportJobs.edit": "Edit",
  "exportJobs.remove": "Remove",
  "exportJobs.utc": "UTC",
  "exportJobs.local": "Local",
  "exportJobs.freeDrawPDFs": "Free Draw PDFs",
  "exportJobs.attachments": "Attachments",
  "exportJobs.surveyDataQs": "Survey Data - QS",
  "exportJobs.surveyDataFt": "Survey Data - FT",
  "exportJobs.surveyDataRs": "Survey Data - RS",
  "exportJobs.surveyDataMk": "Survey Data - MK",
  "exportJobs.participantEvents": "Participant Events",
  "exportJobs.participantGroups": "Participant Groups",
  "exportJobs.compliance": "Compliance",
  "exportJobs.auditTrail": "Audit Trail",
  "exportJobs.dataChange": "Data Changes",
  "outboundApis.sideNav": "Outbound API",
  "outboundApis.heading": "Outbound API Credentials",
  "outboundApis.subHeading":
    "Create API Credentials for use in Rules API Call actions.",
  "outboundApis.addCredentials": "Add Credentials",
  "outboundApis.noConnectedRules":
    "You must connect an unassigned API rule to add credentials.",
  "outboundApis.apiLog": "Outbound API Log",
  "outboundApis.credentialsZeroStateHeading": "No Credentials Created",
  "outboundApis.credentialsZeroStateDescription":
    "Create a credential to get started",
  "outboundApis.credential": "Credential",
  "outboundApis.status": "Status",
  "outboundApis.editCredential": "Edit Credential",
  "outboundApis.delete": "Delete",
  "outboundApis.deleteCredential": "Delete Credential",
  "outboundApis.deleteCredentialMessage":
    "Are you sure you want to delete this credential?",
  "outboundApis.activateCredential": "Activate Credential",
  "outboundApis.selectRulesToActivateCredential":
    "Select Rules to connect to save and activate.",
  "outboundApis.deactivate": "Deactivate",
  "outboundApis.deactivateCredential": "Deactivate Credential",
  "outboundApis.deactivateCredentialMessage":
    "Deactivating this Credential will automatically stop all API calls for connected rules.",
  "outboundApis.active": "Active",
  "outboundApis.inactive": "Inactive",
  "outboundApis.date": "Date",
  "outboundApis.success": "Success",
  "outboundApis.failure": "Failure",
  "outboundApis.exception": "Exception",
  "outboundApis.apiLogZeroStateHeading": "No API Logs",
  "outboundApis.apiLogZeroStateDescription":
    "Logs will appear here after your first API call occurs",
  "outboundApis.downloadLog": "Download Log",
  "outboundApis.downloadLogRestrictedDataTooltip":
    "You must have restricted data permissions to access this log.",
  "outboundApis.downloadLogFailed":
    "An error occurred with your download. Try again.",
  "outboundApis.addCredentialsHeading": "Add Outbound API Credentials",
  "outboundApis.editCredentialsHeading": "Edit Outbound API Credentials",
  "outboundApis.addCredentialsDescription":
    "Add {veevaedc} username and password credentials for use with {veevaedc} Combination Form Update Data actions. Credentials require a rule in an approved major or minor collection version.",
  "outboundApis.editCredentialsDescription":
    "Defines the label which is displayed to study builders in the study design spec AND within the rules picklist for Authentication Credentials.",
  "outboundApis.credentialLabel": "Credential Label",
  "outboundApis.credentialLabelRequired": "Credential Label is required",
  "outboundApis.edcUpdateFormData": "{veevaedc} - Combination Update Form Data",
  "outboundApis.username": "Username",
  "outboundApis.usernameRequired": "Username is required",
  "outboundApis.password": "Password",
  "outboundApis.changePassword": "Change Password",
  "outboundApis.cancelPasswordChange": "Cancel Password Change",
  "outboundApis.passwordRequired": "Password is required",
  "outboundApis.vaultSubdomain": "{vault} subdomain",
  "outboundApis.testFailed": "Failure, verify and try again.",
  "outboundApis.testSuccessful": "Test Successful",
  "outboundApis.veevaEdcHelpLink": "{veevaedc} Help",
  "outboundApis.vaultSubdomainRequired": "{vault} subdomain is required",
  "outboundApis.vaultSubdomainInvalid":
    "{vault} subdomain should not contain http or www and must end with a domain such as .com",
  "outboundApis.rulesToConnect": "Rules to Connect",
  "outboundApis.connectedRules": "Connected Rules",
  "outboundApis.connectedRulesRequired": "You must connect one or more rules",
  "outboundApis.apply": "Apply",
  "outboundApis.testCredential": "Test Credential",
  "outboundApis.cancel": "Cancel",
  "outboundApis.save": "Save",
  "sponsors.languageDisplayName.bg-BG": "Bulgarian (Bulgaria)",
  "sponsors.languageDisplayName.cs-CZ": "Czech (Czechia)",
  "sponsors.languageDisplayName.da-DK": "Danish (Denmark)",
  "sponsors.languageDisplayName.de-AT": "German (Austria)",
  "sponsors.languageDisplayName.de-CH": "German (Switzerland)",
  "sponsors.languageDisplayName.de-DE": "German (Germany)",
  "sponsors.languageDisplayName.el-GR": "Greek (Greece)",
  "sponsors.languageDisplayName.en-CA": "English (Canada)",
  "sponsors.languageDisplayName.en-GB": "English (United Kingdom)",
  "sponsors.languageDisplayName.en-IE": "English (Ireland)",
  "sponsors.languageDisplayName.en-US": "English (United States)",
  "sponsors.languageDisplayName.es-AR": "Spanish (Argentina)",
  "sponsors.languageDisplayName.es-ES": "Spanish (Spain)",
  "sponsors.languageDisplayName.es-MX": "Spanish (Mexico)",
  "sponsors.languageDisplayName.es-US": "Spanish (United States)",
  "sponsors.languageDisplayName.fr-BE": "French (Belgium)",
  "sponsors.languageDisplayName.fr-CA": "French (Canada)",
  "sponsors.languageDisplayName.fr-CH": "French (Switzerland)",
  "sponsors.languageDisplayName.fr-FR": "French (France)",
  "sponsors.languageDisplayName.it-CH": "Italian (Switzerland)",
  "sponsors.languageDisplayName.it-IT": "Italian (Italy)",
  "sponsors.languageDisplayName.ja-JP": "Japanese (Japan)",
  "sponsors.languageDisplayName.ko-KR": "Korean (South Korea)",
  "sponsors.languageDisplayName.nb-NO": "Bokmål (Norway)",
  "sponsors.languageDisplayName.nl-BE": "Dutch (Belgium)",
  "sponsors.languageDisplayName.nl-NL": "Dutch (Netherlands)",
  "sponsors.languageDisplayName.pl-PL": "Polish (Poland)",
  "sponsors.languageDisplayName.pt-BR": "Portuguese (Brazil)",
  "sponsors.languageDisplayName.pt-PT": "Portuguese (Portugal)",
  "sponsors.languageDisplayName.sv-SE": "Swedish (Sweden)",
  "sponsors.languageDisplayName.th-TH": "Thai (Thailand)",
  "sponsors.languageDisplayName.tr-TR": "Turkish (Türkiye)",
  "sponsors.languageDisplayName.zh-SG": "Chinese (Singapore)",
  "sponsors.languageDisplayName.he-IL": "Hebrew (Israel)",
  "sponsors.languageDisplayName.ht-HT": "Haitian Creole (Haiti)",
  "sponsors.languageDisplayName.ar-IL": "Arabic (Israel)",
  "sponsors.languageDisplayName.ca-ES": "Catalan (Spain)",
  "sponsors.languageDisplayName.de-BE": "German (Belgium)",
  "sponsors.languageDisplayName.en-AU": "English (Australia)",
  "sponsors.languageDisplayName.hu-HU": "Hungarian (Hungary)",
  "sponsors.languageDisplayName.zh-CN": "Chinese, Simplified (China)",
  "sponsors.languageDisplayName.en-NZ": "English (New Zealand)",
  "sponsors.languageDisplayName.en-ZA": "English (South Africa)",
  "sponsors.languageDisplayName.fi-FI": "Finnish (Finland)",
  "sponsors.languageDisplayName.nso-ZA": "Northern Sotho (South Africa)",
  "sponsors.languageDisplayName.sr-Latn-RS": "Serbian, Latin (Serbia)",
  "sponsors.languageDisplayName.sv-FI": "Swedish (Finland)",
  "sponsors.languageDisplayName.tn-ZA": "Tswana (South Africa)",
  "sponsors.languageDisplayName.xh-ZA": "Xhosa (South Africa)",
  "sponsors.languageDisplayName.zu-ZA": "Zulu (South Africa)",
  "sponsors.languageDisplayName.as-IN": "Assamese (India)",
  "sponsors.languageDisplayName.bn-IN": "Bengali (India)",
  "sponsors.languageDisplayName.gu-IN": "Gujarati (India)",
  "sponsors.languageDisplayName.kn-IN": "Kannada (India)",
  "sponsors.languageDisplayName.hi-IN": "Hindi (India)",
  "sponsors.languageDisplayName.ml-IN": "Malayalam (India)",
  "sponsors.languageDisplayName.mr-IN": "Marathi (India)",
  "sponsors.languageDisplayName.or-IN": "Odia (India)",
  "sponsors.languageDisplayName.ta-IN": "Tamil (India)",
  "sponsors.languageDisplayName.af-ZA": "Afrikaans (South Africa)",
  "sponsors.languageDisplayName.en-IL": "English (Israel)",
  "sponsors.languageDisplayName.en-SG": "English (Singapore)",
  "sponsors.languageDisplayName.es-CL": "Spanish (Chile)",
  "sponsors.languageDisplayName.es-CO": "Spanish (Colombia)",
  "sponsors.languageDisplayName.es-PE": "Spanish (Peru)",
  "sponsors.languageDisplayName.ms-SG": "Malay (Singapore)",
  "sponsors.languageDisplayName.ta-SG": "Tamil (Singapore)",
  "sponsors.languageDisplayName.te-IN": "Telugu (India)",
  "sponsors.languageDisplayName.sr-RS": "Serbian, Cyrillic (Serbia)",
  "sponsors.languageDisplayName.lt-LT": "Lithuanian (Lithuania)",
  "sponsors.languageDisplayName.lv-LV": "Latvian (Latvia)",
  "sponsors.languageDisplayName.ru-IL": "Russian (Israel)",
  "sponsors.languageDisplayName.ru-LT": "Russian (Lithuania)",
  "sponsors.languageDisplayName.ru-LV": "Russian (Latvia)",
  "sponsors.languageDisplayName.zh-TW": "Chinese, Traditional (Taiwan)",
  "sponsors.languageDisplayName.hr-HR": "Croatian (Croatia)",
  "sponsors.languageDisplayName.zh-HK": "Chinese, Traditional (Hong Kong)",
  "sponsors.languageDisplayName.uk-UA": "Ukrainian (Ukraine)",
  "sponsors.languageDisplayName.ru-UA": "Russian (Ukraine)",
  "sponsors.languageDisplayName.ur-IN": "Urdu (India)",
  "sponsors.languageDisplayName.pa-IN": "Punjabi (India)",
  "sponsors.languageDisplayName.et-EE": "Estonian (Estonia)",
  "sponsors.languageDisplayName.ru-EE": "Russian (Estonia)",
  "sponsors.languageDisplayName.st-ZA": "Southern Sotho (South Africa)",
  "sponsors.languageDisplayName.ro-RO": "Romanian (Romania)",
  "sponsors.languageDisplayName.ro-MD": "Romanian (Moldova)",
  "sponsors.languageDisplayName.ru-MD": "Russian (Moldova)",
  "sponsors.languageDisplayName.vi-VN": "Vietnamese (Vietnam)",
  "sponsors.languageDisplayName.sk-SK": "Slovak (Slovakia)",
  "sponsors.languageDisplayName.bs-BA": "Bosnian (Bosnia and Herzegovina)",
  "sponsors.languageDisplayName.ka-GE": "Georgian (Georgia)",
  "sponsors.languageDisplayName.en-IN": "English (India)",
  "sponsors.languageDisplayName.ar-SA": "Arabic (Saudi Arabia)",
  "sponsors.languageDisplayName.ts-ZA": "Tsonga (South Africa)",
  "sponsors.languageDisplayName.gl-ES": "Galician (Spain)",
  "sponsors.languageDisplayName.en-HK": "English (Hong Kong)",
  "sponsors.languageDisplayName.ms-MY": "Malay (Malaysia)",
  "sponsors.languageDisplayName.en-MY": "English (Malaysia)",
  "sponsors.languageDisplayName.zh-MY": "Chinese, Simplified (Malaysia)",
  "sponsors.languageDisplayName.ta-MY": "Tamil (Malaysia)",
  "sponsorStudyNav.navLabel": "Study Home Navigation",
  "sponsorStudyNav.overview": "Overview",
  "sponsorStudyNav.sites": "Sites",
  "sponsorStudyNav.reports": "Reports",
  "sponsorStudyNav.compliance": "Compliance",
  "sponsorStudyNav.study": "Study",
  "sponsorStudyNav.countries": "Countries",
  "sponsorStudyNav.participants": "Participants",
  "sponsorStudyNav.studyLocked": "Study Locked",
  "sponsorStudyNav.studyUnlocked": "Study Unlocked",
  "sponsorStudyNav.breadcrumbLabel": "Breadcrumb",
  "sponsorStudyNav.returnToVault": "Return to {vault}",
  "sponsorReports.includeZipFileOfUploadedMediaAndFreeDrawImages":
    "Include {zip} file of Uploaded Media and Free Draw Images",
  "sponsorReports.includesMediaUploadsAndFreeDraw":
    "Includes Media (Uploads and Free Draw)",
  "sponsorReports.yes": "Yes",
  "sponsorReports.no": "No",
  "sponsorReports.mediaIncluded": "Media Included",
  "sponsorReports.mediaNotIncluded": "Media Not Included",
  "sponsorReports.containsRestrictedDataWarning":
    "Your reports will contain restricted data",
  "sponsorReports.omitsRestrictedDataWarning":
    "Your reports will omit restricted data",
  "sponsorReports.domains": "Domains",
  "sponsorReports.domain": "Domain",
  "sponsorReports.QS": "QS",
  "sponsorReports.FT": "FT",
  "sponsorReports.RS": "RS",
  "sponsorReports.MK": "MK",
  "sponsorReports.qs": "qs",
  "sponsorReports.ft": "ft",
  "sponsorReports.rs": "rs",
  "sponsorReports.mk": "mk",
  "sponsorReports.domainsCount": "Domains ({count})",
  "sponsorReports.viewFilters": "View Filters",
  "sponsorReports.new": "New",
  "sponsorReports.containsRestrictedData": "Contains Restricted Data",
  "sponsorReports.omitsRestrictedData": "Omits Restricted Data",
  "sponsorReports.download": "Download",
  "sponsorReports.optionsList": "Options: {list}",
  "sponsorReports.sitesCount": "Sites ({count})",
  "sponsorReports.timestampsSelected": "Timestamps ({timezoneType})",
  "sponsorReports.timeRange": "Time Range",
  "sponsorReports.timestampsDislpayedIn": "Timestamps Displayed In",
  "sponsorReports.timestampsDislpayedInTooltip":
    "System timestamps are exported based on your selection: in the timezone where the data was collected for Local, or in UTC for UTC.",
  "sponsorReports.reportsRunningCount": "{count} report(s) running...",
  "sponsorReports.studioAndStudyHome": "Studio and Study Home",
  "sponsorReports.studioAndStudyHomeDescription":
    "This report contains the audit activities, which includes all changes that are made in Studio and Study Home.",
  "sponsorReports.siteUserAction": "Site Non-Clinical Data",
  "sponsorReports.siteUserActionDescription":
    "This report contains site audit activities for operational actions conducted by site users.",
  "sponsorReports.siteClinicalData": "Site Clinical Data",
  "sponsorReports.siteClinicalDataDescription":
    "This report contains site audit actions covering the creation, editing, and removal of clinical data.",
  "sponsorReports.STANDARD": "STANDARD",
  "sponsorReports.AUDIT_TRAIL": "AUDIT TRAIL",
  "sponsorReports.CRITERIA_CHECKS": "CRITERIA CHECKS",
  "sponsorReports.CUSTOM": "CUSTOM",
  "sponsorReports.downloadMessage.surveyData": "Survey_Data",
  "sponsorReports.downloadMessage.participantEvents": "Participant_Events",
  "sponsorReports.downloadMessage.participantGroups": "Participant_Groups",
  "sponsorReports.downloadMessage.compliance": "Compliance",
  "sponsorReports.downloadMessage.auditTrail": "Studio_Study_Home",
  "sponsorReports.downloadMessage.siteUserAction": "Site_Non_Clinical_Data",
  "sponsorReports.downloadMessage.siteClinicalData": "Site_Clinical_Data",
  "sponsorReports.downloadMessage.dataChanges": "Data_Changes",
  "sponsorReports.downloadMessage.criteriaCheckOutput": "Criteria_Check_Output",
  "sponsorReports.generateNew": "Generate New",
  "sponsorReports.resetOptions": "Reset Options",
  "sponsorReports.timeframe": "Timeframe",
  "sponsorReports.all": "All",
  "sponsorReports.allTime": "All Time",
  "sponsorReports.pastWeek": "Past Week",
  "sponsorReports.pastMonth": "Past Month",
  "sponsorReports.runReport": "Run Report",
  "sponsorReports.runningReport": "Running Report",
  "sponsorReports.previousRuns": "Previous Runs",
  "sponsorReports.reportFailedToGenerate":
    "{label} report failed to run. Please try again.",
  "sponsorReports.reportDownloadFailed":
    "The {label} report download failed. Try again.",
  "sponsorReports.runAReport": "Run a report",
  "sponsorReports.surveyData": "Survey Data",
  "sponsorReports.participantEvents": "Participant Events",
  "sponsorReports.participantEventsDescription":
    "This report contains each participant event along with the corresponding entered event datetime.",
  "sponsorReports.participantGroups": "Participant Groups",
  "sponsorReports.participantGroupsDescription":
    "This report shows the current groups each participant is assigned to.",
  "sponsorReports.runSurveyData": "Run Survey Data",
  "sponsorReports.surveyDataDescription":
    "This report contains the current data for {epro} and {eclinro} surveys. It also includes any scoring associated with a survey.",
  "sponsorReports.compliance": "Compliance",
  "sponsorReports.runCompliance": "Run Compliance",
  "sponsorReports.complianceDescription":
    "This report contains a record for every survey with its related compliance status.",
  "sponsorReports.sponsorAuditTrail": "Audit Trail",
  "sponsorReports.runSponsorAuditTrail": "Run Audit Trail",
  "sponsorReports.sponsorAuditTrailDescription":
    "This report contains the audit activities, which includes all changes that are made in Studio.",
  "sponsorReports.runOutputReportForEventNameDescription":
    "This report contains the results of all successful runs of the criteria check rules for this event.",
  "sponsorReports.dataChanges": "Data Changes",
  "sponsorReports.runDataChanges": "Run Data Changes",
  "sponsorReports.dataChangesDescription":
    "This report contains all data changes that were made after initial collection.",
  "sponsorReports.run": "Run",
  "sponsorReports.running": "Running",
  "sponsorReports.reportRunCompleted": "Report Run Completed",
  "sponsorReports.reportTypes": "Report Types",
  "sponsorReports.sites": "Sites",
  "sponsorReports.site": "Site",
  "sponsorReports.allSites": "All Sites",
  "sponsorReports.selectASite": "Select a site",
  "sponsorReports.downloadContainsRestricted": "contains-restricted",
  "sponsorReports.downloadOmitsRestricted": "omits-restricted",
  "sponsorOverview.noSignatureCounts":
    "No signature counts are currently available.",
  "sponsorOverview.siteSignatures": "Site Signatures",
  "sponsorOverview.signatureStatus": "Signature Status",
  "sponsorOverview.signatureStatusTooltip":
    "The chart displays the overall signature status for participants. A participant is counted as Complete only when the Primary Investigator has electronically signed all required data. All required data must be signed before a site can be locked.",
  "sponsorOverview.complete": "Complete",
  "sponsorOverview.needsSignature": "Needs Signature",
  "sponsorOverview.signatureCompleteness": "Signature Completeness",
  "sponsorOverview.signatureCompletenessByParticipant":
    "Signature Completeness (by Participant)",
  "sponsorOverview.totals": "Totals",
  "sponsorOverview.allTime": "All time",
  "sponsorOverview.sites": "Sites",
  "sponsorOverview.sitesTooltip":
    "The total number of sites on this study who have activated at least one version.",
  "sponsorOverview.participants": "Participants",
  "sponsorOverview.participantsTooltip":
    "The total number of participants on this study.",
  "sponsorOverview.completedSurveys": "Completed Surveys",
  "sponsorOverview.completedSurveysTooltip":
    "The total number of {epro} and {eclinro} surveys that have been completed on the study.",
  "sponsorOverview.missedSurveys": "Missed Surveys",
  "sponsorOverview.missedSurveysTooltip":
    "The total number of {epro} and {eclinro} surveys that have been missed on the study.",
  "sponsorOverview.updatedMessage": "Updated {timeAgo}",
  "sponsorOverview.compliance": "Compliance",
  "sponsorOverview.availableSurveys": "Available Surveys",
  "sponsorOverview.availableSurveysTooltip":
    "Available surveys include all surveys that can currently be completed by respondents.",
  "sponsorOverview.complianceTooltip":
    "Completed surveys are scheduled surveys that were successfully completed on time. Missed surveys are past their due date and have not yet been submitted. We do not include “As Needed” surveys in these metrics.",
  "sponsorOverview.complianceMissed": "Missed",
  "sponsorOverview.complianceCompleted": "Completed",
  "sponsorOverview.tableHeaderSite": "Site",
  "sponsorOverview.tableHeaderParticipant": "Participant",
  "sponsorOverview.tableHeaderCompliance": "Compliance",
  "sponsorOverview.tableHeaderPercentage": "Percentage",
  "sponsorOverview.tableHeaderTotal": "Total",
  "sponsorOverview.tableHeaderTotalAvailableSurveys": "Total Available Surveys",
  "sponsorOverview.tableHeaderAvailableLessThanOneWeek":
    "Available Less Than One Week",
  "sponsorOverview.tableHeaderAvailableMoreThanOneWeek":
    "Available More Than One Week",
  "sponsorOverview.tableCountOfTotal": "{count} <gray>of {total}</gray>",
  "sponsorOverview.tableNoSites": "There are no sites on this study.",
  "sponsorOverview.tableNoSurveys": "No surveys are currently available.",
  "sponsorOverview.tableNoParticipants":
    "There are no participants at this site.",
  "sponsorOverview.dataChange": "data change",
  "sponsorOverview.dataChanges": "data changes",
  "sponsorOverview.countDataChangesWaitingApproval":
    "{count} {dataChange} waiting approval.",
  "sponsorOverview.viewAll": "View All",
  "sponsorSites.siteHeader": "Site",
  "sponsorSites.countryHeader": "Country",
  "sponsorSites.siteNameHeader": "Site Name",
  "sponsorSites.siteStatus": "Site Status",
  "sponsorSites.versionStatusHeader": "Version Status",
  "sponsorSites.versionHeader": "Active Version",
  "sponsorSites.participantHeader": "Participants",
  "sponsorSites.eproComplianceHeader": "{epro} Compliance",
  "sponsorSites.eclinroComplianceHeader": "{eclinro} Compliance",
  "sponsorSites.statusActive": "Active",
  "sponsorSites.statusArchived": "Archived",
  "sponsorSites.statusLocking": "Locking",
  "sponsorSites.statusLocked": "Locked",
  "sponsorSites.statusUnlocked": "Unlocked",
  "sponsorSites.statusNotActive": "Not Active",
  "sponsorSites.versionStatusNoVersion": "No Version",
  "sponsorSites.versionStatusActive": "Active",
  "sponsorSites.versionStatusPending": "Pending",
  "sponsorSites.versionStatusPendingActivation": "Pending Initial Activation",
  "sponsorSites.versionStatusActivePendingUpdate":
    "Active (Pending New Version)",
  "sponsorSites.versionStatusActivePendingLanguages":
    "Active (Pending New Languages)",
  "sponsorSites.versionStatusActivePendingTranslations":
    "Active (Pending Translations Update)",
  "sponsorSites.noVersionText": "None",
  "sponsorSites.noSites": "No sites are associated with this study.",
  "sponsorSiteOverview.signaturesByDataType": "Signatures by Data Type",
  "sponsorSiteOverview.signaturesByDataTypeTooltip":
    "This chart displays all applied signatures, grouped by data type that require signature.",
  "sponsorSiteOverview.transcriptionsPercentage":
    "Transcriptions ({percentage}%)",
  "sponsorSiteOverview.sourceEproPercentage": "Source {epro} ({percentage}%)",
  "sponsorSiteOverview.sourceEclinroPercentage":
    "Source {eclinro} ({percentage}%)",
  "sponsorSiteOverview.all": "All",
  "sponsorSiteOverview.transcriptions": "Transcriptions",
  "sponsorSiteOverview.sourceEpro": "Source {epro}",
  "sponsorSiteOverview.sourceEclinro": "Source {eclinro}",
  "sponsorSiteOverview.participantsSigned": "Participants Signed",
  "sponsorSiteOverview.participantsSignedTooltip":
    "Number of participants with signatures applied to all required data.",
  "sponsorSiteOverview.participantsSignedOfTotal": "{signed} of {total}",
  "sponsorSiteOverview.pageTitle": "Site {siteNumber}",
  "sponsorSiteOverview.versionInformation": "Version Information",
  "sponsorSiteOverview.supportedLanguages": "Languages",
  "sponsorSiteOverview.supportedLanguagesTooltip":
    "The number of languages that are available to this site.",
  "sponsorSiteOverview.supportedLanguagesList":
    "Supported languages include: {languages}.",
  "sponsorSiteOverview.noVersion": "No Version",
  "sponsorSiteOverview.versionTooltip":
    "The current, active study collection version at this site.",
  "sponsorSiteOverview.versionStatusTooltip":
    "The status of the version at this site.",
  "sponsorSiteOverview.participantsTooltip":
    "The total number of participants at this site.",
  "sponsorSiteOverview.completedSurveysTooltip":
    "The total number of {epro} and {eclinro} surveys that were completed at this site.",
  "sponsorSiteOverview.noLastSurvey": "None",
  "sponsorStudyHome.studyHome": "Study Home",
  "studyHome.participant.tableActions": "Table Actions",
  "studyHome.participant.SHOW_COLUMNS": "SHOW COLUMNS",
  "studyHome.participant.signatureStatus": "Signature Status",
  "studyHome.participant.signatureApplied": "Signature Applied",
  "studyHome.participant.needsReview": "Needs Review",
  "studyHome.participant.notApplicable": "Not Applicable",
  "studyHome.participant.timepointParentLabel": "timepoint",
  "studyHome.participant.dayOfWeek": "dayOfWeek",
  "studyHome.participant.title": "Participant {participantNumber}",
  "studyHome.participant.active": "Active",
  "studyHome.participant.inactive": "Inactive",
  "studyHome.participant.updatedNow": "Updated now",
  "studyHome.participant.eventsTable.name": "Name",
  "studyHome.participant.eventsTable.date": "Date",
  "studyHome.participant.eventsTable.populatedBy": "Populated By",
  "studyHome.participant.eventsTable.populatedBy.system": "System",
  "studyHome.participant.eventsTable.populatedBy.user": "User",
  "studyHome.participant.surveyCompliance": "Survey Compliance",
  "studyHome.participant.scheduleView": "Schedule View",
  "studyHome.participant.tableView": "Table View",
  "studyHome.participant.survey": "Survey",
  "studyHome.participant.surveyStatus": "Survey Status",
  "studyHome.participant.eventName": "Event Name",
  "studyHome.participant.respondent": "Respondent",
  "studyHome.participant.date": "Date",
  "studyHome.participant.available": "Available",
  "studyHome.participant.completed": "Completed",
  "studyHome.participant.missed": "Missed",
  "studyHome.participant.transcribed": "Transcribed",
  "studyHome.participant.intentionallyLeftBlank": "Intentionally Left Blank",
  "studyHome.participant.completedLate": "Completed (Late)",
  "studyHome.participant.completedRemoved": "Completed (Removed)",
  "studyHome.participant.transcribedRemoved": "Transcribed (Removed)",
  "studyHome.participant.dataChanges.submitted": "Submitted",
  "studyHome.participant.dataChanges.approved": "Approved",
  "studyHome.participant.dataChanges.closed": "Closed",
  "studyHome.participant.participant": "Participant",
  "studyHome.participant.caregiver": "Caregiver",
  "studyHome.participant.caregiverWithRelationship":
    "Caregiver ({relationship})",
  "studyHome.participant.siteStaff": "Site Staff",
  "studyHome.participant.siteUser": "Site User",
  "studyHome.participant.noResults": "No Results",
  "studyHome.participant.theDateDependsOnTheSurveyStatus":
    "The date depends on the survey status:",
  "studyHome.participant.availableDateDescription":
    "Available: The datetime when the survey became available.",
  "studyHome.participant.completedDateDescription":
    "Completed: The datetime when the survey was completed.",
  "studyHome.participant.transcribedDateDescription":
    "Transcribed: The datetime when the assessment was completed.",
  "studyHome.participant.missedDateDescription":
    "Missed: The datetime when the survey was due.",
  "studyHome.participant.intentionallyLeftBlankDateDescription":
    "Intentionally Left Blank: The datetime when the site indicated they were intentionally leaving the survey blank.",
  "studyHome.participant.pleaseModifyOrClearTheFilters":
    "Please modify or clear the filters to see results.",
  "studyHome.participant.restricted": "Restricted",
  "studyHome.participant.selectPage": "Select Page",
  "studyHome.participant.close": "close",
  "studyHome.participant.dataTransferStatus": "Data Transfer Status: ",
  "studyHome.participant.dataTransferStatusDisabled": "Disabled",
  "studyHome.participant.dataTransferStatusRetrying": "Retrying",
  "studyHome.participant.dataTransferStatusFailure": "Failure",
  "studyHome.participant.dataTransferStatusPending": "Pending",
  "studyHome.participant.dataTransferStatusSuccess": "Success",
  "studyHome.paginationCountRange": "{low} - {high} of {total}",
  "studyHome.pageIndicator": "/ {pageCount}",
  "studyHome.zeroStatePageIndicator": "0 / 0",
  "studyHome.previousPage": "Previous Page",
  "studyHome.nextPage": "Next Page",
  "studyHome.participant.groupsTable.group": "Group",
  "studyHome.participant.groupsTable.selectedGroup": "Selected Group",
  "studyHome.participant.eventsTable.warningTooltip": "Outside Visit Window",
  "studyHome.participant.filters": "Filters",
  "studyHome.participant.details": "Details",
  "studyHome.participant.cancel": "Cancel",
  "studyHome.participant.apply": "Apply",
  "studyHome.participant.all": "All",
  "studyHome.participant.resetAllFilters": "Reset All Filters",
  "studyHome.participant.allFilters": "All Filters",
  "studyHome.participant.reset": "Reset",
  "studyHome.participant.clear": "Clear",
  "studyHome.participant.to": "to",
  "studyHome.participant.dateRange": "Date Range",
  "studyHome.participant.applyDateRange": "Apply Date Range",
  "studyHome.participant.dateRangeError":
    "The start date must be before the end date.",
  "studyHome.participant.dateRangeFutureError":
    "The date cannot be in the future.",
  "studyHome.participant.resetAll": "Reset All",
  "studyHome.participant.checkedAtDateTime": "Checked at {dateTime}",
  "studyHome.participant.requiredDataUnavailable": "Required Data Unavailable",
  "studyHome.participant.thisCriteriaCheckRequiresAdditionalInfo":
    "This criteria check requires additional information to run.",
  "studyHome.participant.COMPLETE": "Complete",
  "studyHome.participant.INCOMPLETE": "Incomplete",
  "studyHome.participant.CORRECT": "Correct",
  "studyHome.participant.INCORRECT": "Incorrect",
  "studyHome.participant.MEETS_REQUIREMENTS": "Meets Requirements",
  "studyHome.participant.DOES_NOT_MEET_REQUIREMENTS":
    "Does Not Meet Requirements",
  "studyHome.participant.PASS": "Pass",
  "studyHome.participant.FAIL": "Fail",
  "studyHome.participant.TRUE": "True",
  "studyHome.participant.FALSE": "False",
  "studyHome.participant.YES": "Yes",
  "studyHome.participant.NO": "No",
  "studyHome.participant.headerDelimiter": "•",
  "studyHome.participant.containsRestrictedDataTitle":
    "Contains Restricted Data",
  "studyHome.participant.containsRestrictedDataMessage":
    "Results from this Check Event contain restricted data.",
  "studyHome.participant.criteriaCheckIsRestrictedTitle":
    "This criteria check contains restricted data.",
  "studyHome.participant.criteriaCheckIsRestrictedMessage":
    "Only users with access to restricted data can view the results.",
  "studyHome.participant.dataEvaluationIsUnavailableTitle":
    "Data evaluation is unavailable.",
  "studyHome.participant.dataEvaluationIsUnavailableMessage":
    "This check event has been deactivated and cannot analyze additional participant data.",
  "studyHome.participant.didNotOccur": "Did Not Occur",
  "studyHome.dataChanges": "Data Changes",
  "studyHome.dataChanges.updatedNow": "Updated now",
  "studyHome.dataChanges.submittedRequests": "Submitted Requests",
  "studyHome.dataChanges.approvedRequests": "Approved Requests",
  "studyHome.dataChanges.completedChanges": "Completed Changes",
  "studyHome.dataChanges.rejectedRequests": "Rejected Requests",
  "studyHome.dataChanges.surveyName": "Survey Name",
  "studyHome.dataChanges.restricted": "Restricted",
  "studyHome.dataChanges.windowOfChange": "Window of Change",
  "studyHome.dataChanges.windowOfChange.LESS_THAN_ONE_DAY": "< 1 day",
  "studyHome.dataChanges.windowOfChange.GREATER_THAN_ONE_DAY": "> 1 day",
  "studyHome.dataChanges.windowOfChange.GREATER_THAN_ONE_WEEK": "> 1 week",
  "studyHome.dataChanges.windowOfChange.GREATER_THAN_ONE_MONTH": "> 1 month",
  "studyHome.dataChanges.windowOfChange.GREATER_THAN_ONE_YEAR": "> 1 year",
  "studyHome.dataChanges.windowOfChangeWithPercentage.LESS_THAN_ONE_DAY":
    "< 1 day ({percentage}%)",
  "studyHome.dataChanges.windowOfChangeWithPercentage.GREATER_THAN_ONE_DAY":
    "> 1 day ({percentage}%)",
  "studyHome.dataChanges.windowOfChangeWithPercentage.GREATER_THAN_ONE_WEEK":
    "> 1 week ({percentage}%)",
  "studyHome.dataChanges.windowOfChangeWithPercentage.GREATER_THAN_ONE_MONTH":
    "> 1 month ({percentage}%)",
  "studyHome.dataChanges.windowOfChangeWithPercentage.GREATER_THAN_ONE_YEAR":
    "> 1 year ({percentage}%)",
  "studyHome.dataChanges.surveyTypeDonutLabel": "{type} ({percentage}%)",
  "studyHome.dataChanges.daysSinceApproved": "Days Since Approved",
  "studyHome.dataChanges.dateApproved": "Date Approved",
  "studyHome.dataChanges.daysSinceSubmitted": "Days Since Submitted",
  "studyHome.dataChanges.dateSubmitted": "Date Submitted",
  "studyHome.dataChanges.dateRejected": "Date Rejected",
  "studyHome.dataChanges.view": "View",
  "studyHome.dataChanges.site": "Site",
  "studyHome.dataChanges.participant": "Participant",
  "studyHome.dataChanges.dateCompleted": "Date Completed",
  "studyHome.dataChanges.status": "Status",
  "studyHome.dataChanges.others": "Others",
  "studyHome.dataChanges.actions": "Actions",
  "studyHome.dataChanges.noRequests": "No requests to display.",
  "studyHome.dataChanges.noDataToDisplay": "There is no data to display",
  "studyHome.dataChanges.noRequestsDescription":
    "Future requests will be displayed here.",
  "studyHome.dataChangeRequestDrawer.totalChangesNumber":
    "Total Changes: {number}",
  "studyHome.dataChanges.tile.lagWindow.title": "Data Change Lag By Window",
  "studyHome.dataChanges.tile.lagWindow.tooltip":
    "The number of days between when the data was collected and the data change was completed.",
  "studyHome.dataChanges.tile.site.title": "Data Changes by Site",
  "studyHome.dataChanges.tile.site.tooltip":
    "The number of data changes completed at each site.",
  "studyHome.dataChanges.tile.survey.title": "Data Changes by Survey",
  "studyHome.dataChanges.tile.survey.tooltip":
    "The number of data changes completed on each survey.",
  "studyHome.dataChanges.tile.surveyType.title": "Data Changes by Survey Type",
  "studyHome.dataChanges.tile.surveyType.tooltip":
    "The number of data changes on each survey type.",
  "studyHome.dataChangeRequestDrawer.header": "Data Change Request",
  "studyHome.dataChangeRequestDrawer.requestOpened": "Request opened",
  "studyHome.dataChangeRequestDrawer.messageHidden": "Hidden",
  "studyHome.dataChangeRequestDrawer.statusDisplayValues.approved": "Approved",
  "studyHome.dataChangeRequestDrawer.statusDisplayValues.canceled": "Canceled",
  "studyHome.dataChangeRequestDrawer.statusDisplayValues.completed":
    "Completed",
  "studyHome.dataChangeRequestDrawer.statusDisplayValues.rejected": "Rejected",
  "studyHome.dataChangeRequestDrawer.statusDisplayValues.submitted":
    "Submitted",
  "studyHome.dataChangeRequestDrawer.terminalStatusLabels.approved":
    "Waiting on data change",
  "studyHome.dataChangeRequestDrawer.terminalStatusLabels.canceled":
    "Request closed",
  "studyHome.dataChangeRequestDrawer.terminalStatusLabels.completed":
    "Request closed",
  "studyHome.dataChangeRequestDrawer.terminalStatusLabels.rejected":
    "Request closed",
  "studyHome.dataChangeRequestDrawer.terminalStatusLabels.submitted":
    "Waiting on response",
  "studyHome.dataChangeRequestDrawer.status": "Status",
  "studyHome.dataChangeRequestDrawer.participant": "Participant",
  "studyHome.dataChangeRequestDrawer.event": "Event",
  "studyHome.dataChangeRequestDrawer.survey": "Survey",
  "studyHome.dataChangeRequestDrawer.message": "Message",
  "studyHome.dataChangeRequestDrawer.details": "Details",
  "studyHome.dataChangeRequestDrawer.changeMade": "change made",
  "studyHome.dataChangeRequestDrawer.changesMade": "changes made",
  "studyHome.dataChangeRequestDrawer.description":
    "{siteName} requested to change data for {participantNumber} on {surveyName}.",
  "studyHome.dataChangeRequestDrawer.permissionError":
    "You do not have permission to approve or reject this data change request.",
  "studyHome.dataChangeRequestDrawer.restrictedDataError":
    "This survey contains restricted data.",
  "studyHome.dataChangeRequestDrawer.approveDisclaimer":
    "If you approve this request, the site is notified they can edit the survey responses.",
  "studyHome.dataChangeRequestDrawer.approve": "approve",
  "studyHome.dataChangeRequestDrawer.approveRequest": "Approve Request",
  "studyHome.dataChangeRequestDrawer.reasonForRejecting":
    "Reason for Rejecting",
  "studyHome.dataChangeRequestDrawer.reject": "reject",
  "studyHome.dataChangeRequestDrawer.rejectRequest": "Reject Request",
  "studyHome.dataChangeRequestDrawer.addDetails": "Add Details",
  "studyHome.dataChangeRequestDrawer.sendReminder": "Send Reminder to Site",
  "studyHome.dataChangeRequestDrawer.reminderSent": "Reminder Sent",
  "studyHome.dataChangeRequestDrawer.youCanRemindTheSiteAgainAtDatetime":
    "You can remind the site again on {datetime}.",
  "studyHome.dataChangeRequestDrawer.or": "or",
  "studyHome.dataChangeRequestDrawer.select": "Select",
  "studyHome.dataChangeRequestDrawer.outsideRecallPeriod":
    "Outside of Reasonable Recall Period",
  "studyHome.dataChangeRequestDrawer.other": "Other",
  "studyHome.dataChangeRequestDrawer.reasonRequired": "Please select a reason",
  "studyHome.dataChangeRequestDrawer.messageRequired": "Details are required",
  "studyHome.dataChangeRequestDrawer.conflictTitle":
    "We cannot {verb} this request",
  "studyHome.dataChangeRequestDrawer.conflictMessage":
    "This data change request has changed status. Please refresh and try again.",
  "studyHome.dataChangeRequestDrawer.conflictButton": "Refresh Page",
  "studyHome.dataChangeRequestDrawer.fullName": "{firstName} {lastName}",
  "studyHome.at": "at",
  "studyHome.compliance.filters.events": "Events",
  "studyHome.compliance.filters.surveys": "Surveys",
  "studyHome.compliance.filters.countryIds.all": "All Countries",
  "studyHome.compliance.filters.siteIds.all": "All Sites",
  "studyHome.compliance.filters.participantIds.all": "All Participants",
  "studyHome.compliance.filters.eventIds.all": "All Events",
  "studyHome.compliance.filters.surveyIds.all": "All Surveys",
  "studyHome.compliance.filters.xMore": "+{count} more",
  "studyHome.compliance.filters.close": "Close",
  "studyHome.compliance.filters.filterData": "Filter Data",
  "studyHome.compliance.filters.resetAll": "Reset All",
  "studyHome.compliance.filters.apply": "Apply",
  "studyHome.compliance.filters.searchByCountry": "Search by country",
  "studyHome.compliance.filters.searchByCountryOrSite":
    "Search by country or site",
  "studyHome.compliance.filters.bySite": "By Site",
  "studyHome.compliance.filters.byGroup": "By Group",
  "studyHome.compliance.filters.searchBySiteOrParticipant":
    "Search by site or participant",
  "studyHome.compliance.filters.searchByGroupOrParticipant":
    "Search by group or participant",
  "studyHome.compliance.summary": "Summary",
  "studyHome.compliance.trends": "Trends",
  "studyHome.compliance.trends.last6Months": "Last 6 Months",
  "studyHome.compliance.trends.last2Years": "Last 2 Years",
  "studyHome.compliance.dateRange": "Date Range",
  "studyHome.compliance.sortBy": "Sort By",
  "studyHome.compliance.percentage": "{percentage}%",
  "studyHome.compliance.applyAsFilter": "Apply As Filter",
  "studyHome.compliance.noDataToDisplay": "There is no data to display",
  "studyHome.compliance.loadingData": "Loading your data...",
  "studyHome.compliance.noResultsTitle": "No Results to Display",
  "studyHome.compliance.noDataIsAvailable": "No data is currently available.",
  "studyHome.compliance.noResultsSubtitle":
    "Your current filters returned no data. Please adjust your criteria or reset all filters to continue.",
  "studyHome.compliance.datasetTooLarge": "Dataset Too Large",
  "studyHome.compliance.datasetTooLargeSubtitle":
    "This view will return more than 1,000 results. Please add or adjust the criteria to continue.",
  "studyHome.compliance.filters.addFilters": "Add Filters",
  "studyHome.compliance.filters.resetAllFilters": "Reset All Filters",
  "studyHome.compliance": "Compliance",
  "studyHome.compliance.last7Days": "Last 7 Days",
  "studyHome.compliance.allTime": "All Time",
  "studyHome.compliance.last30Days": "Last 30 Days",
  "studyHome.compliance.last90Days": "Last 90 Days",
  "studyHome.compliance.week": "Week",
  "studyHome.compliance.month": "Month",
  "studyHome.compliance.weeks": "Weeks",
  "studyHome.compliance.months": "Months",
  "studyHome.compliance.numberOfIntervalBelowThreshold":
    "Number of {interval} Below Threshold",
  "studyHome.compliance.latestIntervalCompliance":
    "Latest {interval} Compliance",
  "studyHome.compliance.changeFromPreviousInterval":
    "Change from Previous {interval}",
  "compliance.chart.thousandsValue": "{count}k",
  "compliance.scatterplot.xAxisLabel": "Total Number of Surveys",
  "compliance.scatterplot.yAxisLabel": "Compliance Percentage (%)",
  "compliance.scatterplot.selectedCount": "{count} Selected",
  "compliance.scatterplot.surveys.single": "1 survey",
  "compliance.scatterplot.surveys.plural": "{count} surveys",
  "compliance.scatterplot.applyAsFilter": "Apply as Filter",
  "compliance.scatterplot.viewSites": "View Sites",
  "compliance.scatterplot.viewParticipants": "View Participants",
  "compliance.scatterplot.threshold": "Threshold: {threshold}%",
  "compliance.scatterplot.zoomIn": "Zoom In",
  "compliance.scatterplot.resetZoom": "Reset Zoom",
  "compliance.trend.notFinal":
    "Compliance values are not final until the {period} is complete.",
  "complianceViews.trend.week": "week",
  "complianceViews.trend.month": "month",
  "complianceViews.trend.dateRange": "{startDate} - {endDate}",
  "complianceViews.legend.totalSurveys": "Total Surveys",
  "complianceViews.legend.threshold": "Threshold",
  "complianceViews.legend.below": "{dimension} (Below)",
  "complianceViews.legend.above": "{dimension} (Above)",
  "complianceViews.trendCards.noData": "--",
  "complianceViews.trendCards.noChange": "No Change",
  "complianceViews.trendCards.streakTitle": "Last {count} {unit}",
  "complianceViews.trendCards.percentageSubtitle": "vs. previous {unit}",
  "complianceViews.trendCards.percentageTitle": "{count}%",
  "complianceViews.trendCards.week": "week",
  "complianceViews.trendCards.weeks": "weeks",
  "complianceViews.trendCards.month": "month",
  "complianceViews.trendCards.months": "months",
  "complianceViews.trendCards.aboveBelow": "above/below threshold",
  "complianceViews.trendCards.above": "above threshold",
  "complianceViews.trendCards.below": "below threshold",
  "complianceViews.heading": "Compliance Views",
  "complianceViews.studyThreshold.title": "Study Threshold",
  "complianceViews.studyThreshold.description":
    "Enter the target percentage for compliance.",
  "complianceViews.studyThreshold.setThreshold": "Set Threshold",
  "complianceViews.studyThreshold.updating": "Updating",
  "complianceViews.studyThreshold.success":
    "The study threshold was updated successfully.",
  "complianceViews.sideNav": "Compliance Views",
  "manageDataChanges.composite": "Composite",
  "manageDataChanges.headlineDataChange": "Manage {type} Survey Data Changes",
  "manageDataChanges.headlineTranscription":
    "Manage {type} Survey Transcription",
  "manageDataChanges.allowDataChangesForDataChange":
    "Allow Data Changes for {type} Surveys",
  "manageDataChanges.allowDataChangesForTranscription":
    "Allow Transcription for {type} Surveys",
  "manageDataChanges.dataChangeSubmissionWindow":
    "Data Change Submission Window",
  "manageDataChanges.daysAfterSurveyComplete": "Days After Survey is Complete",
  "manageDataChanges.leaveEmpty": "Leave empty for no time limit.",
  "studyDeployments.selectSites": "Select Sites",
  "studyDeployments.site": "Site",
  "studyDeployments.noChange": "No Change",
  "studyDeployments.showMore": "Show More",
  "studyDeployments.showLess": "Show Less",
  "studyDeployments.activateForSiteWhenDeployed":
    "Activate for Site When Deployed",
  "studyDeployments.versionIsAvailableInRegions":
    "Version {major}.{minor} is available in {smaller} of {max} regions",
  "studyDeployments.versionIsAvailable": "Version {major}.{minor} is available",
  "studyDeployments.ap": "Asia-Pacific",
  "studyDeployments.eu": "EU",
  "studyDeployments.us": "US",
  "studyDeployments.deploying...": "{major}.{minor} Deploying...",
  "studyDeployments.versionNumber": "Version {major}.{minor}",
  "studyDeployments.makeChanges": "Make Changes",
  "studyDeployments.manageSite": "Manage Site",
  "studyDeployments.reviewChanges": "Review Changes",
  "studyDeployments.selectVersion": "Select Version",
  "studyDeployments.notYetAvailable": "Not Yet Available",
  "studyDeployments.active": "Active",
  "studyDeployments.latest": "Latest",
  "studyDeployments.site:SiteNumber": "Site: {siteNumber}",
  "studyDeployments.next": "Next",
  "studyDeployments.selectedLanguages": "Selected Languages",
  "studyDeployments.deploy": "Deploy",
  "studyDeployments.activateForSite": "Activate for Site",
  "studyDeployments.activateForSiteTooltip":
    "Disable this option to keep the current version until the site reviews and activates the latest version themselves.",
  "studyDeployments.previousVersion": "Previous Version",
  "studyDeployments.newVersion": "New Version",
  "studyDeployments.activeVersion": "Active Version",
  "studyDeployments.previousLanguages": "Previous Languages",
  "studyDeployments.newLanguages": "New Languages",
  "studyDeployments.activeLanguages": "Active Languages",
  "studyDeployments.languageRemoved": "{language} Removed",
  "studyDeployments.languageAdded": "{language} Added",
  "studyDeployments.forceActivateBannerMessage":
    "Version {major}.{minor} is deployed and pending activation. <buttonLink>Force Activate</buttonLink>",
  "studyDeployments.formattedStudyVersion": "{major}.{minor}",
  "studyDeployments.selectSite": "Select Site {siteName}",
  "studyDeployments.selectSitesInCountry": "Select all Sites in {country}",
  "studyDeployments.selectAllSites": "Select All Sites",
  "studyDeployments.editLanguages": "Edit Languages",
  "studyDeployments.editLanguagesTooltip":
    "You can only edit languages when you select sites from a single country.",
  "studyDeployments.noLanguages": "No Languages",
  "studyDeployments.edit": "Edit",
  "studyDeployments.youMustApproveACollection":
    "You must approve a collection before you can assign languages to a country. {viewCollectionsLink}",
  "studyDeployments.viewCollections": "View Collections",
  "studyDeployments.pendingActivation": "Pending Activation: {major}.{minor}",
  "studyDeployments.newVersionAvailable": "New Version Available",
  "studyDeployments.noVersionDeployed": "No Version Deployed",
  "studyDeployments.noSites": "No Sites",
  "studyDeployments.addSitesInVault":
    "Add sites in {vault} to manage versions and languages.",
  "studyDeployments.languageCountSingle": `1 Language`,
  "studyDeployments.languageCountPlural": `{count} Languages`,
  "studyDeployments.manageCountryLanguages": "Manage Country Languages",
  "studyDeployments.close": "Close",
  "studyDeployments.clear": "Clear",
  "studyDeployments.noResults": "No Results",
  "studyDeployments.updateYourSearchAndTryAgain":
    "Update your search and try again.",
  "studyDeployments.selectAll": "Select All",
  "studyDeployments.deselectAll": "Deselect All",
  "studyDeployments.selectLanguages": "Select Languages",
  "studyDeployments.searchLanguages": "Search Languages",
  "studyDeployments.cancel": "Cancel",
  "studyDeployments.save": "Save",
  "studyDeployments.cannotRemoveLanguage":
    "You cannot remove a language while it is in use at the site level.",
  "studyDeployments.applySelectedLanguagesToTheSitesWithinThisCountry":
    "Apply selected languages to the sites within this country",
  "studyDeployments.deployments": "Deployments",
  "studyDeployments.deploymentsMessage":
    "You may control the version and languages assigned to each country and/or site. You may also accept the changes on the site's behalf.",
  "studyDeployments.deploymentsMessageDisabled":
    "Deployments are currently unavailable. Please try again soon.",
  "studyDeployments.noCountriesAndSites": "No Countries and Sites",
  "studyDeployments.noCountriesAndSitesMessage":
    "Add countries and sites in {vault} to manage versions and languages.",
  "studyDeployments.bulkDeploy": "Bulk Deploy",
  "studyDeployments.sitesHeader": "Sites",
  "studyDeployments.languagesHeader": "Languages",
  "studyDeployments.activeVersionHeader": "Active Version",
  "studyDataChanges.type": "Type",
  "studyDataChanges.survey": "Survey",
  "studyDataChanges.dataChanges": "Data Changes",
  "studyDataChanges.surveyDataChanges": "Survey Data Changes",
  "studyDataChanges.surveyDataChangesDescription":
    "This setting allows you to configure whether a site can edit survey data after submission. You can control this ability by type of survey and by individual surveys within each type. You can also set a time limit after submission or disable the ability to edit data completely.",
  "studyDataChanges.noSurveysTitle": "No Surveys Available",
  "studyDataChanges.noSurveysDescription":
    "You can only edit these settings after surveys are added to a collection.",
  "studyDataChanges.countDays": "Data Change Submission Window: {count} Days",
  "studyDataChanges.on": "On",
  "studyDataChanges.off": "Off",
  "studyDataChanges.cancel": "Cancel",
  "studyDataChanges.saveChanges": "Save Changes",
  "studyDataChanges.allowSiteUsersToChangeData":
    "Allow Site Users to Change Data in Surveys",
  "studyDataChanges.defaultDataChangeSubmissionWindow":
    "Default Data Change Submission Window",
  "studyDataChanges.days": "Days",
  "studyDataChanges.daysRangeError": "Window must be between 1 and 365 days.",
  "studyDataChanges.daysRequiredError": "Required",
  "studyDataChanges.editDisabledMessage":
    "Locked for {uat}. Edit in parent study to apply changes here.",
  "studyDataChanges.removeSurveys": "Remove Surveys",
  "studyDataChanges.removeSurveysDescription":
    "This configuration determines whether a site can remove surveys collected in error. When surveys are removed, all data is available on the audit trail, and they can be restored.",
  "studyDataChanges.allowSiteUsersToRemoveSurveys":
    "Allow Site Users to Remove Surveys",
  "studyDataChanges.transcriptions": "Transcriptions",
  "studyDataChanges.transcribeSurveys": "Transcribe Surveys",
  "studyDataChanges.transcriptionsDescription":
    "This setting enables sites to transcribe data that is recorded elsewhere.",
  "studyDataChanges.allowSurveysToBeTranscribed":
    "Allow Surveys to Be Transcribed",
  "inPersonAccess.heading": "In-Person Access",
  "inPersonAccess.description":
    "This setting determines whether participants and caregivers can respond to surveys in person without logging into a participant account. When turned on, this option can be overridden for specific countries or sites in {vault}.",
  "inPersonAccess.note":
    "<b>Important:</b> Disabling the in-person flow setting does not stop participants or caregivers from completing assessments in clinic. However, it disables the streamlined in-person workflow that does not require a participant account.",
  "inPersonAccess.switchLabel": "Enable In-Person Flow",
  "inPersonAccess.accessType": "Access Type",
  "inPersonAccess.streamlined": "Streamlined",
  "inPersonAccess.streamlinedDescription":
    "Participants verify their identity by entering year of birth on file or verifying participant ID.",
  "inPersonAccess.passwordAuthenticated": "Password-authenticated",
  "inPersonAccess.passwordAuthenticatedDescription":
    "Participants create a password to access the in-person session. Participants with {myveeva} accounts use their existing password. Password recovery is supported.",
  "eproModule.error": "Error",
  "eproModule.discardChanges": "Discard Changes",
  "eproModule.continueAndSave": "Continue and Save",
  "eproModule.exportWarningMessage":
    "You made name or answer configuration changes that may cause mapping discrepancies for exports. Consider using export mappings instead of changing the survey. Go to <medium>Manage Mapping</medium> in the survey editor to update mappings.",
  "eproModule.exportWarning": "Export Warning",
  "eproModule.uploadExportMapping.browseOrDragAndDrop":
    "<link>Click to browse</link> or drag and drop a file",
  "eproModule.uploadExportMapping.browse": "Browse",
  "eproModule.uploadExportMapping.fileFormatsAccepted":
    "File Formats Accepted:",
  "eproModule.uploadExportMapping.maxFileSizeLabel": "Max File Size:",
  "eproModule.numberMB": "{number} MB",
  "eproModule.uploading": "Uploading...",
  "eproModule.mappingUploadedSuccessfully":
    "Mapping file uploaded successfully.",
  "eproModule.exportMappingUploadError.invalidFileCount":
    "Only one file can be uploaded at a time.",
  "eproModule.exportMappingUploadError.invalidFileType":
    "Upload must be a .JSON file.",
  "eproModule.exportMappingUploadError.invalidFileSize":
    "File size cannot exceed {maxFileSize}.",
  "eproModule.exportMappingUploadError.INVALID_JSON_FORMAT":
    "The file does not contain valid JSON.",
  "eproModule.exportMappingUploadError.INVALID_SURVEY_NAME":
    "The survey name in the JSON does not match this survey.",
  "eproModule.exportMappingUploadError.INVALID_BLOCK_NAME":
    "The mapping references blocks that have never been included in this survey.",
  "eproModule.exportMappingUploadError.INVALID_ANSWER_NAME":
    "The mapping references answers that have never been included in this survey.",
  "eproModule.exportMappingUploadError.INVALID_TYPE":
    "The mapping includes values that are not strings.",
  "eproModule.importNewMappingFile": "Import New Mapping File",
  "eproModule.exportCurrentMapping": "Export Current Mapping",
  "eproModule.importNewMappingDisabledTooltip":
    "You must save the survey before you can import new mapping.",
  "eproModule.exportMappingDisabledTooltip":
    "You must save the survey before you can export mapping.",
  "eproModule.manageMappingDisabledTooltip":
    "You must save the survey before you can manage mapping.",
  "eproModule.manageMappingDescription":
    "We recommend mapping your export data to align with SDTM requirements. Although mapping is not required for the survey, using it will improve the quality and consistency of your exports.",
  "eproModule.manageMapping": "Manage Mapping",
  "eproModule.itemCount": "{count} items",
  "eproModule.reduceCharacterCount": "Reduce Character Count",
  "eproModule.characterCountLimits": "Character Count Limits:",
  "eproModule.questionHeadingLimit": "Question headings <= 40 characters",
  "eproModule.blockNameLimit": "Block names <= 8 characters",
  "eproModule.blockAnswerLimit": "Answer labels <= 200 characters",
  "eproModule.removeHTMLElements": "Remove HTML Elements",
  "eproModule.removeNonASCIICharacters": "Remove Non-ASCII Characters",
  "eproModule.mappingSuggestions": "Mapping Suggestions",
  "eproModule.mappingSuggestionsTooltip":
    "You can provide mappings to align your data with SDTM requirements for better consistency and compliance.",
  "eproModule.languageStatus": "Language Status",
  "eproModule.useUatCode": "Use {uat} Code",
  "eproModule.enterCode": "Enter Code",
  "eproModule.enterUatCode": "Enter {uat} Code",
  "eproModule.enterUatCodeDescription":
    "Once you connect a collection using a {uat} code, you won't be able to make any manual changes or create new versions.",
  "eproModule.connect": "Connect",
  "eproModule.thisCodeHasAlreadyBeenUsed": "This code has already been used.",
  "eproModule.youHaveSuccessfullyConnectedTheStudy":
    "You have successfully connected the study.",
  "eproModule.somethingWentWrongPleaseTryAgain":
    "Something went wrong. Please try again.",
  "eproModule.studyIsConnectedToUat":
    "You can't create a new <br></br> version because this study is <br></br> connected with a {uat} code.",
  "eproModule.backToDraft": "Back to Draft",
  "eproModule.deactivate": "Deactivate",
  "eproModule.details": "Details",
  "eproModule.access": "Access",
  "eproModule.additionalInformation": "Additional Information",
  "eproModule.inactivate": "Inactivate",
  "eproModule.continue": "Continue",
  "eproModule.confirm": "Confirm",
  "eproModule.confirmGroupTypeRemove": 'Confirm the removal of "{groupType}"?',
  "eproModule.includeInVersion": "Include In Version",
  "eproModule.includeInVersionTooltip":
    "Languages included in the Collection Version require complete translations.",
  "eproModule.translationsIncomplete":
    "<button>{count} item(s)</button> with incomplete translations",
  "eproModule.type": "Type",
  "eproModule.allItemsTranslated": "All items translated",
  "eproModule.protocolExpectedDate": "Protocol Expected Date",
  "eproModule.protocolExpectedDateDescription":
    "Relate this event to an anchor event. When sites enter a datetime for the anchor event, a protocol expected date will be calculated for this event.",
  "eproModule.anchorEvent": "Anchor Event",
  "eproModule.anchorEventDisplay": "{eventName} ({sequence})",
  "eproModule.anchorEventPlaceholder": "Select one",
  "eproModule.anchorEventWarning":
    "Updating the anchor event updates protocol expected dates for all connected anchor events.",
  "eproModule.anchorEventGroupError":
    "Select an anchor event that includes all groups from this event.",
  "eproModule.eventTriggeredGroupError":
    "The datetime cannot be set to Populate for Sites when Enable Event-Triggered Group Assignment is selected. To save this event, set the datetime population to Display for Sites or disable Event-Triggered Group Assignment.",
  "eproModule.invalidConfiguration": "Invalid Configuration",
  "eproModule.groupAnchorEventError":
    "Related groups must include all groups on events that have this event as an anchor event.",
  "eproModule.anchorEventCycleError":
    "Select an anchor event that starts before this event.",
  "eproModule.api": "API",
  "eproModule.sites": "Sites",
  "eproModule.rule": "Rule",
  "eproModule.apiDisabledSubtext": "Contact {veeva} to enable this option",
  "eproModule.apiDisabledTooltipText":
    "Contact {veeva} to enable API connections for this study.",
  "eproModule.apiConnectionWarningTitle": "API Connection Warning",
  "eproModule.eventsApiConnectionWarningMessage":
    "Editing the event name may break API field mapping for this Event. Only change it if the connecting system also changes its API configuration.",
  "eproModule.groupTypeApiConnectionWarningMessage":
    "Editing the group type name may break API field mapping for this Group Type and associated Groups. Only change it if the connecting system also changes its API configuration.",
  "eproModule.groupNameApiConnectionWarningMessage":
    "Editing the group name may break API field mapping for this Group. Only change it if the connecting system also changes its API configuration.",
  "eproModule.availableWhen": "Available When",
  "eproModule.always": "Always",
  "eproModule.whenCriteriaCheckIsPassed": "When Criteria Check Is Passed",
  "eproModule.afterPreviousEvent": "After Previous Event",
  "eproModule.populatedBy": "Populated By",
  "eproModule.populatedByTooltip":
    "Select the source that populates the event datetime: a site user, a rule, or an external API.",
  "eproModule.outsideDataTooltip":
    "The event name is populated by API. Unlock the field to edit the name.",
  "eproModule.APPROVED": "Approved",
  "eproModule.DELETED": "Deleted",
  "eproModule.DRAFT": "Draft",
  "eproModule.NO": "No",
  "eproModule.NOT_APPLICABLE": "N/A",
  "eproModule.PREPARING_UAT": "Preparing {uat}",
  "eproModule.SUPERSEDED": "Superseded",
  "eproModule.REVERTED": "Reverted",
  "eproModule.UAT_IN_PROGRESS": "{uat} In Progress",
  "eproModule.UAT_PASSED": "{uat} Passed",
  "eproModule.YES": "Yes",
  "eproModule.aDraftVersionAlreadyExists":
    "A DRAFT version <br></br> already exists",
  "eproModule.actions": "Actions",
  "eproModule.surveyActions": "Survey Actions",
  "eproModule.add": "Add",
  "eproModule.addEvent": "Add Event",
  "eproModule.addFromLibrary": "Add From Library",
  "eproModule.addGroup": "Add Group",
  "eproModule.reorderItems": "Reorder Items",
  "eproModule.ordering": "Ordering",
  "eproModule.reorderGroupTypes": "Reorder Group Types",
  "eproModule.reorderGroups": "Reorder Groups",
  "eproModule.addGroupType": "Add Group Type",
  "eproModule.addGroupTypeWarning":
    "Adding a Type in a new version may require site staff to modify each existing participant.",
  "eproModule.groupTypeDescription":
    "Group types are used to organize groups that participants are assigned to. For example, if you want to assign participants to groups based on their age range, you can add Age Range as the group type. Then under the Age Range group type, you can add the groups “Youth” and “Adult.”",
  "eproModule.triggerAssignmentDescription":
    "If participants should only be assigned to this group type at a specific event, go to the event in the <semibold>Events</semibold> tab to enable group assignment.",
  "eproModule.triggerAssignmentAtEvent": "Trigger Assignment At Event",
  "eproModule.newGroupType": "New Group Type",
  "eproModule.groupTypeLabel": "Group Type Label",
  "eproModule.groupTypeLabelDescription": "Displayed to site staff.",
  "eproModule.groupTypeName": "Group Type Name",
  "eproModule.groupTypeNameDescription":
    "Used to identify the group type in configuration and does not appear to site staff.",
  "eproModule.groupPopulatedByTooltip":
    "Select the source that populates the Group Type: a site user, or a rule.",
  "eproModule.groupTypeNameLockedTooltip":
    "The group type name is populated by API. Unlock the field to edit the name.",
  "eproModule.groupPopulatedByTriggeringEvent":
    "This group is populated by a triggering event. To edit this field, you must remove the group from the triggering event.",
  "eproModule.descriptionOrPrompt": "Description or Prompt",
  "eproModule.promptDescription":
    "Displays as additional information or prompt to site staff when they assign a participant to a group type.",
  "eproModule.cannotDeleteGroupTypeNoGroups":
    "You cannot remove a Group Type that has Groups.",
  "eproModule.cannotDeleteGroupTypeEventTriggered":
    "You cannot remove a Group Type that is configured with Event-Triggered Group Assignment.",
  "eproModule.removeGroupType": "Remove Group Type?",
  "eproModule.removeGroupTypeDescription":
    "Once removed, you cannot create groups in this group type.",
  "eproModule.editGroupType": "Edit Group Type",
  "eproModule.groupType": "Group Type",
  "eproModule.groupSpecificEvents": "Group-Specific Events",
  "eproModule.groupSpecificEventsDescription":
    "If participants in this group should receive a subset of events for the study, go to the <semibold>Events</semibold> tab to update Applicable Groups for events.",
  "eproModule.addImage": "Add Image",
  "eproModule.addImageDescription":
    "Upload an image or browse the library for one to add to your survey.",
  "eproModule.addLanguageHelp":
    "The languages below are supported by {myveevaforpatients}. If you need another language, please contact {veeva} support.",
  "eproModule.addLanguages": "Add Languages",
  "eproModule.noResultsHeading": "No Results",
  "eproModule.noResultsDescription": "Update your search and try again.",
  "eproModule.missingLanguageQuestion":
    "Missing a language? Add study languages in the <studySettingsLink>Study Settings</studySettingsLink> tab in order to add them to your collection.",
  "eproModule.addStudyDetailsExplanation":
    "These details will personalize your study's appearance in the {myveevaforpatients} application.",
  "eproModule.addSurvey": "Add Survey",
  "eproModule.addSurveys": "Add Surveys",
  "eproModule.all": "All",
  "eproModule.allActions": "All Actions",
  "eproModule.allLanguageActions": "All Language Actions",
  "eproModule.allGroups": "All Groups",
  "eproModule.allGroupTypes": "All Group Types",
  "eproModule.approve": "Approve",
  "eproModule.approveModalAfterFirst":
    "Approve this version to send it to sites for review and activation. Summarize the changes introduced since the last approved version below.",
  "eproModule.approveModalFirst":
    "Approve this version to enable sites to begin using {ecoa} for this study. Summarize what is included in the initial version below.",
  "eproModule.approveModalWithLanguages":
    "Sites connected to this study who support {languages} will receive this new version for review and approval.",
  "eproModule.approveVersion": "Approve Version {majorVersion}.{minorVersion}",
  "eproModule.approvedOn": "Approved On",
  "eproModule.activeOn": "Active On",
  "eproModule.numSitesSingle": "1 site",
  "eproModule.numSitesPlural": "{count} sites",
  "eproModule.asNeededDisplayLabel": "As-Needed Display Label",
  "eproModule.asNeededDisplayLabelTooltip": `<b>As-Needed Display Label</b> appears on the Tasks page if the survey has an as-needed schedule. You can use this to instruct a participant when to submit this type of survey (such as "Log Drug Intake").`,
  "eproModule.automaticDatetimePopulation": "Automatic Datetime Population",
  "eproModule.automaticDatetimePopulationTooltip":
    "Display for Sites will show a protocol expected date for the event to site users. Populate for Sites will automatically populate the event's datetime with the protocol expected date.",
  "eproModule.backToStudy": "Back to study",
  "eproModule.browse": "Browse",
  "eproModule.back": "Back",
  "eproModule.cancel": "Cancel",
  "eproModule.apply": "Apply",
  "eproModule.caregiver": "Caregiver",
  "eproModule.chooseFileError":
    "Sorry, that file doesn't meet our requirements.<br></br>Please resize or reformat the file and try again.",
  "eproModule.chooseGroupType": "Choose a Type",
  "eproModule.reset": "Reset",
  "eproModule.clear": "Clear",
  "eproModule.clearAnchorTitle": "Remove Anchor Event",
  "eproModule.open": "Open",
  "eproModule.close": "Close",
  "eproModule.closeDialog": "Close Dialog",
  "eproModule.collection": "Collection",
  "eproModule.collections": "Collection Versions",
  "eproModule.exports": "Exports",
  "eproModule.daysBefore": "Days Before",
  "eproModule.daysAfter": "Days After",
  "eproModule.defaultEventTime": "Default Event Time",
  "eproModule.displayForSites": "Display for Sites",
  "eproModule.populateForSites": "Populate for Sites",
  "eproModule.schedulingOptions": "Scheduling Options",
  "eproModule.applicableGroups": "Applicable Groups",
  "eproModule.enableEventTriggeredGroupAssignment":
    "Enable Event-Triggered Group Assignment",
  "eproModule.eventTriggeredGroupsDescription":
    "Enable this option to require site users to assign a participant to a group when this event occurs. You can select the Group Types that need to be assigned below.",
  "eproModule.groupsDescription":
    "Events apply to all participants by default. To limit the event to participants in specific groups, select the groups below.",
  "eproModule.groupOptions": "Group Options",
  "eproModule.groupTypes": "Group Types",
  "eproModule.enableEventTriggeredParticipantIdAssignment":
    "Enable Event-Triggered Participant ID Assignment",
  "eproModule.eventTriggeredParticipantIdAssignmentDescription":
    "Enable this option to require site users to assign a Participant ID when this event occurs.",
  "eproModule.eventTriggeredParticipantIdError":
    "The datetime cannot be set to Populate for Sites when Enable Event-Triggered Participant ID Assignment is selected. To save this event, set the datetime population to Display for Sites or disable Event-Triggered Participant ID Assignment.",
  "eproModule.studioNavLabel": "Studio Navigation",
  "eproModule.studySettings": "Study Settings",
  "eproModule.studyParticipantIdFormatDisabled":
    "You cannot configure a Participant ID format for this study because participants are expected to be created with an external integration.",
  "eproModule.studyParticipantIdFormatVariables": "Variables",
  "eproModule.studyParticipantIdFormatNumericType":
    "Required Numeric Characters",
  "eproModule.studyParticipantIdFormatNumeric": "[####]",
  "eproModule.studyParticipantIdFormatNumericDescription":
    "Defines the quantity of numeric characters that must be included where this variable is added. For example, [#] requires the site user to enter a single numeric value between 0 and 9, and [##] requires the site user to enter two numeric values, each between 0 and 9.",
  "eproModule.studyParticipantIdFormatNumericCopyTitle":
    "Copy Numeric Variable",
  "eproModule.studyParticipantIdFormatAlphabeticType":
    "Required Alphabetic Characters",
  "eproModule.studyParticipantIdFormatAlphabetic": "[@@@@]",
  "eproModule.studyParticipantIdFormatAlphabeticDescription":
    "Defines the quantity of uppercase alphabetic characters that must be included where this variable is added. For example, [@] requires the site user to enter a single alphabetic value between A and Z, and [@@] requires the site user to enter two alphabetic values, each between A and Z.",
  "eproModule.studyParticipantIdFormatAlphabeticCopyTitle":
    "Copy Alphabetic Variable",
  "eproModule.studyParticipantIdFormatModalCancel": "Cancel",
  "eproModule.studyParticipantIdFormatModalContinue": "Continue",
  "eproModule.studyParticipantIdFormatModalTitle":
    "Confirm Participant ID Format Change?",
  "eproModule.studyParticipantIdFormatModalMessage":
    "This change may require existing participant IDs to be updated to match the new format. Are you sure you want to continue?",
  "eproModule.studyParticipantIdFormatModalMessageCancelWarning":
    "Cancelling will discard any changes to Participant ID format and instructions.",
  "eproModule.studyParticipantIdFormatVariableError":
    "Invalid Participant ID format. Include at least one numeric or alphabetic variable.",
  "eproModule.studyParticipantIdFormatLengthError":
    "Format produces IDs that are longer than 128 characters.",
  "eproModule.studyParticipantIdFormatTextFieldLabel": "Format",
  "eproModule.studyParticipantIdFormatExampleValue": "Example Value: {value}",
  "eproModule.studyParticipantIdFormatTextFieldSave": "Save",
  "eproModule.studyParticipantIdFormatSuccessMessage":
    "Participant ID settings updated successfully.",
  "eproModule.participantIdFormat.participantId": "Participant ID",
  "eproModule.participantIdFormat.participantIdDescription":
    "Define a Participant ID format or add site-facing instructions to the study.",
  "eproModule.participantIdFormat.format": "Format",
  "eproModule.participantIdFormat.formatDescription":
    "A Participant ID format can be defined using any combination of text and variable templates (see panel). Text that is not a variable is hard-coded into the Participant ID format and cannot be edited by site users.",
  "eproModule.participantIdFormat.formatConfigurationInfo":
    "If your study uses a post-randomization ID, you should only configure this option if the ID formats are identical.",
  "eproModule.participantIdFormat.instructions": "Instructions",
  "eproModule.participantIdFormat.instructionsDescription":
    "Define site-facing instructions to guide the population of the Participant ID field when creating or editing a Participant in {ecoa}. Instructions can be included with or without formatting requirements.",
  "eproModule.participantIdFormat.sourceLanguage": "Source Language",
  "eproModule.participantIdFormat.sourceLanguageRequired":
    "Source Site Instructions must be included to save Instruction Translations",
  "eproModule.participantIdFormat.siteInstructions": "Site Instructions",
  "eproModule.participantIdFormat.addTranslations": "ADD TRANSLATIONS",
  "eproModule.participantIdFormat.siteLanguage": "Site Language",
  "eproModule.participantIdFormat.instructionTranslation":
    "Instruction Translation",
  "eproModule.studySettings.sideNavLabel": "Study Settings Navigation",
  "eproModule.studySettings.general": "GENERAL",
  "eproModule.studySettings.studyConduct": "STUDY CONDUCT",
  "eproModule.studySettings.authenticationAndIdentity":
    "AUTHENTICATION & IDENTITY",
  "eproModule.siteSignature": "Site Signature",
  "eproModule.siteSignature.siteSignatureDescription":
    "This setting determines whether a study site's investigator must review and endorse survey data with an electronic signature. Signatures must be complete before study sites can be locked. Signature status is tracked in Study Home.",
  "eproModule.siteSignature.dataRequiringSignature": "Data Requiring Signature",
  "eproModule.siteSignature.onlySurveysWithDataChanges":
    "Only Surveys with Data Changes",
  "eproModule.siteSignature.allSurveys": "All Surveys",
  "eproModule.siteSignature.transcriptions": "Transcriptions",
  "eproModule.siteSignature.dataChanges": "Data Changes",
  "eproModule.siteSignature.sourceEclinro": "Source {eclinro}",
  "eproModule.siteSignature.sourceEpro": "Source {epro}",
  "eproModule.siteSignature.sourceComposite": "Source Composite",
  "eproModule.siteSignature.signatureStatement": "Signature Statement",
  "eproModule.siteSignature.signatureStatementDescription":
    "Define what the user's electronic signature means in {veevaecoa}. You can use the default statement or provide your own. You may need to provide translations for the custom statement, based on the Study Languages that have been selected.",
  "eproModule.siteSignature.defaultStatement": "Default Statement",
  "eproModule.siteSignature.defaultStatementDescription":
    "By entering my password, I confirm that I reviewed the data and that it is complete and accurate.",
  "eproModule.siteSignature.customStatement": "Custom Statement",
  "eproModule.siteSignature.statementTranslation": "Statement Translation",
  "eproModule.siteSignature.addStatement": "Add Statement",
  "eproModule.siteSignature.ADD_TRANSLATIONS": "ADD TRANSLATIONS",
  "eproModule.siteSignature.excludeTranslation": "Exclude Translation:",
  "eproModule.siteSignature.statementWillBeDisplayedInEnglish":
    "Statement Will Be Displayed in English",
  "eproModule.siteSignature.siteLanguage": "Site Language",
  "eproModule.siteSignature.missingTranslations": "Missing Translations",
  "eproModule.siteSignature.missingTranslationWarning":
    "Review and add required Statement Translations to enable Site Signatures to display in site user languages.",
  "eproModule.studySettings.studyLanguages": "Study Languages",
  "eproModule.studySettings.addLanguage": "Add Language",
  "eproModule.studySettings.deleteLanguage":
    "This language can't be removed because it is used in a collection.",
  "eproModule.studySettings.languagesMessage":
    "Select the languages supported by the study, including patient and site languages. Languages must be added to this list before they are included in the <collectionLink>Collection</collectionLink>.",
  "eproModule.studySettings.noLanguages": "No Languages",
  "eproModule.studySettings.noLanguagesMessage": "Start by adding a language",
  "eproModule.studySettings.deleteLanguageMessage":
    "Removing {language} from the study and collection will delete all language resources",
  "eproModule.studySettings.confirmLanguageRemoval": "Confirm Language Removal",
  "eproModule.studySettings.resources": "Resources",
  "eproModule.studySettings.resourcesMessage": `Upload website links for participants. Toggle resource availability "on" to make the resource visible to {myveevaforpatients} users.`,
  "eproModule.studySettings.createResource": "Create Resource",
  "eproModule.studySettings.editResource": "Edit Resource",
  "eproModule.studySettings.editResourceAvailableWarning":
    "If you edit the display label or URL for an available resource, updates will be immediately released to the {myveevaforpatients} app.",
  "eproModule.studySettings.editResourceRemovalWarning":
    "If you remove the display label or URL for an available resource, the resource will be removed from the {myveevaforpatients} app.",
  "eproModule.studySettings.resources.exports": "Exports",
  "eproModule.studySettings.resources.ordering": "Ordering",
  "eproModule.studySettings.resources.reorder": "Reorder Resources",
  "eproModule.studySettings.resources.generateNew": "Generate New",
  "eproModule.studySettings.resources.latestScreenshots": "Latest Screenshots",
  "eproModule.studySettings.resources.generatingScreenshots":
    "Generating screenshot report. Changes to resources may not be captured.",
  "eproModule.studySettings.resources.screenshotsReady":
    "Screenshot export is ready. <link>Download</link>",
  "eproModule.studySettings.resources.failedToGenerateLatestScreenshots":
    "Failed to Generate Latest Screenshots",
  "eproModule.studySettings.resources.screenshotsFilename": "Resource_Overview",
  "eproModule.studySettings.resources.deleteResource": "Delete Resource",
  "eproModule.studySettings.resources.resourceDeleted": "Resource deleted",
  "eproModule.studySettings.resources.deleteWarning":
    "Deleting this resource will permanently remove this resource from the resource list, and remove it from the {myveevaforpatients} app. You cannot undo this action.",
  "eproModule.studySettings.resources.noResources": "No Resources",
  "eproModule.studySettings.resources.noResourcesMessage":
    "Start by creating a resource",
  "eproModule.studySettings.resources.nameHeader": "Name",
  "eproModule.studySettings.resources.languagesHeader": "Languages",
  "eproModule.studySettings.resources.labelHeader": "Display Label",
  "eproModule.studySettings.resources.urlHeader": "URL",
  "eproModule.studySettings.resources.reorderItems": "Reorder Items",
  "eproModule.studySettings.resources.availableHeader":
    "Available to Participants",
  "eproModule.studySettings.resources.availableTooltip":
    "In order to release a resource for a specific language, it must both have a display label and a URL.",
  "eproModule.studySettings.resources.noUrl": "No URL",
  "eproModule.studySettings.resources.noLabel": "No label",
  "eproModule.resourceTableSourceLanguage": "{language} (Source)",
  "eproModule.resourceAvailableAriaLabel": "Toggle availability",
  "eproModule.studySettings.resourceName": "Resource Name",
  "eproModule.studySettings.resources.addName": "Add Name",
  "eproModule.studySettings.addResourceSourceLanguage":
    "Add Resource in Source Language",
  "eproModule.studySettings.resources.useUrlForAllLanguages":
    "Use for All Languages",
  "eproModule.studySettings.addResourceAdditionalLanguage":
    "Add Additional Languages for Resource",
  "eproModule.studySettings.addResourceLanguagesMessage":
    "In order to release a resource for a specific language, it must both have a display label and a URL.",
  "eproModule.studySettings.resourceNameTooltip":
    "This is the internal reference name for the resource. It is not shown to participants.",
  "eproModule.studySettings.displayLabelTooltip":
    "This is the title of the resource that is displayed in the {myveevaforpatients} app.",
  "eproModule.studySettings.resources.addLabel": "Add Label",
  "eproModule.studySettings.resources.urlError": "Incomplete URL",
  "eproModule.studySettings.resources.urlLengthError":
    "URL must be {maxLength} characters or less",
  "eproModule.studySettings.resources.labelLengthError":
    "Display Label must be {maxLength} characters or less",
  "eproModule.requiredError": "{fieldName} is required",
  "eproModule.studySettings.urlTooltip":
    "URLs are web links that participants can access in the {myveevaforpatients} app. Include the entire URL, including http:// or https://.",
  "eproModule.addVisitWindow": "Add Visit Window",
  "eproModule.addVisitWindowTooltip":
    "When you add a visit window, sites can view the preferred timeframe for a participant event.",
  "eproModule.windowDaysRangeError": "Enter a value less than 1000.",
  "eproModule.offsetRangeError": "Exceeds the maximum value of {number} days.",
  "eproModule.confirmReversion": "Confirm Reversion",
  "eproModule.confirmReversionMessage":
    "Reverting to the last major version will change the status of some minor versions to Reverted. This change cannot be undone. <break></break>The following versions will be reverted:<break></break> <versions></versions>",
  "eproModule.create": "Create",
  "eproModule.lastSupersededMinorVersion": "Last Superseded Minor Version",
  "eproModule.recommended": "Recommended",
  "eproModule.lastApprovedVersion": "Last Approved Version",
  "eproModule.createNewVersion": "Create New Version",
  "eproModule.createNewVersionMessage":
    "You can create a new version based on the last superseded minor version or you can revert to the last approved version. Select the version you want to use as the base for your new collection version.",
  "eproModule.reasonForDeletion": "Reason for Deletion",
  "eproModule.provideReason": "Provide Reason",
  "eproModule.copiedTooltip": "Copied",
  "eproModule.actionsDropdownManage": "MANAGE",
  "eproModule.copyEproCode": "Copy Setup Code",
  "eproModule.copyEventName": "Copy Event Name",
  "eproModule.copyGroupName": "Copy Group Name",
  "eproModule.copyRuleName": "Copy Rule Name",
  "eproModule.copyName": "Copy Name",
  "eproModule.copyURL": "Copy URL",
  "eproModule.copyUatEproCode": "Copy {uat} Setup Code",
  "eproModule.createNew": "Create New",
  "eproModule.createNewSurvey": "Create New Survey",
  "eproModule.delete": "Delete",
  "eproModule.remove": "Remove",
  "eproModule.deleteCollection": "Delete Collection",
  "eproModule.deleteSurvey": "Delete Survey",
  "eproModule.deleteLanguage": "Remove Language",
  "eproModule.deleteModalMessage":
    "This action cannot be undone. Do you want to delete this collection version?",
  "eproModule.deleteModalTitle": "Delete Collection Version",
  "eproModule.activateEventDisabledAnchor":
    "You can't activate this event because it is anchored to the inactive event: {event}",
  "eproModule.inactiveEventDisabledList":
    "You can't inactivate this event for the following reasons: <ul>{list}</ul>",
  "eproModule.removeEventDisabledList":
    "You can't remove this event for the following reasons: <ul>{list}</ul>",
  "eproModule.standardEvent": "This event is a standard event.",
  "eproModule.eventUsedInRule": "This event is used in a rule or as a trigger.",
  "eproModule.eventUsedInSchedule": "This event is used in a schedule.",
  "eproModule.eventUsedAsAnchorEvent":
    "This event is used as an anchor event by the following events: <ul>{events}</ul>",
  "eproModule.dimensions": "Dimensions: {dimensions}",
  "eproModule.displayLabelField": "Display Label",
  "eproModule.surveyEntityName": "Name",
  "eproModule.displayLabelTooltip":
    "The <b>display label</b> will be displayed as the survey title in {veevaEcoa} and {myveevaforpatients}.",
  "eproModule.entityNameTooltip":
    "The <b>name</b> is used to identify the survey in a rule template.",
  "eproModule.namesMustBeUnique":
    "Names must be unique within study collection.",
  "eproModule.disabledRemoveUsedGroupType":
    "You can't remove types used by groups",
  "eproModule.disabledRemovePreviouslyApprovedGroupType":
    "You can't remove a type once it has been used in an approved collection",
  "eproModule.done": "Done",
  "eproModule.download": "Download",
  "eproModule.downloadAllTranslations": "Download All Translations",
  "eproModule.downloadScheduleConfiguration": "Download Schedule Configuration",
  "eproModule.downloadScheduleConfigurationFilename": "{name}_schedules",
  "eproModule.surveyFilenameFallback": "survey",
  "eproModule.downloadSurveyConfiguration": "Download Survey Configuration",
  "eproModule.downloadTitle": "Download Translations",
  "eproModule.downloadTranslationsActions": "Download Translations Actions",
  "eproModule.downloadUntranslatedText": "Download Untranslated Text",
  "eproModule.downloadBySurvey": "Download By Survey",
  "eproModule.downloadTranslationsBySurvey": "Download Translations by Survey",
  "eproModule.downloadBySurveySelectionLimit":
    "You cannot select more than 20 surveys to download files for.",
  "eproModule.downloadUntranslatedTextBySurvey":
    "Download Untranslated Text by Survey",
  "eproModule.useOnlyWhenRequired": "Use only when required",
  "eproModule.downloadSourcePopulatedTranslations":
    "Download Source-Populated Translations",
  "eproModule.downloadSourcePopulatedTranslationsTooltip":
    "Populates translation strings with source strings. This should only be used when required by the translation vendor.",
  "eproModule.dropAFileHereOrBrowseForOne":
    "Drop a file here or browse for one to add.",
  "eproModule.dropANewImageHereOrBrowseForOne":
    "Drop a new image here or browse for one.",
  "eproModule.dropYourFileHereToUploadIt": "Drop your file here to upload it.",
  "eproModule.duplicateSequenceError": "The sequence must be unique.",
  "eproModule.easy": "Easy",
  "eproModule.edit": "Edit",
  "eproModule.editEvent": "Edit Event",
  "eproModule.editLanguageTooltip":
    "You can't edit languages that have previously been used for both patients and sites in an approved collection.",
  "eproModule.editLanguageTooltipNoSurveys":
    "You can't edit survey types when there are no surveys in the collection.",
  "eproModule.editStandardEventDisabled": "You can't edit standard events.",
  "eproModule.editSurvey": "Edit Survey",
  "eproModule.editSurveyLocked": "Edit Survey (Locked)",
  "eproModule.setLanguageSupport": "Set Language Support",
  "eproModule.editingUnlockedTooltip":
    "Editing unlocked. Click Cancel to revert your changes.",
  "eproModule.enterFullscreen": "Enter Full Screen",
  "eproModule.eproCodeCopied": "Setup Code Copied",
  "eproModule.errors.400-message":
    "Your browser sent a request that the server did not understand. Please select the button below to return to your {page}.",
  "eproModule.errors.400-title": "Bad Request",
  "eproModule.errors.401-message":
    "We logged you out while you were inactive. Please log in again.",
  "eproModule.errors.401-title": "Authentication Required",
  "eproModule.errors.403-message":
    "You do not have permission to view this information. Please contact an administrator if you should have access.",
  "eproModule.errors.403-title": "Access Denied",
  "eproModule.errors.404-message":
    "The page you are looking for no longer exists. Please select the button below to return to your {page}.",
  "eproModule.errors.404-title": "Page Not Found",
  "eproModule.errors.412-title": "Unable to Update",
  "eproModule.errors.412-message":
    "Rule references to this object are no longer valid. Correct all rule reference errors before you change this status.",
  "eproModule.errors.412-externalApiTitle": "Invalid Request",
  "eproModule.errors.412-externalApiMessage":
    "An external API connection was deactivated or set to read only. This action cannot be completed.",
  "eproModule.errors.500-message":
    "Sorry, we are having an issue with our website or servers. Please refresh the page and contact support if the problem continues.",
  "eproModule.errors.500-title": "Internal Server Error",
  "eproModule.errors.503-message":
    "Sorry, the service for this action is unavailable. Please try again later and contact support if the problem continues.",
  "eproModule.errors.503-title": "Service Unavailable",
  "eproModule.errors.buttonGoToPage": "Go to {page}",
  "eproModule.eventLabel": "Event Label",
  "eproModule.eventLabelTooltip":
    "The Event Label is displayed to site and sponsor users to identify the event.",
  "eproModule.eventLabelNoSurveysTooltip":
    "No surveys are included in this event. Add this event to a survey schedule or remove it.",
  "eproModule.eventLabelInvalidChars":
    "The event label can't contain invalid characters.",
  "eproModule.eventLabelPlaceholder": "e.g., Visit 1, Phase 1, Screening Visit",
  "eproModule.unscheduledEventLabelPlaceholder": "e.g., Unscheduled Event",
  "eproModule.eventLabelRequired": "The event label is required.",
  "eproModule.unlock": "Unlock",
  "eproModule.eventEntityName": "Event Name",
  "eproModule.eventEntityTooltip":
    "The Event Name is used to reference the event in a rule.",
  "eproModule.eventEntityNamePlaceholder":
    "e.g., visit_1, phase_1, screening_visit",
  "eproModule.unscheduledEventEntityNamePlaceholder": "e.g., unscheduled_event",
  "eproModule.eventEntityNameRequired": "The event name is required.",
  "eproModule.events": "Events",
  "eproModule.eventType": "EVENT TYPE",
  "eproModule.scheduleEvent": "Scheduled Event",
  "eproModule.unscheduledEvent": "Unscheduled Event",
  "eproModule.unscheduledEventDescription":
    "Unscheduled Events do not appear in participant event lists unless added by a site.",
  "eproModule.unscheduledEventLabelId":
    "A numeric identifier (#) will be added to the event label in exports and reports. It will also appear in event labels for site users.",
  "eproModule.unscheduledEventLabelIdExample": "Example: Event Label - 1",
  "eproModule.editCriteriaCheck": "Edit Criteria Check",
  "eproModule.addCriteriaCheck": "Add Criteria Check",
  "eproModule.addScheduleEvent": "Add Scheduled Event",
  "eproModule.editScheduleEvent": "Edit Scheduled Event",
  "eproModule.addUnscheduleEventTooltip":
    "Unscheduled Events do not appear in participant event lists unless added by a site.",
  "eproModule.addUnscheduleEvent": "Add Unscheduled Event",
  "eproModule.editUnscheduleEvent": "Edit Unscheduled Event",
  "eproModule.eventsDescription":
    "Events are used in schedules to determine when surveys should be sent. The actual date and time of events are entered by the site.",
  "eproModule.eventInactivateTitle": "Inactivate this event?",
  "eproModule.eventInactivateMessage":
    "Site staff cannot collect new data for inactive events. Any study data already collected is still accessible. You can reactivate events later if needed.",
  "eproModule.eventsTooltip":
    "<b>Events</b> are used in schedules to determine when surveys should be sent. The actual date and time of events are entered by the site.",
  "eproModule.eventScheduleValidation": `Schedules associated with this event are assigned to the "{groupName}" group. You must select this group to continue or update your schedules.`,
  "eproModule.exitFullscreen": "Exit Full Screen",
  "eproModule.screenshotReport": "Screenshot Report",
  "eproModule.failedToGenerateStudyDesignSpecificationPleaseTryAgain":
    "Failed to generate Study Design Specification. Please try again.",
  "eproModule.studyDesignSpecification": "Study Design Specification",
  "eproModule.failedToGenerateLatestSpecification":
    "Failed to Generate Latest Specification",
  "eproModule.failedToGenerateScreenshotReportPleaseTryAgain":
    "Failed to generate Screenshot Report. Please try again.",
  "eproModule.failedToGenerateLatestReport": "Failed to Generate Latest Report",
  "eproModule.studyDesignSpecificationPdf": "study_design_specification",
  "eproModule.screenshotReportPdf": "screenshot_report",
  "eproModule.screenshotReportZip": "screenshot_reports",
  "eproModule.fileSize": "File Size: {size}",
  "eproModule.fileUploaded": "File Uploaded",
  "eproModule.finishUat": "Finish {uat}",
  "eproModule.manageDeployments": "Manage Deployments",
  "eproModule.notDeployedToAnySites":
    "Not deployed to <b>ANY</b> sites <br></br> {manageDeploymentsLink}",
  "eproModule.notDeployedToSomeSites":
    "Not deployed to some sites <br></br> {manageDeploymentsLink}",
  "eproModule.fileFormatsAccepted": "File Formats Accepted:",
  "eproModule.format": "Format: <b>{format}</b>",
  "eproModule.previewStudySchedule": "Preview Study Schedule",
  "eproModule.downloadLatestSpecification": "Download Latest Specification",
  "eproModule.generateNewSpecification": "Generate New Specification",
  "eproModule.generateNewReport": "Generate New Report",
  "eproModule.screenshotReportSizeModal.description":
    "Select a device size for the screenshot report.",
  "eproModule.screenshotReportSizeModal.default": "Default Sizes",
  "eproModule.screenshotReportSizeModal.tablet": "Tablet Size for All Surveys",
  "eproModule.screenshotReportSizeModal.generate": "Generate",
  "eproModule.generatedDate": "Generated {date}",
  "eproModule.generating": "Generating...",
  "eproModule.sdsExportIsReady":
    "Study Design Specification export is ready. <link>Download</link>",
  "eproModule.screenshotReportExportIsReady":
    "Screenshot Report export is ready. <link>Download</link>",
  "eproModule.generatingNewSds":
    "Generating new Study Design Specification. This may take up to 1 hour for large files.",
  "eproModule.generatingNewScreenshotReport":
    "Generating new Screenshot Report. This may take up to 1 hour for large files.",
  "eproModule.generatingNewSurveyScreenshotReport":
    "Generating new Screenshot Report. This may take a few minutes.",
  "eproModule.collapse": "Collapse",
  "eproModule.composite": "Composite",
  "eproModule.expand": "Expand",
  "eproModule.groups": "Groups",
  "eproModule.surveyAccessPermissions": "Survey Access Permissions",
  "eproModule.appliesToGroups": "Applies to Groups",
  "eproModule.triggersAssignmentFor": "Triggers Assignment For",
  "eproModule.assignedAt": "Assigned at {eventsList}",
  "eproModule.editGroup": "Edit Group",
  "eproModule.groupsOrGroupTypes": "Groups or Group Types",
  "eproModule.groupName": "Group Name",
  "eproModule.groupLabel": "Group Label",
  "eproModule.whereUsed": "Where Used",
  "eproModule.groupDetails": "Group Details",
  "eproModule.group": "Group",
  "eproModule.groupNameLockedTooltip":
    "The group name is populated by API. Unlock the field to edit the name.",
  "eproModule.populatedByDetails": "Populated by {populatedBy}",
  "eproModule.groupField":
    "Group: <ValueText>{groupType} > {groupName}</ValueText>",
  "eproModule.groupTypeAndLabel": "Type · Group Label",
  "eproModule.groupsTooltip":
    "Groups are used in schedules to determine to whom surveys should be sent. The group(s) for a Participant are selected by the site.",
  "eproModule.groupsZeroStateHeader": "No Groups",
  "eproModule.groupsZeroStateSubHeader": "Start by adding a group type.",
  "eproModule.none": "None",
  "eproModule.schedulesThatIncludeGroup":
    "The following schedules apply to this group:",
  "eproModule.schedulesThatIncludeAllGroups":
    "The following schedules apply to all groups:",
  "eproModule.eventsThatIncludeGroup":
    "The following events apply to this group:",
  "eproModule.eventsThatIncludeAllGroups":
    "The following events apply to all groups:",
  "eproModule.groupTypesEmpty": "No types have been added yet.",
  "eproModule.groupDeactivateTitle": "Deactivate this group?",
  "eproModule.groupInactivate":
    "Inactive groups can still be used in schedules and events but will no longer be available for site users to select for new participants.",
  "eproModule.groupActivateTitle": "Activate this group?",
  "eproModule.groupActivate":
    "Active groups can be used in schedules and events and can be selected by site users for new participants.",
  "eproModule.activate": "Activate",
  "eproModule.groupRemoveTitle": "Remove This Group?",
  "eproModule.groupRemove":
    "Once removed, this group cannot be used in future schedules and events.",
  "eproModule.groupDisabledList":
    "You cannot delete this group for the following reasons:",
  "eproModule.groupDisabledUsedInScheduleOrEvent":
    "The group is used in a schedule or event.",
  "eproModule.groupDisabledLastTriggered":
    "The group is the last active group in a Group Type that has event-triggered assignment.",
  "eproModule.hard": "Hard",
  "eproModule.help": "Help",
  "eproModule.invalidSurveyJsonLinkBlock":
    "Invalid relatedSurvey or summaryBlocks reference. See Surveys for details.",
  "eproModule.areAllPeEventsMappedToRules":
    "A rule is missing for a rule populated event.",
  "eproModule.areAllPeRulesMappedToEvents":
    "A populate event rule references an event which is not configured to be populated by a rule.",
  "eproModule.areAllRuleConditionalEventsReferencedByRules":
    "There is no criteria check rule which references a conditional event.",
  "eproModule.areAllRuleToConditionalEventLinksValid":
    "A criteria check rule is set to make an event available, but the event is not configured to be rule triggered.",
  "eproModule.screeningIdNeedsEventTriggeredParticipantIdAssignment":
    "Screening IDs are enabled. At least one event must be configured with an Event-Triggered Participant ID Assignment.",
  "eproModule.imageLibrary": "Image Library",
  "eproModule.imageType": "Type: {type}",
  "eproModule.imageUrlCopiedToClipboard": "Image URL Copied to Clipboard",
  "eproModule.invalidLogoImageDimensions":
    "Warning: Your image height is {height}px. For optimal display, we recommend an image height of at least {minimumHeight}px.",
  "eproModule.manageSurvey.accessPermissions": "Access Permissions",
  "eproModule.manageSurvey.accessPermissionsDescription":
    "Add a permission requirement for this survey. Each permission you save is automatically available for other surveys after you save this survey.",
  "eproModule.manageSurvey.permissionCannotBeRemoved":
    "This permission cannot be removed because it is part of an approved collection or used to control access to another survey.",
  "eproModule.manageSurvey.createPermission": "Create Permission",
  "eproModule.manageSurvey.noPermissions":
    "No permissions have been created. Create a permission.",
  "eproModule.manageSurvey.newPermission": "New Permission",
  "eproModule.manageSurvey.editPermission": "Edit Permission",
  "eproModule.manageSurvey.permissionLabel": "Permission Label",
  "eproModule.manageSurvey.permissionLabelValidationError":
    "May only contain letters, numbers, spaces, and hyphens.",
  "eproModule.manageSurvey.permissionLabelUniqueError":
    "Permission label must be unique.",
  "eproModule.manageSurvey.dismiss": "Dismiss",
  "eproModule.manageSurvey.close": "Close",
  "eproModule.manageSurvey.snippetsBannerText":
    "Get started with an example JSON survey or code snippet, use the <b>Tools {snippetsIcon}</b> menu.",
  "eproModule.manageSurvey.tools": "Tools",
  "eproModule.manageSurvey.viewError": "View {errorCount} Error",
  "eproModule.manageSurvey.viewErrors": "View {errorCount} Errors",
  "eproModule.manageSurvey.errors": "Errors",
  "eproModule.manageSurvey.lineNumber": "Line {lineNumber}",
  "eproModule.manageSurvey.view": "View",
  "eproModule.manageSurvey.jsonSnippets": "JSON Snippets",
  "eproModule.manageSurvey.copySnippet": "Copy Snippet",
  "eproModule.manageSurvey.openHelp": "Open Help",
  "eproModule.manageSurvey.goTo": "Go To {location}",
  "eproModule.manageSurvey.images": "Images",
  "eproModule.manageSurvey.removeImage": "Remove Image",
  "eproModule.manageSurvey.removeImageDisabledTooltip":
    "Remove the image from the survey and save before deleting the image.",
  "eproModule.manageSurvey.removeImageDescription":
    "Are you sure you want to delete {filename} and any related image translations? This action cannot be undone.",
  "eproModule.manageSurvey.confirm": "Confirm",
  "eproModule.manageSurvey.cancel": "Cancel",
  "eproModule.manageSurvey.clickToBrowse": "Click to browse",
  "eproModule.manageSurvey.orDragAndDrop": "or drag and drop image",
  "eproModule.manageSurvey.uploadedImage": "Uploaded Image",
  "eproModule.manageSurvey.imageUploadedSuccessfully":
    "Image Uploaded Successfully",
  "eproModule.manageSurvey.imagesTabDescription":
    "Upload an image or select one from the library to add it to your survey.",
  "eproModule.manageSurvey.manageImages": "Manage Images",
  "eproModule.manageSurvey.imageSource": "Source",
  "eproModule.manageSurvey.imageActionCopyUrl": "Copy Image URL for JSON",
  "eproModule.manageSurvey.imageActionCopyCode": "Copy Share Code",
  "eproModule.manageSurvey.supportedLanguagesHeading":
    "Source Image Supported Languages",
  "eproModule.manageSurvey.relatedSurveysHeading":
    "Survey Image Libraries Affected By Changes",
  "eproModule.manageSurvey.relatedSurveysTooltip":
    "All survey image libraries listed below will be affected by edits to localizations and language assignments.",
  "eproModule.manageSurvey.noLanguagesAvailable": "No languages available",
  "eproModule.manageSurvey.noImages": "No Images",
  "eproModule.manageSurvey.noImageFound": "No image found",
  "eproModule.manageSurvey.unableToReadFile": "Unable to read file",
  "eproModule.manageSurvey.anErrorOccurred":
    "An error occurred, please try again",
  "eproModule.manageSurvey.noImageLocalizations": "No Image Localizations",
  "eproModule.manageSurvey.startUploadSourceImage":
    "Start by uploading a source image",
  "eproModule.manageSurvey.startUploadImage": "Start by uploading an Image",
  "eproModule.manageSurvey.imageLanguageVariants": "Image Language Variants",
  "eproModule.manageSurvey.uploadSourceImage": "Upload Source Image",
  "eproModule.manageSurvey.importImageFromCodeValidationError":
    "Invalid code. Copy the Image Share Code and try again.",
  "eproModule.manageSurvey.importImageFromCode": "Add Image with Share Code",
  "eproModule.manageSurvey.importImageFromCodeTooltip":
    "To add an image and its localizations from another survey, copy the Image Share Code from the source image Copy menu and enter it here.",
  "eproModule.manageSurvey.importImage": "Import Image",
  "eproModule.manageSurvey.importCodePlaceholder":
    "e.g., 2d8cece8-c51e-4148-9fd4-6b1dd11d7965",
  "eproModule.manageSurvey.importCodeConfirmOverwriteTitle": "Replace Image",
  "eproModule.manageSurvey.importCodeConfirmOverwriteMessage":
    "This image and its localizations already exist. Do you want to replace them for all instances in this collection? After importing, verify the localization images.",
  "eproModule.manageSurvey.removeImageLocalizationTitle":
    "Remove Image Localization",
  "eproModule.manageSurvey.removeImageLocalizationMessage":
    "Are you sure you want to delete {filename}? This will remove any assigned languages.",
  "eproModule.manageSurvey.replace": "Replace",
  "eproModule.manageSurvey.imageUsageOverview":
    "Upload {jpg}, {png}, or {gif} images to display in a survey. Images are saved to the survey's image library. Survey images adapt to the size of a respondent's device. Images can be used in the following contexts:",
  "eproModule.manageSurvey.imageLocalizationUsageOverview":
    "Image localizations are available for all studies with more than one study language. A localized image replaces the source image within the survey when the respondent's language matches the localization's language. Image localizations can be added to support text in images and other localization requirements.",
  "eproModule.manageSurvey.aboveLicenseText": "Above license text",
  "eproModule.manageSurvey.aboveQuestionOrHeading":
    "Above question or instruction heading text",
  "eproModule.manageSurvey.aboveNumericRatingScales":
    "Above numeric rating scales",
  "eproModule.manageSurvey.asAnswersToQuestions":
    "As answers to single- or multiple-choice questions",
  "eproModule.manageSurvey.aboveHorizontalVASScales":
    "Above horizontal visual analog scales",
  "eproModule.manageSurvey.nextToVerticalVASScales":
    "Next to vertical visual analog scales",
  "eproModule.manageSurvey.sourceImages": "Source Images",
  "eproModule.manageSurvey.only": "Only",
  "eproModule.manageSurvey.addImageLocalizations": "Add Image Localizations",
  "eproModule.manageSurvey.manageImageLocalizations":
    "Manage Image Localizations",
  "eproModule.manageSurvey.languageAssignment": "Language Assigment",
  "eproModule.manageSurvey.groupNames": "Group Names",
  "eproModule.manageSurvey.eventNames": "Event Names",
  "eproModule.manageSurvey.ruleNames": "Rule Names",
  "eproModule.manageSurvey.groups": "Groups",
  "eproModule.manageSurvey.events": "Events",
  "eproModule.manageSurvey.rules": "Rules",
  "eproModule.manageSurvey.groupsTabDescription":
    "Add groups to define which participants this schedule applies to. If you add multiple groups, participants must be in all of the groups for the schedule to apply to them.",
  "eproModule.manageSurvey.eventsTabDescription":
    'Add event names to the "startEvents" parameter to define when the schedule will start. Add event names to the "endEvents" parameter to define when the schedule will end.',
  "eproModule.manageSurvey.rulesTabDescription":
    'Add rule names to the "startRules" parameter to define when the schedule will start.',
  "eproModule.manageSurvey.navigateToHelpDocumentation":
    "Navigate to Help Documentation",
  "eproModule.manageSurvey.survey": "Survey",
  "eproModule.manageSurvey.schedule": "Schedule",
  "eproModule.manageSurvey.scheduled": "Scheduled",
  "eproModule.manageSurvey.unscheduled": "Unscheduled",
  "eproModule.manageSurvey.unscheduledTooltip":
    'Unscheduled events can only start "for" schedules.',
  "eproModule.snippetTitle.surveySnippets": "Survey Snippets",
  "eproModule.snippetTitle.validations": "Validations",
  "eproModule.snippetTitle.templates": "Templates",
  "eproModule.snippetTitle.baseTemplate": "Base Template",
  "eproModule.snippetTitle.baseTableClinroTemplate": "Base Table {clinro}",
  "eproModule.snippetTitle.baseRepeatSection": "Base Repeat Section",
  "eproModule.snippetTitle.baseCompositeTemplate": "Base Composite Survey",
  "eproModule.snippetTitle.questionBlocks": "Question Blocks",
  "eproModule.snippetTitle.textBlock": "Instructional Text Block",
  "eproModule.snippetTitle.singleChoice": "Single Choice",
  "eproModule.snippetTitle.multipleChoice": "Multiple Choice",
  "eproModule.snippetTitle.vas": "Visual Analog Scale (VAS)",
  "eproModule.snippetTitle.nrs": "Numeric Rating Scale (NRS)",
  "eproModule.snippetTitle.numberEntry": "Number Entry",
  "eproModule.snippetTitle.textEntry": "Text Entry",
  "eproModule.snippetTitle.date": "Date Entry",
  "eproModule.snippetTitle.time": "Time Entry",
  "eproModule.snippetTitle.datetime": "Datetime Entry",
  "eproModule.snippetTitle.questionAttributes": "Question Attributes",
  "eproModule.snippetTitle.blockType": "Block Type",
  "eproModule.snippetTitle.blockName": "Block Name",
  "eproModule.snippetTitle.headingImage": "Heading Image Container",
  "eproModule.snippetTitle.blockHeadingText": "Block Heading Text",
  "eproModule.snippetTitle.optionalAnswersContainer":
    "Optional Answers Container",
  "eproModule.snippetTitle.optionalAnswerName": "Optional Answer Name",
  "eproModule.snippetTitle.optionalAnswerText": "Optional Answer Text",
  "eproModule.snippetTitle.optionalAnswerScore": "Optional Answer Score",
  "eproModule.snippetTitle.conditions": "Conditions",
  "eproModule.snippetTitle.conditionsContainer": "Conditions Container",
  "eproModule.snippetTitle.conditionName": "Condition Name",
  "eproModule.snippetTitle.conditionType": "Condition Type",
  "eproModule.snippetTitle.conditionBlockName": "Condition Block Name",
  "eproModule.snippetTitle.operation": "Condition Operation",
  "eproModule.snippetTitle.answerTypeName": "Answer Type: Name",
  "eproModule.snippetTitle.answerTypeNumber": "Answer Type: Number",
  "eproModule.snippetTitle.answerTypeStatic": "Answer Type: Static",
  "eproModule.snippetTitle.optionalAnswer": "Optional Answer",
  "eproModule.snippetTitle.validationBase": "Validation Base",
  "eproModule.snippetTitle.validationSettingsContainer":
    "Validation Settings Container",
  "eproModule.snippetTitle.scores": "Scores",
  "eproModule.snippetTitle.scoreBase": "Score Base",
  "eproModule.snippetTitle.scoreName": "Score Name",
  "eproModule.snippetTitle.scoreLabel": "Score Label",
  "eproModule.snippetTitle.scoreVisibility": "Score Visibility",
  "eproModule.snippetTitle.scoreDerivedValue": "Score Derived Value",
  "eproModule.snippetTitle.scheduleSnippets": "Schedule Snippets",
  "eproModule.snippetTitle.baseFor": "Base {for}",
  "eproModule.snippetTitle.fullFor": "Full {for}",
  "eproModule.snippetTitle.baseBetween": "Base {between}",
  "eproModule.snippetTitle.fullBetween": "Full {between}",
  "eproModule.snippetTitle.baseAsNeeded": "Base {asNeeded}",
  "eproModule.snippetTitle.fullAsNeeded": "Full {asNeeded}",
  "eproModule.snippetTitle.baseOpenEnded": "Base {openEnded}",
  "eproModule.snippetTitle.fullOpenEnded": "Full {openEnded}",
  "eproModule.snippetTitle.parameters": "Parameters",
  "eproModule.snippetTitle.scheduleName": "Name",
  "eproModule.snippetTitle.scheduleDescription": "Description",
  "eproModule.snippetTitle.scheduleGroups": "Groups",
  "eproModule.snippetTitle.scheduleStartContainer": "Start Container",
  "eproModule.snippetTitle.scheduleStartDelayValue": "Start Delay Value",
  "eproModule.snippetTitle.scheduleEndContainer": "End Container",
  "eproModule.snippetTitle.scheduleLocation": "Location",
  "eproModule.snippetTitle.availableTypeFor": "Available Type {for}",
  "eproModule.snippetTitle.availableTypeBetween": "Available Type {between}",
  "eproModule.snippetTitle.availableTypeAsNeeded": "Available Type {asNeeded}",
  "eproModule.snippetTitle.availableTypeOpenEnded":
    "Available Type {openEnded}",
  "eproModule.snippetTitle.asNeededStartEndTimes": "{asNeeded} Start/End Times",
  "eproModule.snippetTitle.recurrenceRule": "Recurrence Rule",
  "eproModule.snippetTitle.notifications": "Notifications",
  "eproModule.snippetTitle.notificationsBase": "Notifications Base",
  "eproModule.snippetTitle.notificationsFull": "Notifications Full",
  "eproModule.snippetDescription.baseTemplate":
    "This JSON template is for a new {epro} survey. Essential components for collecting participant data are included.",
  "eproModule.snippetDescription.baseTableClinroTemplate":
    "This JSON template is for a new {eclinro} table survey. Essential components for collecting clinician-reported data are included.",
  "eproModule.snippetDescription.baseRepeatSection":
    "This JSON template is for a section of repeating questions.",
  "eproModule.snippetDescription.validationBase":
    "This attribute is used to define validations between question blocks in a survey. Add it to the top level of the survey JSON. Must use with the validationSettings parameter for survey questions.",
  "eproModule.snippetDescription.validationSettingsContainer":
    "This attribute connects a block to the related validation logic. It also defines the error message that is displayed if the validation fails.",
  "eproModule.snippetDescription.baseCompositeTemplate":
    "This JSON template is for a new composite survey with {epro} and {eclinro} parts. Essential components for collecting participant and clinician-reported data are included.",
  "eproModule.snippetDescription.textBlock":
    "This block includes all required attributes for instructional text that is not directly associated with a question.",
  "eproModule.snippetDescription.singleChoice":
    "This block includes all required attributes for a single-choice/verbal-rating-scale (VRS) question.",
  "eproModule.snippetDescription.multipleChoice":
    "This block includes all required attributes for a multiple-choice question.",
  "eproModule.snippetDescription.vas":
    "This block includes all required attributes for both vertical and horizontal visual analog scale questions.",
  "eproModule.snippetDescription.nrs":
    "This block includes all required attributes for numeric rating scale questions.",
  "eproModule.snippetDescription.numberEntry":
    "This block includes all required attributes for number entry questions.",
  "eproModule.snippetDescription.textEntry":
    "This block includes all required attributes for text entry questions.",
  "eproModule.snippetDescription.date":
    "This block includes all required attributes for date entry questions.",
  "eproModule.snippetDescription.time":
    "This block includes all required attributes for time entry questions.",
  "eproModule.snippetDescription.datetime":
    "This block includes all required attributes for dateime entry questions.",
  "eproModule.snippetDescription.blockType":
    "This attribute determines the type of question the block contains. Required.",
  "eproModule.snippetDescription.blockName":
    "This attribute defines the name of the block. Required.",
  "eproModule.snippetDescription.headingImage":
    "This attribute creates a container that holds a heading image. Optional.",
  "eproModule.snippetDescription.blockHeadingText":
    "This attribute defines the heading text that is shown to each participant. Required.",
  "eproModule.snippetDescription.optionalAnswersContainer":
    "This attribute creates a container to hold optional answers. Optional.",
  "eproModule.snippetDescription.optionalAnswerName":
    "This attribute defines the name of the optional answer. The name must be unique to the question. Required for an optional answer.",
  "eproModule.snippetDescription.optionalAnswerText":
    "This attribute defines the text for the optional answer. The text is displayed to participants. Required for an optional answer.",
  "eproModule.snippetDescription.optionalAnswerScore":
    "This attribute defines the score this question will receive if this answer is selected. Required for an optional answer.",
  "eproModule.snippetDescription.conditionsContainer":
    "This attribute creates the container to define the response type and value that the condition evaluates. Required for a condition.",
  "eproModule.snippetDescription.conditionName":
    "This attribute defines the name of the condition. Required for a condition.",
  "eproModule.snippetDescription.conditionType":
    "This attribute defines the type of the condition. Required for a condition.",
  "eproModule.snippetDescription.conditionBlockName":
    "This attribute defines the controlling question block being evaluated by the condition. Required for a condition.",
  "eproModule.snippetDescription.operation":
    "This attribute is used to compare the triggering response to the participant's response.  Required for a condition.",
  "eproModule.snippetDescription.answerTypeName":
    "This attribute sets the value that the condition evaluates against to a name value. Works with singleChoice and multipleChoice question types. Required for a condition.",
  "eproModule.snippetDescription.answerTypeNumber":
    "This attribute sets the value that the condition evaluates against to a number value. Works with visualScale, numberScale, and numberEntry question types. Required for a condition.",
  "eproModule.snippetDescription.answerTypeStatic":
    "This attribute sets the value that the condition evaluates against to a static value. Works with date, time, and dateTime question types. Required for a condition.",
  "eproModule.snippetDescription.optionalAnswer":
    "This attribute is used within the condition answer to define the triggering value of an optional answer. Required for conditions evaluating optional answers.",
  "eproModule.snippetDescription.scoreBase":
    "This attribute is used to configure scoring. Add it to the top level of a survey JSON to configure scoring. Must be used with the score parameter for survey questions.",
  "eproModule.snippetDescription.scoreName":
    "This attribute is used to define the score name. Required for scores.",
  "eproModule.snippetDescription.scoreLabel":
    "This attribute is used to define the display label for the score. Required for scores.",
  "eproModule.snippetDescription.scoreVisibility":
    "This attribute defines whether the score is displayed to site users. Required for scores.",
  "eproModule.snippetDescription.scoreDerivedValue":
    "This optional attribute derives a value from numeric scores. Optional.",
  "eproModule.snippetDescription.baseFor":
    "This JSON template is for a basic {for} schedule, which makes the survey available for a specific amount of time. Only required attributes are included.",
  "eproModule.snippetDescription.fullFor":
    "This JSON template is for a full {for} schedule, which makes the survey available for a specific amount of time. All required and optional attributes are included.",
  "eproModule.snippetDescription.baseBetween":
    "This JSON template is for a basic {between} schedule, which makes surveys available during a specified time of day. Only required attributes are included.",
  "eproModule.snippetDescription.fullBetween":
    "This JSON template is for a full {between} schedule, which makes surveys available during a specified time of day. All required and optional attributes are included.",
  "eproModule.snippetDescription.baseAsNeeded":
    "This JSON template is for a basic {asNeeded} schedule, which makes surveys available for completion as often as they are needed. Only required attributes are included.",
  "eproModule.snippetDescription.fullAsNeeded":
    "This JSON template is for a full {asNeeded} schedule, which makes surveys available for completion as often as they are needed. All required and optional attributes are included.",
  "eproModule.snippetDescription.baseOpenEnded":
    "This JSON template is for a basic {openEnded} schedule, which makes surveys available without a specific due date. Restricted to {eclinro} surveys and training surveys. Only required attributes are included.",
  "eproModule.snippetDescription.fullOpenEnded":
    "This JSON template is for a full {openEnded} schedule, which makes surveys available without a specific due date. Restricted to {eclinro} surveys and training surveys. All required and optional attributes are included.",
  "eproModule.snippetDescription.scheduleName":
    "This parameter is used to define a unique identifier for the Schedule. Required.",
  "eproModule.snippetDescription.scheduleDescription":
    "This parameter is used to describe the Schedule and isn't visible to sites, participants, or caregivers. Optional.",
  "eproModule.snippetDescription.scheduleGroups":
    "This parameter defines which groups the schedule applies to. If no groups are selected, the schedule is applied to all groups. Optional.",
  "eproModule.snippetDescription.scheduleStartContainer":
    "This parameter holds the configuration for the schedule's start, and the parameter to define which events trigger the start of the schedule. Required.",
  "eproModule.snippetDescription.scheduleStartDelayValue":
    "This parameter defines the number of days the Start Event is offset from the schedule. The value can contain any whole numeric value and supports a variety of time units. Optional.",
  "eproModule.snippetDescription.scheduleEndContainer":
    "This parameter defines which events trigger the end of a schedule for respondents during the study. Optional.",
  "eproModule.snippetDescription.scheduleLocation":
    "This parameter is used to define where a participant or caregiver survey should be completed. This value is displayed to site users. Only available for {epro} survey types. Optional.",
  "eproModule.snippetDescription.availableTypeFor":
    "This parameter defines the type for the schedule and sets it to {forDot} Required for {for} schedules.",
  "eproModule.snippetDescription.availableTypeBetween":
    "This parameter defines the type for the schedule and sets it to {betweenDot} Required for {between} schedules.",
  "eproModule.snippetDescription.availableTypeAsNeeded":
    "This parameter defines the type for the schedule and sets it to {asNeededDot} Required for {asNeeded} schedules.",
  "eproModule.snippetDescription.availableTypeOpenEnded":
    "This parameter defines the type for the schedule and sets it to {openEndedDot} Required for {openEnded} schedules.",
  "eproModule.snippetDescription.asNeededStartEndTimes":
    "This parameter defines the start and end times for an {asNeeded} schedule. This parameter can be added to the Available Type {asNeeded} parameter. Optional.",
  "eproModule.snippetDescription.recurrenceRule":
    "This parameter is used within the Available container to define how often the schedule recurs. Optional.",
  "eproModule.snippetDescription.notificationsBase":
    "This attribute defines which notifcations should be triggered by the system when the schedule is started. Optional.",
  "eproModule.snippetDescription.notificationsFull":
    "This attribute defines which notifications should be triggered by the system when the schedule is started. It includes an example for setting up recurring reminder notifications.",
  "eproModule.jsonLabel": "Survey",
  "eproModule.jsonPlaceholder":
    "Surveys can be created using JSON. Use the help documentation and snippets to start building a survey.",
  "eproModule.jsonLabelTooltip":
    "The survey configuration section contains details about the survey in JSON format.",
  "eproModule.jsonUpdateWarning":
    "Saving an updated survey configuration may require new translations in each supported language.",
  "eproModule.language": "Language",
  "eproModule.languages": "Languages",
  "eproModule.translationHistory": "TRANSLATION HISTORY",
  "eproModule.downloadReport": "Download Report",
  "eproModule.downloadingReport": "Downloading Report",
  "eproModule.downloadTranslationHistoryReportFailed":
    "The Translation History report was not generated. Try again. Contact system support if the problem continues.",
  "eproModule.activeDisabledLanguagesTooltip":
    "Languages that are part of an approved collection cannot be removed.",
  "eproModule.languagesMessage":
    "Manage translations and collection languages here. You can add languages in <studySettingsLink>Study Settings</studySettingsLink>.",
  "eproModule.incompleteLanguageMessage":
    "The following items are missing {language} translations:",
  "eproModule.downloadLatestReport": "Download Latest Report",
  "eproModule.leavePageMessage":
    "Do you want to leave this page? Changes you made may not be saved.",
  "eproModule.librarySurveys": "Library Surveys",
  "eproModule.librarySurveysTooltip":
    "Library surveys may have already been reviewed, licensed, and translated. You may be able to use these to accelerate your study setup.",
  "eproModule.libraryUpdateWarning":
    "You're currently using a survey from a library. Saving these updates will unlink the survey from the library, and you won't receive new translations.",
  "eproModule.licensed": "Licensed",
  "eproModule.licensedTooltip":
    '<b>Licensed</b> indicates that this survey has been licensed by your organization from the licensing agency for the survey. By selecting "Yes," you attest that a license has been obtained.',
  "eproModule.limitAccess": "Limit Access",
  "eproModule.limitAccessTooltip":
    "Enable this setting to choose which permission a site user needs to complete this assessment.",
  "eproModule.requiredPermission": "Required Permission",
  "eproModule.clickToAddAPermissionType": "Click to add a permission type",
  "eproModule.addAndManagePermissionsLabel": "Add and Manage Permissions",
  "eproModule.loading": "Loading",
  "eproModule.general": "GENERAL",
  "eproModule.maxFileSizeLabel": "Max File Size:",
  "eproModule.maxFileSize": "Max File Size: <b>{filesize}</b>",
  "eproModule.moderate": "Moderate",
  "eproModule.name": "Name",
  "eproModule.label": "Label",
  "eproModule.labelUpdateWarning":
    "Saving an updated display label will require a new translation in each supported language.",
  "eproModule.scheduleReferencesInvalidRule":
    "A schedule references rule which does not exist.",
  "eproModule.needsSchedule": "Each survey must have at least one schedule.",
  "eproModule.needsSurvey": "At least one survey must be added.",
  "eproModule.needsSurveyInUnscheduledEvent":
    "Unscheduled events must start one or more schedules.",
  "eproModule.needsTranslation":
    "Each survey must be translated into the selected languages.",
  "eproModule.needsSurveyAccessPermissionsTranslation":
    "Survey access permissions must be translated into the selected languages.",
  "eproModule.needsStudyDetailsTranslation":
    "Study details must be translated into the selected languages.",
  "eproModule.needsEventsTranslation":
    "Study events must be translated into the selected languages.",
  "eproModule.needsGroupsTranslation":
    "Study groups must be translated into the selected languages.",
  "eproModule.newVersion": "New Version",
  "eproModule.no": "No",
  "eproModule.noCollections": "No Collections",
  "eproModule.noCollectionsDescription": "Start by creating a collection",
  "eproModule.noSurveys": "No Surveys",
  "eproModule.noSurveysAddedYet": "No surveys have been added yet.",
  "eproModule.noSurveysFound": "No surveys found",
  "eproModule.noSurveysRequireTranslations":
    "No surveys require translations in this language.",
  "eproModule.numberOfNumber": "{lowerNumber} of {greaterNumber}",
  "eproModule.offsetDays": "Offset Days",
  "eproModule.offsetDaysWarning":
    "Updating the offset days updates protocol expected dates for all connected anchor events.",
  "eproModule.ok": "OK",
  "eproModule.otherAvailableLanguages": "Other Available Languages:",
  "eproModule.participant": "Participant",
  "eproModule.password": "Password",
  "eproModule.patient": "Patient",
  "eproModule.patientAndSite": "Patient and Site",
  "eproModule.patientLanguages": "Patient Languages",
  "eproModule.patientOnly": "Patient Only",
  "eproModule.preview": "Preview",
  "eproModule.previewSurvey": "Preview Survey",
  "eproModule.problemWithFileUpload":
    "Upload Failed - Update File and Try Again",
  "eproModule.removeEventMessage":
    "Once removed, this event cannot be used in future schedules.",
  "eproModule.removeEventTitle": "Remove this Event?",
  "eproModule.confirmLanguageRemoval": "Confirm Language Removal",
  "eproModule.deleteLanguageMessage":
    "Removing {language} from the study and collection will delete all language resources",
  "eproModule.removeMedia": "Remove media",
  "eproModule.removeStudyLogo": "Remove Image",
  "eproModule.removeSurvey": "Remove Survey",
  "eproModule.removeThisSurvey": "Remove This Survey?",
  "eproModule.removeThisSurveyMessage":
    "All configurations for this survey will be permanently removed.",
  "eproModule.removeTooltip": "You can't remove approved languages.",
  "eproModule.required": "Required",
  "eproModule.requiredField": "This field is required.",
  "eproModule.nameValidationCharacters":
    "Names must begin with a letter (A-Z, a-z) and contain no spaces. Additional letters, numbers (0-9), dashes (-), and underscores (_) are also permitted.",
  "eproModule.respondent": "Respondent",
  "eproModule.respondentTooltip":
    "<b>Respondent</b> indicates which role a {myveevaforpatients} user must be designated as to complete this survey.",
  "eproModule.respondentDisabledTooltip":
    "<b>Respondent</b> can't be changed once a survey has been used in an approved collection.",
  "eproModule.respondentBurdenLabel": "Respondent Burden",
  "eproModule.respondentBurdenTooltip":
    "<b>Respondent Burden</b> indicates the perceived difficulty for those completing this survey.",
  "eproModule.restricted": "Restricted",
  "eproModule.restrictData": "Restrict Data",
  "eproModule.restrictedTooltip":
    "<b>Restrict Data</b> indicates whether the data collected within the survey should be visible to users. Selecting Yes will limit who can view the data.",
  "eproModule.reviewed": "Reviewed",
  "eproModule.reviewedTooltip":
    "<b>Reviewed</b> indicates whether the agency that owns the survey has reviewed and approved the survey for use in {myveevaforpatients}.",
  "eproModule.domain": "Domain",
  "eproModule.domainTooltip": "The SDTM domain is one of the following:",
  "eproModule.domainTooltipQS": "QS (Questionnaires)",
  "eproModule.domainTooltipFT": "FT (Functional Tests)",
  "eproModule.domainTooltipRS":
    "RS (Clinical Classifications and Disease Response)",
  "eproModule.domainTooltipMK": "MK (Musculoskeletal System Findings)",
  "eproModule.QS": "QS",
  "eproModule.FT": "FT",
  "eproModule.RS": "RS",
  "eproModule.MK": "MK",
  "eproModule.timepointLabelOnlySupportedToken":
    "timepointLabel is the only supported token",
  "eproModule.supportedTokensError":
    "timepointLabel and dayOfWeek are the only supported tokens",
  "eproModule.saveFailureAlert":
    "Unable to save the survey. Check for errors and try again.",
  "eproModule.save": "Save",
  "eproModule.saveAndExit": "Save & Exit",
  "eproModule.scheduleConfiguration": "Schedule",
  "eproModule.scheduleConfigurationTooltip":
    "The schedule configuration section contains details about the schedule in JSON format.",
  "eproModule.schedules": "Schedules",
  "eproModule.addingRestrictedDataWarning":
    "Adding this restriction will prevent some or all users from viewing data for new instances of this survey.",
  "eproModule.removeRestrictedDataWarning":
    "Removing this restriction will allow all users to view data in new instances of this survey.",
  "eproModule.scoringUpdateWarning":
    "Changing the configuration of a survey that includes scoring may result in differences in score calculations between the previously approved version and this version.",
  "eproModule.search": "Search",
  "eproModule.select": "Select",
  "eproModule.selectGroups": "Select Groups",
  "eproModule.selectedSurveys": "Selected Surveys",
  "eproModule.selectedSurveysEmpty":
    "Click the <icon></icon> icon to add a survey from a library.",
  "eproModule.selectedSurveysTooltip":
    "Selected surveys are library surveys that have been selected for this study. When you click Save, these surveys will be available in your Surveys tab.",
  "eproModule.sequence": "Sequence",
  "eproModule.sequenceTooltip":
    "The Sequence determines the order of displayed events on participant schedules.",
  "eproModule.sequenceRangeError": "The sequence must be between 0 and 1000.",
  "eproModule.trainingSequenceMismatchError":
    "All sequenced training surveys must have the same sequence number.",
  "eproModule.trainingSequenceCannotBeHigherError":
    "Training surveys cannot have a higher sequence than {epro} surveys.",
  "eproModule.regularSequenceCannotBeLowerError":
    "{epro} surveys cannot have a lower sequence than training surveys",
  "eproModule.setSurveyType": "Set Patient and Site Language Support",
  "eproModule.setTranslationLabel": "Translations Available For",
  "eproModule.surveyTypeMessage":
    "Indicate whether patients or sites will require <b>{language}</b> translations.",
  "eproModule.showMore": "Show More",
  "eproModule.site": "Site",
  "eproModule.siteLanguages": "Site Languages",
  "eproModule.siteOnly": "Site Only",
  "eproModule.source": "Source",
  "eproModule.sourceLanguageDisplay": "Source Language",
  "eproModule.sourceLanguage": "Source language (no translation needed)",
  "eproModule.start": "Start",
  "eproModule.startUat": "Start {uat}",
  "eproModule.startUatMessage":
    "Sites connected to this study in your {uat} environment will receive this new version for review and approval.",
  "eproModule.startUatVersion":
    "Start {uat} for Version {majorVersion}.{minorVersion}",
  "eproModule.status": "Status",
  "eproModule.study": "Study",
  "eproModule.studyDescription": "Study Description",
  "eproModule.studyDescriptionTooltip":
    "<b>Study Description</b> is a brief summary of your study for participants to reference.",
  "eproModule.collectionSideNavLabel": "Collection Navigation",
  "eproModule.studyDetails": "Study Details",
  "eproModule.screeningId": "Screening ID",
  "eproModule.screeningId.description":
    "Require sites to populate Screening IDs to temporarily identify participants until they pass screening and receive a Participant ID. If you enable this setting, you must turn on the Event-Triggered Participant ID Assignment toggle for the first post-screening event. <b>This setting cannot be disabled once deployed to production.</b>",
  "eproModule.screeningId.enabled": "Enabled",
  "eproModule.screeningId.disabled": "Disabled",
  "eproModule.screeningId.warningTitle":
    "Enable Event-Triggered Participant ID Assignment",
  "eproModule.screeningId.warningMessage":
    "Configure an event to prompt sites to assign a Participant ID.",
  "eproModule.screeningId.goToEvents": "Go to Events",
  "eproModule.screeningId.disabledDueToEventTrigger":
    "You must first disable Event-Triggered Participant ID assignment on all events before you can update this setting.",
  "eproModule.studyImageAlt": "Study Image",
  "eproModule.studySpecific": "Study-Specific",
  "eproModule.studyUploadLogo": "Upload Image",
  "eproModule.studyUploadLogoTooltip":
    "This image will appear above the study name on a white background. You can include the sponsor's logo, a study-specific logo, or another relevant image. Images should be {minimumHeight}px in height.",
  "eproModule.submit": "Submit",
  "eproModule.summaryOfChanges": "Summary of Changes",
  "eproModule.supportedStudyLanguages": "Supported Study Languages:",
  "eproModule.surveyLibrary": "{libraryName} Library",
  "eproModule.clickLockToEdit":
    "This is a survey from a library. Click the lock to edit.",
  "eproModule.survey": "Survey Label",
  "eproModule.displayLabel": "Display Label",
  "eproModule.surveySequence": "Sequence",
  "eproModule.surveySequenceError":
    "Survey Sequence must be greater than 0 and less than or equal to 1000.",
  "eproModule.surveySequenceTooltip":
    "<b>Survey Sequence</b> defines the order in which users must complete surveys.",
  "eproModule.surveyType": "Type",
  "eproModule.surveys": "Surveys",
  "eproModule.tooManyFiles": "You can only upload one file at a time.",
  "eproModule.translated": "Translated",
  "eproModule.translationComplete": "Translation Complete:",
  "eproModule.translationIncomplete": "Translation Incomplete:",
  "eproModule.translationsInputAriaLabel": "Translations Input",
  "eproModule.uatEproCodeCopied": "{uat} Setup Code Copied",
  "eproModule.uatModalMessage": "Did this Collection pass {uat}?",
  "eproModule.uatModalNo": "No, make changes",
  "eproModule.uatModalTitle": "{uat} Outcome",
  "eproModule.uatModalYes": "Yes, complete {uat}",
  "eproModule.unlockEditing": "Unlock Editing",
  "eproModule.unsupportedStudyLanguages": "Unsupported Study Languages:",
  "eproModule.update": "Update",
  "eproModule.upload": "Upload",
  "eproModule.uploadImage": "Upload Image",
  "eproModule.uploadTranslations": "Upload Translations",
  "eproModule.usedIn": "Used In",
  "eproModule.username": "Username",
  "eproModule.version": "Version",
  "eproModule.versionNumber": "Version {majorVersion}.{minorVersion}",
  "eproModule.veryEasy": "Very Easy",
  "eproModule.veryHard": "Very Hard",
  "eproModule.view": "View",
  "eproModule.viewEvents": "View Events",
  "eproModule.viewGroups": "View Groups",
  "eproModule.workflowReasons":
    "You can't start {uat} for this collection for the following reason(s):",
  "eproModule.yes": "Yes",
  "eproModule.youCantEditThisValueForAVeevaLibrarySurvey":
    "You can't edit this value for a {veeva} Library survey.",
  "eproModule.youCantEditThisLibrarySurvey":
    "You can't edit this library survey.",
  "eproModule.yourImage": "Your image",
  "eproModule.yourLibrary": "Your Library",
  "error.moduleError.message": "Unable to load. Please try again.",
  "error.moduleError.tryAgain": "Try Again",
  "error.fallbackTitle": "Something Went Wrong",
  "error.fallbackMessage":
    "Sorry, we are having an issue with our website or servers. Please try again, and contact support if the problem continues.",
  "error.refresh": "Refresh",
  "error.401Title": "You're Logged Out",
  "error.401Message":
    "We logged you out while you were inactive. Please log in again.",
  "error.403Title": "Restricted Access",
  "error.403Message":
    "We are unable to show you this information because you do not have the right permissions. If you think you should have access, contact your administrator.",
  "error.503Message":
    "Sorry, the service for this action is unavailable. Please try again in a few minutes and contact support if the problem continues.",
  "error.studyLockedTitle": "Study Locked",
  "error.studyLockedMessage":
    "You cannot perform this action because database lock has been initiated.",
  "libraryManager.createNewVersion": "Create New Version",
  "libraryManager.preview": "Preview",
  "libraryManager.reviewed": "Reviewed",
  "libraryManager.licensed": "Licensed",
  "libraryManager.summaryOfChanges": "Summary of Changes",
  "libraryManager.seeMore": "See More",
  "libraryManager.edit": "Edit",
  "libraryManager.open": "Open",
  "libraryManager.delete": "Delete",
  "libraryManager.translations": "Translations",
  "libraryManager.addLanguage": "Add Language",
  "libraryManager.addReferenceMaterials": "Add Reference Materials",
  "libraryManager.manageImages": "Manage Images",
  "libraryManager.uploadTranslations": "Upload Translations",
  "libraryManager.language": "Language",
  "libraryManager.translationVersion": "Translation Version",
  "libraryManager.translationStatus": "Translation Status",
  "libraryManager.availableInLibrary": "Available in Library",
  "libraryManager.publish": "Publish",
  "libraryManager.translationTableSourceLanguage": "{language} (Source)",
  "libraryManager.ready": "Ready",
  "libraryManager.notAvailable": "Not Available",
  "libraryManager.incomplete": "Incomplete",
  "libraryManager.complete": "Complete",
  "libraryManager.version": "Version {num}",
  "libraryManager.emptyCell": "--",
  "libraryManager.NO": "No",
  "libraryManager.NOT_APPLICABLE": "N/A",
  "libraryManager.YES": "Yes",
  "libraryManager.DRAFT": "Draft",
  "libraryManager.SUPERSEDED": "Superseded",
  "libraryManager.PUBLISHED": "Published",
  "libraryManager.ARCHIVED": "Archived",
  "libraryManager.AVAILABLE": "Available",
  "libraryManager.NOT_AVAILABLE": "Not Available",
  "libraryManager.UNARCHIVED": "Unarchived",
  "libraryManager.READY": "Ready",
  "libraryManager.surveyStatus.READY": "Draft",
  "libraryManager.surveyStatus.AVAILABLE": "Published",
  "libraryManager.surveyStatus.ARCHIVED": "Archived",
  "libraryManager.surveyStatus.UNARCHIVED": "Unarchived",
  "libraryManager.surveyStatus.SUPERSEDED": "Superseded",
  "libraryManager.close": "Close",
  "libraryManager.remove": "Remove",
  "libraryManager.undo": "Undo",
  "libraryManager.generatingNewReport":
    "Generating new report. This may take up to 1 hour for large files.",
  "libraryManager.deleteVersion": "Delete Version",
  "libraryManager.generate": "Generate",
  "libraryManager.manage": "Manage",
  "libraryManager.moreActions": "More Actions",
  "libraryManager.exports": "Exports",
  "libraryManager.generating": "Generating...",
  "libraryManager.screenshotReportIsReady":
    "Screenshot report is ready. {downloadButton}",
  "libraryManager.screenshotReportFailedToGenerate":
    "Screenshot report failed to generate.",
  "libraryManager.failedToGenerateLatestScreenshots":
    "Failed to Generate Latest Screenshots",
  "libraryManager.generateNew": "Generate New",
  "libraryManager.latestScreenshots": "Latest Screenshots",
  "libraryManager.generatedDateTime": "Generated {dateTime}",
  "libraryManager.selectScreenshotLanguages": "Select Screenshot Languages",
  "libraryManager.selectScreenshotLanguagesTooltip":
    "Only languages with complete translations are available.",
  "libraryManager.download": "Download",
  "libraryManager.archive": "Archive",
  "libraryManager.attach": "Attach",
  "libraryManager.unarchive": "Unarchive",
  "libraryManager.upversion": "Upversion",
  "libraryManager.surveyVersion.viewDetails": "View Details",
  "libraryManager.libraryManager": "Library Manager",
  "libraryManager.referenceMaterials": "Reference Materials",
  "libraryManager.referenceMaterialRemoved": "{displayName} Removed",
  "libraryManager.referenceMaterialRemovedDescription":
    "Select Undo to restore {displayName}.",
  "libraryManager.displayName": "Display Name",
  "libraryManager.vaultLink": "{vault} Link",
  "libraryManager.documentType": "Document Type",
  "libraryManager.referenceMaterialDocumentType.sourceDocument":
    "Source Document",
  "libraryManager.referenceMaterialDocumentType.certificateOfTranslation":
    "Certificate of Translation",
  "libraryManager.referenceMaterialDocumentType.other": "Other",
  "libraryManager.notes": "Notes",
  "libraryManager.publishTranslationVersion": "Publish New Translation Version",
  "libraryManager.enterReasonForChange": "Enter reason for change",
  "libraryManager.publishTranslationModalDescription":
    "Publishing this version will supersede the previous translation version. Studies using the previous translation version will not be affected.",
  "libraryManager.toPublish": "Review the summary of changes and confirm.",
  "libraryManager.publishTooltip": "You must publish the source language first",
  "libraryManager.archiveSourceLanguage": "Archive Source Language",
  "libraryManager.archiveModalMessage":
    "Archiving the source language will remove it from the library so it can no longer be used in studies. This will also archive all other languages that the survey is available in.",
  "libraryManager.publishNewSurveyVersion": "Publish New Survey Version",
  "libraryManager.publishSurveyModalDescription":
    "Publishing this version will supersede the previous version in all languages. Studies using the previous survey version will not be affected.",
  "libraryManager.viewSummaryOfChanges": "View Summary of Changes",
  "libraryManager.uploadTranslations.error.1":
    "You can't upload a translation for the following.<br></br> Survey Version {version}<br></br> {language}, translation version {num}<br></br> Library Status: {status}<br></br> Create a new translation version and try again.",
  "libraryManager.uploadTranslations.error.2":
    "You have to upload a translation version for the following.<br></br> Survey Version {version}<br></br> {language}, translation version {num}<br></br> Are you sure you want to modify this translation?",
  "libraryManager.changeFile": "Change File",
  "libraryManager.create": "Create",
  "libraryManager.createNewTranslationVersion":
    "Create New Translation Version",
  "libraryManager.createTranslationWarning":
    "The survey version already has a {language} translation available in your library.",
  "libraryManager.createTranslationDescription":
    "Continuing with this upload will create a new translation version for {language}. You will be able to publish the new version when you're ready.",
  "libraryManager.enterReasonForUpdate": "Enter reason for update",
  "libraryManager.wrongSurveyVersion": "Wrong Survey Version",
  "libraryManager.wrongSurveyVersionDescription":
    "You've attempted to upload a file for a different survey version. Go to <semibold>Survey Version {num}</semibold> to upload the file.",
  "libraryManager.invalidVaultLinkError":
    "Must be a valid {ecoa} {vault} permalink",
  "libraryManager.ok": "OK",
  "libraryManager.back": "Back",
  "libraryManager.uploadTranslationSuccess":
    "{language} translation added to Survey Version {num}",
  "libraryManager.addLanguageSuccess":
    "Language(s) added to Survey Version {num}",
  "libraryManager.fileSelected": "File Selected",
  "libraryManager.translationFileIssues": "Translation File Issues",
  "libraryManager.problemWithFileUpload":
    "Upload Failed - Update File and Try Again",
  "libraryManager.downloadAllTranslations": "Download All Translations",
  "libraryManager.downloadUntranslatedText": "Download Untranslated Text",
  "libraryManager.useOnlyWhenRequired": "Use only when required",
  "libraryManager.downloadSourcePopulatedTranslations":
    "Download Source-Populated Translations",
  "libraryManager.downloadSourcePopulatedTranslationsTooltip":
    "Populates translation strings with source strings. This should only be used when required by the translation vendor.",
  "libraryManager.downloadTranslationsActions": "Download Translations Actions",
  "libraryManager.addLanguageHelp":
    "The languages below are supported by {myveevaforpatients}. If you need another language, please contact {veeva} support.",
  "libraryManager.deleteSurvey": "Delete Survey Version",
  "libraryManager.deleteModalMessage":
    "Continuing will delete Version {version}. This action cannot be reversed.",
  "libraryManager.customerLibrary.heading": "{customerName} Library",
  "libraryManager.customerLibrary.message":
    "Create and manage reusable library surveys. View the {veevaLibraryLink} to see surveys that have been pre-configured by {veeva}.",
  "libraryManager.customerLibrary.createNewSurvey": "Create New Survey",
  "libraryManager.customerLibrary.resultCount":
    "Showing {filteredCount} out of {totalSurveyCount} Surveys",
  "libraryManager.customerLibrary.publishedSurveys": "Published Surveys",
  "libraryManager.customerLibrary.publishedSurveysTooltip":
    "Surveys that are available for use in studies.",
  "libraryManager.customerLibrary.surveyLabel": "Survey Label",
  "libraryManager.customerLibrary.type": "Type",
  "libraryManager.customerLibrary.description": "Description",
  "libraryManager.customerLibrary.lastPublishedAt": "Last Published",
  "libraryManager.customerLibrary.systemVersion": "System Version",
  "libraryManager.customerLibrary.libraryStatus": "Library Status",
  "libraryManager.customerLibrary.status": "Status",
  "libraryManager.customerLibrary.languages": "Languages",
  "libraryManager.customerLibrary.emptyState": "No Library Surveys",
  "libraryManager.customerLibrary.emptyStateMessage":
    "Start by creating a survey",
  "libraryManager.cancel": "Cancel",
  "libraryManager.save": "Save",
  "libraryManager.saveAndExit": "Save & Exit",
  "libraryManager.create.createNewSurvey": "Create New Survey",
  "libraryManager.allowStudySpecificEdits": "Allow Study-Specific Edits",
  "libraryManager.allowStudySpecificEditsTooltip":
    "Allows users to edit the survey configuration after this library survey is added to a study.",
  "libraryManager.customerLibrary.surveyDescription": "Survey Description",
  "libraryManager.customerLibrary.expandButtonTitle": "Expand",
  "libraryManager.customerLibrary.collapseButtonTitle": "Collapse",
  "libraryManager.customerLibrary.noResults": "No Results",
  "libraryManager.customerLibrary.noResultsMessage":
    "Update your filters or search and try again.",
  "libraryManager.customerLibrary.searchFieldAriaLabel": "Search",
  "libraryManager.customerLibrary.searchFieldClearTitle": "Clear",
  "libraryManager.customerLibrary.manageLibrary": "Manage Library",
  "libraryManager.customerLibrary.downloadLibrarySnapshot":
    "Download Library Snapshot",
  "libraryManager.edit.editSurvey": "Edit Survey",
  "libraryManager.edit.summaryOfChanges": "Summary of Changes",
  "libraryManager.edit.disabledJsonTooltip":
    "You can't edit this survey because it has been published. Create a new version to edit.",
  "libraryManager.terminalPage.heading": "Survey Discarded",
  "libraryManager.terminalPage.returnToVaultMessage":
    "You can return to {vault} to view all surveys.",
  "libraryManager.terminalPage.returnToVault": "Return to {vault}",
  "libraryManager.terminalPage.createNewSurvey": "Create New Survey",
  "libraryManager.terminalPage.or": "or",
  "libraryManager.embeddedStaticPage.message":
    "Use Library Manager to create and edit library surveys.",
  "libraryManager.embeddedStaticPage.button": "Open Library Manager",
  "translations.errorLogAvailable": "Error Log Available",
  "translations.errorLogAvailableMessage":
    "Some files contained errors. Download the log for details.",
  "translations.discard": "Discard",
  "translations.download": "Download",
  "translations.exceededQueueLimit":
    "{limit} file limit exceeded. No files were added to the queue.",
  "translations.wrongFileOrSize":
    "One or more files are too large or in the wrong format. No files were added. Resize or reformat the files and try again.",
  "translations.successfullyUploaded": "Successfully Uploaded",
  "translations.uploadAndProcessingCompleteNoErrorsFound":
    "Upload and processing complete. No errors found.",
  "translations.numberOfFilesHaveErrors":
    "<span>{number} file(s) have errors.</span> <dismiss>Download Error Log</dismiss>",
  "translations.uploadWarning":
    "Do not close your browser or refresh this page during the upload process.",
  "translations.uploadAndProcessTranslations":
    "Upload and Process Translations",
  "translations.close": "Close",
  "translations.upload": "Upload",
  "translations.uploadMultipleFilesOr": "Upload multiple files or {link}",
  "translations.uploadMoreFiles": "Upload More Files",
  "translations.choose": "Choose",
  "translations.chooseOrDragAndDrop":
    "<choose>Choose</choose> <text>or drag and drop files here to add.</text>",
  "translations.format": "Format: .JSON",
  "translations.maxFileSize": "Max File Size: 10 MB",
  "translations.queue": "Queue: {queueCount}/{limit} files",
  "translations.removeFile": "Remove File",
  "translations.noTranslationsInProgress": "No Translations in Progress",
  "translations.addOneOrMoreTranslationFiles":
    "Add one or more translation files.",
  "translations.addATranslationFile": "Add a translation file.",
  "translations.chooseOneSurveyToUploadTo": "Choose one survey to upload to.",
  "translations.chooseOneSurveyToUploadTranslationsTo":
    "Choose one survey to upload translations to.",
  "translations.expand": "Expand",
  "translations.collapse": "Collapse",
  "translations.errorKey.T301":
    "<error>Error {errorCode}: </error>The following groups are locked and can't be edited: {groupNames}",
  "translations.errorKey.T302":
    "<error>Error {errorCode}: </error>The required group for the translation is missing.",
  "translations.errorKey.T303":
    "<error>Error {errorCode}: </error>The following groups don't exist: {groupNames}",
  "translations.errorKey.T304":
    "<error>Error {errorCode}: </error>The source language doesn't match group source language for the following groups: {groupNames}",
  "translations.errorKey.T305":
    "<error>Error {errorCode}: </error>The language for the translated strings must be different than the source language in the following groups: {groupNames}",
  "translations.errorKey.T306":
    "<error>Error {errorCode}: </error>The following languages aren't currently supported: {languageTags}",
  "translations.errorKey.T307":
    "<error>Error {errorCode}: </error>The file contains no translations.",
  "translations.errorKey.T308":
    "<error>Error {errorCode}: </error>The required key is missing for the following strings: {strings}",
  "translations.errorKey.T309":
    "<error>Error {errorCode}: </error>The required translated string is missing for the following keys: {groupKeyPairs}",
  "translations.errorKey.T310":
    "<error>Error {errorCode}: </error>The following language tags don't match the group language: {languageTags}",
  "translations.errorKey.T311":
    "<error>Error {errorCode}: </error>The keys below don't exist; you must add the source content before uploading translations.<br></br>{groupKeyPairs}",
  "translations.errorKey.T312":
    "<error>Error {errorCode}: </error>The source strings for the keys below don't match the current source content.<br></br>{groupKeyPairs}",
  "translations.errorKey.T313":
    "<error>Error {errorCode}: </error>An internal error occurred. Please try again.",
  "translations.errorKey.T314":
    "<error>Error {errorCode}: </error>The keys below already exist; all keys must be unique.<br></br>{groupKeyPairs}",
  "translations.errorKey.T315":
    "<error>Error {errorCode}: </error>The file contains invalid JSON formatting.",
  "translations.errorKey.serverError":
    "Sorry, we are having an issue with our website or servers. Please refresh the page and contact support if the problem continues.",
  "translations.errorLogFile": "translation_error_log_{datetime}",
  "rules.eventsCannotTriggerThisAction":
    "{eventNames} cannot trigger this action. Edit events or select a new event to resolve.",
  "rules.editMakeEventsAvailable": "Edit Make Events Available",
  "rules.deleteMakeEventsAvailable": "Delete Make Events Available",
  "rules.noEventsAllowingCriteriaCheckLinks":
    "There are no events configured to work with this rule template. Add an event to the events list and try again.",
  "rules.eventAlreadyLinked":
    "This event is already used by another rule and cannot be selected.",
  "rules.makeEventsAvailableDescription":
    "The selected events will become available to a Participant if the expression evaluates to true.",
  "rules.selectEvents": "Select Events",
  "rules.edit": "Edit",
  "rules.theFollowingErrorsArePreventingSave":
    "The following errors are preventing save",
  "rules.removeIncompatibleTokenInTitle":
    "Remove incompatible token in message title.",
  "rules.removeIncompatibleTokenInBody":
    "Remove incompatible token in message body.",
  "rules.invalidTooltip": "The following fields must be completed to save:",
  "rules.invalidTooltipName": "Name",
  "rules.invalidTooltipDescription": "Description",
  "rules.invalidTooltipTriggeringEvent": "Triggering Event",
  "rules.invalidTooltipNotifications": "Add Notification",
  "rules.invalidTooltipCriteria": "Add Criteria",
  "rules.invalidTooltipVariables": "Variables",
  "rules.noActionExpressionWarning":
    "Missing action expression. This action will not occur unless the action expression evaluates as true.",
  "rules.actionExpression": "Action Expression",
  "rules.actionExpressionTooltip":
    "The action expression determines if conditional actions occur.",
  "rules.timeExpressionTooltip": "Define an expression to return a time.",
  "rules.dateExpressionTooltip": "Define an expression to return a date.",
  "rules.datetimeExpressionTooltip":
    "Define an expression to return a datetime.",
  "rules.selectAStartScheduleOption":
    "Select a start schedule option above to get started.",
  "rules.selectingSurveyCompletionDatetime":
    "Selecting <b>“Survey Completion Datetime”</b> will start schedules using the date and time from when the survey was submitted.",
  "rules.selectingStartEventDatetime":
    "Selecting <b>“Start Event Datetime”</b> will start schedules using the start event datetime from the survey specified above.",
  "rules.selectingQuestionAnswer":
    "Selecting <b>“Question Answer”</b> will start schedules using a question from the survey specified above.",
  "rules.populateWith": "Populate with",
  "rules.datetime": "Datetime",
  "rules.dateAndTime": "Date and Time",
  "rules.date": "Date",
  "rules.startWith": "Start With",
  "rules.selectEvent": "Select Event",
  "rules.selectEventDescription": "Select an event to get started.",
  "rules.surveyCompletionDatetime": "Survey Completion Datetime",
  "rules.questionAnswer": "Question Answer",
  "rules.startEventDatetime": "Start Event Datetime",
  "rules.select": "Select",
  "rules.noApplicableEvents": "No Applicable Events",
  "rules.noApplicableEventsTooltip":
    "There are no available events configured to work with this rule template. Add an event to the events list and try again.",
  "rules.startSchedule": "Start Schedule",
  "rules.scheduleTriggerRuleActionDescription":
    "Configure actions to start schedules that are associated with this rule. ",
  "rules.scheduleTriggerRuleTriggerDescription":
    "Define which surveys start the schedule trigger.",
  "rules.addDatetimeReference": "Add Datetime Reference",
  "rules.overrideTime": "Override Time",
  "rules.overrideTimeDescription":
    "Optional: Use if you'd like to override the event's default time",
  "rules.addDateReference": "Add Date Reference",
  "rules.addTimeReference": "Add Time Reference",
  "rules.addTime": "Add Time",
  "rules.scheduleTriggerRuleLocked": "Schedule Trigger Rule (Locked)",
  "rules.scheduleTriggerRule": "Schedule Trigger Rule",
  "rules.scheduleTrigger": "Schedule Trigger",
  "rules.scheduleTriggerDescription":
    "Trigger a schedule based on when a rule is executed, instead of using a fixed start date and time.",
  "rules.populateEventRuleActionDescription":
    "The following actions will be performed when the referenced survey becomes compliant.",
  "rules.populateEventRuleTriggerDescription":
    "Define which surveys start the rule evaluation.",
  "rules.populateEventRuleLocked": "Populate Event Rule (Locked)",
  "rules.populateEventRule": "Populate Event Rule",
  "rules.populateEvent": "Populate Event",
  "rules.populateEventDescription":
    "Populate an event based off a date or datetime that is entered by a respondent within a survey.",
  "rules.surveyTriggeredApiCall": "Survey-triggered API Call",
  "rules.sendSurveyData": "Send Survey Data",
  "rules.sendSurveyDataDescription":
    "Use a survey to start an API Call that transfers the associated survey data to an external system.",
  "rules.sendMissedSurveys": "Send Missed Surveys",
  "rules.sendMissedSurveysDescription":
    "When enabled, the rule will call the configured API with null values when the triggering survey is missed.",
  "rules.saveAndExit": "Save & Exit",
  "rules.invalidDataFixAndTryAgain":
    "A survey's restricted data status and/or a referenced object name has changed. Review the protected data settings, fix any errors, and try again.",
  "rules.invalidHandlebarsSyntax":
    "A message or title contains an invalid template token.",
  "rules.addCriteriaCheckInEventsTab":
    "Add a Criteria Check Event in the <b>Events</b> tab to use this template.",
  "rules.addPopulatedByRuleInEventsTab":
    "Add an Event which is populated by a rule in the <b>Events</b> tab to use this template.",
  "rules.rules": "Rules",
  "rules.rulesAllowStudiesToConfigureNotifications":
    "Rules allow studies to configure notifications, data checks, schedules, data transfers, and other study behaviors.",
  "rules.createRule": "Create Rule",
  "rules.ruleName": "Rule Name",
  "rules.description": "Description",
  "rules.theDescriptionIsAnInternalRuleExplanation":
    "The description is an internal rule explanation and is only visible in Studio.",
  "rules.templateType": "Template Type",
  "rules.criteriaCheck": "Criteria Check",
  "rules.surveyBasedNotification": "Survey-based Notification",
  "rules.surveyBasedNotificationUpper": "Survey-Based Notification",
  "rules.editRule": "Edit Rule",
  "rules.deleteRule": "Delete Rule",
  "rules.noRules": "No Rules",
  "rules.startByAddingARule": "Start by adding a rule to this collection",
  "rules.rulesDisabled": "Rules Disabled",
  "rules.toCreateRulesMessage":
    "To create rules, all survey, schedule, group type, and group names must be valid.",
  "rules.ellipsis": "...",
  "rules.ruleTemplates": "Rule Templates",
  "rules.selectTemplate": "Select Template",
  "rules.sendConditionalEmailsOrNotifications":
    "Send conditional emails or notifications to site staff  based on survey data.",
  "rules.performSiteInitiatedConditionalEvalutations":
    "Perform site-initiated conditional evaluations of data and display the results.",
  "rules.back": "Back",
  "rules.surveyBasedNotificationRule": "Survey-based Notification Rule",
  "rules.surveyBasedNotificationRuleLocked":
    "Survey-based Notification Rule (Locked)",
  "rules.criteriaCheckRule": "Criteria Check Rule",
  "rules.criteriaCheckRuleLocked": "Criteria Check Rule (Locked)",
  "rules.surveyTriggeredApiRule": "Survey-triggered API Call",
  "rules.surveyTriggeredApiRuleLocked": "Survey-triggered API Call (Locked)",
  "rules.restrictedData": "Restricted Data",
  "rules.thisRuleShouldProtectRestrictedData":
    "This rule should protect restricted data",
  "rules.trigger": "Trigger",
  "rules.selectTheEventThatWillStartThisRule":
    "Select the event that will start this rule.",
  "rules.preconditions": "Preconditions",
  "rules.missingPreconditionsMessage": "Missing Preconditions Message:",
  "rules.missingPreconditionsMessageTooltip":
    "This message will be displayed to site users if preconditions aren't met when they run the criteria check.",
  "rules.conditionalActionsOptional": "Conditional Actions (Optional)",
  "rules.conditionalActionsDescription":
    "Add additional actions to this rule that will trigger when the expression below evaluates to true.",
  "rules.addAction": "Add Action",
  "rules.makeEventsAvailable": "Make Events Available",
  "rules.triggerFtpExport": "Trigger FTP Export",
  "rules.deleteTriggerFtpExport": "Delete Trigger FTP Export",
  "rules.exportJob:": "Export Job:",
  "rules.notConnected": "Not Connected",
  "rules.ftpExportNotConnectedMessage":
    "To trigger an FTP Export Job, create a new <link>FTP Export Job</link> and select the event: <b>{triggeringEventName}</b>.",
  "rules.ftpExportConnectedMessage":
    "Edits for this action must occur on the FTP Export Job(s).",
  "rules.noTriggeringEventConfigured": "No triggering event configured",
  "rules.deleteTriggerFtpExportAction": "Delete Trigger FTP Export Action",
  "rules.deleteTriggerFtpExportActionMessage":
    "Removing this action will prevent the FTP Export Job from firing. However, the job will remain active until it is deactivated.",
  "rules.ftpExportNotConnectedTooltip":
    "The rule must be in an approved collection before it can be used to trigger an FTP export job.",
  "rules.actions": "Actions",
  "rules.dragCriteriaToThisSection": "Drag Criteria to this section",
  "rules.editSection": "Edit Section",
  "rules.deleteSection": "Delete Section",
  "rules.moveEntityName": "Move {entityName}",
  "rules.actionsSubheader":
    "Add criteria and/or sections for this check that will display to site users.",
  "rules.eventName": "Event Name",
  "rules.selectAnEvent": "Select An Event",
  "rules.name": "Name",
  "rules.editName": "Edit Name",
  "rules.nameTooltip":
    "The name is an internal rule identifier and is only visible in Studio.",
  "rules.RULE": "Rule",
  "rules.SCHEDULE": "Schedule",
  "rules.STUDY_EVENT": "Event",
  "rules.STUDY_GROUP": "Group",
  "rules.STUDY_GROUP_TYPE": "Group Type",
  "rules.SURVEY": "Survey",
  "rules.SURVEY_BLOCK": "Block",
  "rules.SURVEY_SCORE": "Score",
  "rules.anyNegativeIntegerExcept0Or*CanBeUsedAsAReference":
    "Any negative integer (except 0), negative range, negative list, or * can be used as a reference",
  "rules.anyIntegerExcept0CanBeUsedAsAReference":
    "Any integer (except 0), range, list, or * can be used as a reference",
  "rules.deleteThisRule": "Delete This Rule?",
  "rules.deleteThisRuleMessage":
    "Deleting this rule will permanently remove it from your rule list. This action cannot be undone.",
  "rules.cancel": "Cancel",
  "rules.delete": "Delete",
  "rules.add": "Add",
  "rules.addAnother": "Add Another",
  "rules.save": "Save",
  "rules.hidden": "Hidden",
  "rules.displayLabel": "Display Label",
  "rules.displayLabel:": "Display Label:",
  "rules.siteVisibility:": "Site Visibility:",
  "rules.enabled": "Enabled",
  "rules.disabled": "Disabled",
  "rules.displayLabelTooltip":
    "The display label will be displayed in front of the calculated expression result. <br></br> <helpLink>See Help Page</helpLink>",
  "rules.hideFromSiteUsers": "Hide from Site Users",
  "rules.hideFromSiteUsersTooltip":
    "Section and criteria visibility are set independently. Hiding a section does not automatically hide its criteria.",
  "rules.addDefinition": "Add Definition",
  "rules.expression": "Expression",
  "rules.displayExpression": "Display Expression",
  "rules.expression:": "Expression:",
  "rules.displayExpression:": "Display Expression:",
  "rules.seeMore": "See more",
  "rules.seeLess": "See less",
  "rules.displayExpressionTooltip":
    "The display expression calculates the value that is displayed with the display label.",
  "rules.deleteMessageCriteria": "criteria",
  "rules.deleteMessageSection": "section",
  "rules.criteriaCheckActionDeleteConfirmation":
    "Are you sure you want to delete this {criteriaOrSection}?",
  "rules.surveyRuleActionDeleteConfirmation":
    "Are you sure you want to delete this notification?",
  "rules.sectionTitle": "Section Title",
  "rules.section": "Section",
  "rules.sectionTooltip":
    "<b>Sections</b> may be used to organize criteria for this check. You may reorder these items after you create them.",
  "rules.criteria": "Criteria",
  "rules.criteriaTooltip":
    "Criteria evaluate an expression and record the calculated result as a record in the check event.",
  "rules.criteriaName": "Criteria Name",
  "rules.criteriaNameTooltip":
    "This value will appear as a column name in Criteria Check Output reports.",
  "rules.notificationName": "Notification Name",
  "rules.and": "AND",
  "rules.nameMustBeUniqueToRule":
    "Name must be unique within the current rule.",
  "rules.referenceError": "Reference Error",
  "rules.editCriteria": "Edit Criteria",
  "rules.deleteCriteria": "Delete Criteria",
  "rules.editNotification": "Edit Notification",
  "rules.deleteNotification": "Delete Notification",
  "rules.addMessage": "Add Message",
  "rules.defineWhichSurveysStartTheRuleEvaluation":
    "Define which surveys start the rule evaluation.",
  "rules.surveyReference": "Survey Reference",
  "rules.preconditionsTooltip":
    "Preconditions define which data is required to run the expression.",
  "rules.surveyRuleExpressionTooltip":
    "Expressions define which data should be evaluated and how.",
  "rules.theFollowingActionsWillBePerformed":
    "The following actions will be performed if the expression evaluates to true.",
  "rules.sendNotification": "Send Notification",
  "rules.recipient:": "Recipient:",
  "rules.testEmails:": "Test Email(s):",
  "rules.title:": "Title:",
  "rules.body:": "Body:",
  "rules.protectRestrictedData:": "Protect Restricted Data:",
  "rules.yes": "Yes",
  "rules.no": "No",
  "rules.title": "Title",
  "rules.body": "Body",
  "rules.thisActionShouldProtectRestrictedData":
    "This action should protect restricted data",
  "rules.siteStaff": "Site Staff",
  "rules.emailAddress": "Email Address",
  "rules.recipient": "Recipient",
  "rules.roleType": "Role Type",
  "rules.emailAddress(es)": "Email Address(es)",
  "rules.chooseASiteRole": "Select Type",
  "rules.addEmailAndPressEnter":
    "Add an email and press <b>ENTER</b>. You can add multiple emails.",
  "rules.invalidEmailFormat": "Invalid email address",
  "rules.clearAll": "Clear All",
  "rules.addNew": "Add New",
  "rules.createNewVariable": "Create New Variable",
  "rules.templateTokens": "Template Tokens",
  "rules.variables": "Variables",
  "rules.ruleTools": "Rule Tools",
  "rules.noVariablesYet": "No Variables Yet",
  "rules.newVariable": "New Variable",
  "rules.ruleVariableNameValidation":
    "Names must begin with an upper case letter (A-Z) and contain no spaces. Additional letters and numbers (0-9) are also permitted.",
  "rules.definition": "Definition",
  "rules.deleteVariable": "Delete Variable",
  "rules.deleteVariableConfirmation":
    "Are you sure you want to delete this variable?",
  "rules.copyVariableName": "Copy Variable Name",
  "rules.protectRestrictedDataTooltipCriteriaCheckRule":
    "When set to Yes, users who can't access restricted data won't be able to run criteria checks and view results.",
  "rules.protectRestrictedDataTooltipSurveyRule":
    "Protecting restricted data limits which users receive notifications. Email notifications can't protect restricted data.",
  "rules.restrictedDataMayBeVisibleToUnauthorizedUsers":
    "Restricted data may be visible to unauthorized users.",
  "rules.asterisk": "*",
  "rules.deleteTrigger": "Delete Trigger",
  "rules.triggerSurveyInstanceAutocomplete":
    "Survey instance must be a positive integer or [*]",
  "rules.unscheduledEventSurveyInstanceAutocomplete":
    "Survey instance must be [*]",
  "rules.testEmailAddress(es)": "Test Email Address(es)",
  "rules.testEmailTooltip":
    "Test emails are sent to this email address during {uat}.",
  "rules.templateTokensAreSystemProvidedDynamicValues":
    "<b>Template tokens</b> are system-provided dynamic values that can be used in specific fields.",
  "rules.uatBlockedByRules": "{uat} Blocked by Rules",
  "rules.theFollowingRulesContainErrors":
    "The following rules contain errors that must be corrected to begin {uat}:",
  "rules.error": "Error",
  "rules.rulesMustBeInAValidSavedState":
    "Rules must be in a valid saved state.",
  "rules.eachRuleMustBeTranslated":
    "Each rule must be translated into the selected languages.",
  "rules.callApiTemplate": "Call API Template",
  "rules.callName": "Call Name",
  "rules.callNameRequired": "Call Name is required",
  "rules.template": "Template",
  "rules.expand": "Expand",
  "rules.collapse": "Collapse",
  "rules.edcDescription":
    "This template is configured to support calls to update form data associated with existing events in {veevaedc}.",
  "rules.mapping": "Mapping",
  "rules.fieldMapping": "Field Mapping",
  "rules.fieldMappingRequired": "Field Mapping is required",
  "rules.fieldMappingDescription":
    "The Field Mapping JSON defines which values should be sent to the external system. Please see <helpLink>help for details</helpLink>.",
  "rules.callMapping": "Call Mapping",
  "rules.callMappingEventGroupName": "eventgroup_name",
  "rules.callMappingEventName": "event_name",
  "rules.callMappingFormName": "form_name",
  "rules.callMappingStudyName": "study_name",
  "rules.callMappingUATStudyName": "uat_study_name",
  "rules.eventGroupNameRequired": "eventgroup_name is required",
  "rules.eventNameRequired": "event_name is required",
  "rules.formNameRequired": "form_name is required",
  "rules.deleteCallApiTemplate": "Delete Call API Template",
  "rules.deleteCallApiTemplateAction": "Delete Call API Template Action",
  "rules.deleteCallApiTemplateActionMessage":
    "Are you sure you want to delete this action?",
  "rules.timeTravelGutterWarning":
    "{uat} Time Travel not supported: {functionName} uses actual datetime",
  "manageSurvey.tooltip.invalidJson":
    "You can't save while there is invalid JSON present.",
  "studio.studio": "Studio",
  "veevaLibrary.veevaSurveyLibrary": "{veeva} Survey Library",
  "veevaLibrary.disclaimer":
    "This data is confidential and should not be shared publicly or with others outside your company.",
  "veevaLibrary.surveyLabel": "Survey Label",
  "veevaLibrary.type": "Type",
  "veevaLibrary.languages": "Languages",
  "surveyAutocomplete.sections.blocks.blockSettings.showPercent":
    "Determines whether a percentage symbol is displayed.",
  "surveyAutocomplete.sections.blocks.blockSettings.placement":
    "Defines where custom labels will appear along the scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.direction":
    "Defines the direction of scale.",
  "surveyAutocomplete.scores.result.condition":
    "Defines the condition that makes a score fall into this result category.",
  "surveyAutocomplete.scores.result.value":
    "Defines the string that displays if the score meets the condition of this result category.",
  "surveyAutocomplete.scores.name": "Defines the unique name of the score.",
  "surveyAutocomplete.scores.label":
    "Defines the score label that can be displayed to site users and is included in data exports.",
  "surveyAutocomplete.scores.function":
    "Defines how the score is calculated. See help documentation for supported operations.",
  "surveyAutocomplete.scores.display":
    "A boolean that defines whether a site user can see the score.",
  "surveyAutocomplete.scores.result":
    "The result array categorizes the score's numerical value into one or many result categories for additional context.",
  "surveyAutocomplete.conditions.optionalAnswer.name":
    "Defines the unique name of the optional answer.",
  "surveyAutocomplete.conditions.answer.value":
    "The condition uses the operation (==, !=, <, <=, >, >=) to evaluate the respondent's response against this value.",
  "surveyAutocomplete.conditions.answer.type":
    "The type of response value that the condition evaluates against. The type must match the controlling question's type and be consistent with the operation of the condition.",
  "surveyAutocomplete.conditions.answer.number":
    "The condition uses the operation (==, !=, <, <=, >, >=) to evaluate the respondent's response against this value.",
  "surveyAutocomplete.conditions.answer.name":
    "The condition uses the operation (==, !=, INCLUDES, NOT_INCLUDES) to evaluate the respondent's response against this value.",
  "surveyAutocomplete.conditions.name":
    "Defines the unique name of the condition.",
  "surveyAutocomplete.conditions.type":
    "Defines the type of the condition, either single or compound.",
  "surveyAutocomplete.conditions.conditions":
    "List the single or compound conditions that are being evaluated in the compound condition.",
  "surveyAutocomplete.conditions.operation":
    "Defines the comparison between the triggering response and the respondent's response.",
  "surveyAutocomplete.conditions.optionalAnswer":
    "The condition uses the operation (==, !=) to evaluate the respondent's response against this value.",
  "surveyAutocomplete.conditions.answer":
    "Creates an array to define the response type and response value that the condition evaluates against.",
  "surveyAutocomplete.conditions.blockName":
    "Defines the controlling question block being evaluated by the condition.",
  "surveyAutocomplete.sections.tableColumns.heading":
    "Defines the text that is displayed as a column heading.",
  "surveyAutocomplete.sections.tableColumns.width":
    "Defines the width of a column.",
  "surveyAutocomplete.sections.blocks.headingImage.image":
    "Defines the URL for the heading image uploaded to Studio.",
  "surveyAutocomplete.sections.blocks.headingImage.description":
    "A description of the heading image that can be read by screen readers for blind or low-vision respondents.",
  "surveyAutocomplete.sections.blocks.headingImage.maxHeightPercentage":
    "Defines the percentage of screen height a heading image will fill.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.answerImage.description":
    "Defines the description of the image that can be read by screen readers for blind or low-vision respondents.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.answerImage.image":
    "Defines the URL for the image uploaded to Studio.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.increment":
    "Defines the increment value that responses must be a multiple of.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.label":
    "Defines the text label of a number entry field that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.maxNumber":
    "Defines highest number that a respondent can enter.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.minNumber":
    "Defines the lowest number that a respondent can enter.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.placeholder":
    "Defines the text placeholder in the number entry field that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.answer":
    "The text of an answer option that is displayed to a respondent.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.answerImage":
    "Creates a container to define the image and description.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.name":
    "Defines the unique name of an answer option.",
  "surveyAutocomplete.sections.blocks.answerSet.answers.score":
    "Defines the score this question will receive if this answer is selected.",
  "surveyAutocomplete.sections.blocks.answerSet.answers":
    "Creates an array to define the block's answers.",
  "surveyAutocomplete.sections.blocks.blockSettings.answerImage.description":
    "Defines the description of the answer image that can be read by screen readers for visually-impaired respondents.",
  "surveyAutocomplete.sections.blocks.blockSettings.answerImage.image":
    "Defines the URL for the answer image uploaded to Studio.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks.label":
    "Defines the label shown at the corresponding position.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks.positions":
    "Defines the position where a label should appear.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks.placement":
    "Defines whether a label will be displayed above or below the scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks.showPercent":
    "Defines whether a numeric label displays a percentage symbol.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks.direction":
    "Defines whether a scale moves from min to max or max to min.",
  "surveyAutocomplete.sections.blocks.blockSettings.default.offset.unit":
    "Defines the unit of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.default.offset.value":
    "Defines the quantity of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.default.type":
    "Defines the type of the default value, either static or dynamic.",
  "surveyAutocomplete.sections.blocks.blockSettings.default.value":
    "Defines the value of the block's default response that is displayed to a respondent.",
  "surveyAutocomplete.sections.blocks.blockSettings.default.offset":
    "Creates a container to hold and define the unit and value that a respondent can enter as a response, in relation to the current point in time.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue.offset.unit":
    "Defines the unit of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue.offset.value":
    "Defines the quantity of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue.type":
    "Defines the type of the minimum value, either static or dynamic.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue.value":
    "Defines the minimum value that a respondent can enter as a response.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue.offset":
    "Creates a container to hold and define the unit and value that a respondent can enter as a response, in relation to the current point in time.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue.offset.unit":
    "Defines the unit of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue.offset.value":
    "Defines the quantity of the offset.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue.type":
    "Defines the type of the maximum value, either static or dynamic.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue.value":
    "Defines the maximum value that a respondent can enter as a response.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue.offset":
    "Creates a container to hold and define the unit and value that a respondent can enter as a response, in relation to the current point in time.",
  "surveyAutocomplete.sections.blocks.blockSettings.controlsBlock":
    "Defines the block that this block controls and cannot have the same response as.",
  "surveyAutocomplete.sections.blocks.blockSettings.controllingBlock":
    "Defines the controlling block that this block is controlled by and cannot have the same response as.",
  "surveyAutocomplete.sections.blocks.blockSettings.displayCount":
    "Enables the display of a numeric counter for selected joints.",
  "surveyAutocomplete.sections.blocks.blockSettings.countLabel":
    "Defines the text label that's displayed next to the displayCount.",
  "surveyAutocomplete.sections.blocks.blockSettings.displayResult":
    "Defines whether the numeric value of the respondent's selected position is displayed.",
  "surveyAutocomplete.sections.blocks.blockSettings.markDisplayInterval":
    "Defines how often marks are displayed to the right of the visual analog scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.markNumberInterval":
    "Defines how often numbers are displayed along the visual analog scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxLabel":
    "Defines the label that is displayed with the maximum value.",
  "surveyAutocomplete.sections.blocks.blockSettings.minLabel":
    "Defines the label that is displayed with the minimum value.",
  "surveyAutocomplete.sections.blocks.blockSettings.orientation":
    "Defines whether the scale is displayed in a horizontal or vertical format.",
  "surveyAutocomplete.sections.blocks.blockSettings.visualScaleDisplayType":
    "Defines whether the visualScale line is displayed as a wider bar that fills with color as the user interacts, or as a thin line with minimal styling.",
  "surveyAutocomplete.sections.blocks.blockSettings.label":
    "Defines the text label of a text entry field that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.blockSettings.placeholder":
    "Defines text placeholder in the text entry field that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxLength":
    "Defines the maximum number of characters a respondent can enter.",
  "surveyAutocomplete.sections.blocks.blockSettings.answerImage":
    "Creates a container to hold and define an answer image and description.",
  "surveyAutocomplete.sections.blocks.blockSettings.customMarks":
    "Creates a container to hold and define the positions and labels of the scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.increment":
    "Defines the increment value for responses, limiting selections to multiples of this value.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxNumber":
    "Defines the highest number a respondent can select on the scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.minNumber":
    "Defines the lowest number a respondent can select on the scale.",
  "surveyAutocomplete.sections.blocks.blockSettings.answerHeight":
    "Defines the height of the block's individual response options as either variable or consistent.",
  "surveyAutocomplete.sections.blocks.blockSettings.displayAsDropdown":
    "Defines whether the block's response options are displayed in a list or in a drop-down menu.",
  "surveyAutocomplete.sections.blocks.blockSettings.default":
    "Creates a container for the parameters of the block's default response that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.blockSettings.minValue":
    "Creates a container for the minimum value parameters.",
  "surveyAutocomplete.sections.blocks.blockSettings.maxValue":
    "Creates a container for the maximum value parameters.",
  "surveyAutocomplete.sections.blocks.blockSettings":
    "Creates a container to define and hold parameters for block settings.",
  "surveyAutocomplete.sections.blocks.blockSettings.relatedSurvey":
    "Defines the survey that will populate the list of possible answers for the respondent.",
  "surveyAutocomplete.sections.blocks.blockSettings.summaryBlocks":
    "Defines the block answer which is used to provide context for link block answers.",
  "surveyAutocomplete.sections.blocks.blockSettings.emptyState":
    "Defines the message that is displayed to respondents if no relatedSurveys are available.",
  "surveyAutocomplete.sections.blocks.blockSettings.listRange":
    "Defines the limit in days for valid responses.",
  "surveyAutocomplete.sections.blocks.optionalAnswers.name":
    "Defines the unique name for an optional answer. Must be unique within the question.",
  "surveyAutocomplete.sections.blocks.optionalAnswers.answer":
    "Defines the text of the optional answer that is displayed to respondents.",
  "surveyAutocomplete.sections.blocks.optionalAnswers.score":
    "Defines the score this question will receive if this answer is selected.",
  "surveyAutocomplete.sections.blocks.type": "Defines the type of the block.",
  "surveyAutocomplete.sections.blocks.name":
    "Defines the unique name of the block.",
  "surveyAutocomplete.sections.blocks.position":
    "Defines the row and column of the block.",
  "surveyAutocomplete.sections.blocks.heading":
    "Defines the heading that is displayed at the top of the section.",
  "surveyAutocomplete.sections.blocks.headingImage":
    "Creates a container to define the image and description.",
  "surveyAutocomplete.sections.blocks.condition":
    "References the condition that causes the block to be displayed to the respondent if the condition is true.",
  "surveyAutocomplete.sections.blocks.questionNumber":
    "Defines the number that is displayed before the heading.",
  "surveyAutocomplete.sections.blocks.answerSet":
    "Creates an container to define the block's answer set.",
  "surveyAutocomplete.sections.blocks.optionalAnswers":
    "Creates an array to define the block's optional answers, if applicable.",
  "surveyAutocomplete.sections.name":
    "Defines the unique section name. Name is only used by the system and not displayed to respondents.",
  "surveyAutocomplete.sections.type":
    "Defines how the section's blocks are displayed",
  "surveyAutocomplete.sections.condition":
    "References the condition that causes the section to be displayed to the respondent if the condition is true.",
  "surveyAutocomplete.sections.heading":
    "Defines the heading that is displayed at the top of the section.",
  "surveyAutocomplete.sections.stickyHeading":
    "Defines whether the section heading will stay visible when the respondent scrolls down the page.",
  "surveyAutocomplete.sections.tableColumns":
    "Creates a container for up to six columns that will be displayed as a table.",
  "surveyAutocomplete.sections.stickyTableHeading":
    "Defines whether the table heading will stay visible when the respondent scrolls down the page.",
  "surveyAutocomplete.sections.blocks":
    "Creates a container for blocks within a section.",
  "surveyAutocomplete.parts":
    "Creates a container to define and hold survey parts to support multi-part surveys.",
  "surveyAutocomplete.parts.name":
    "Defines the unique part name. parts.name is only used by the system and is not displayed to respondents.",
  "surveyAutocomplete.parts.displayLabel":
    "Defines the display label that is displayed at the top of the survey part.",
  "surveyAutocomplete.parts.sections":
    "Defines the sections in this survey part.",
  "surveyAutocomplete.parts.partType": "Defines the type of this survey part.",
  "surveyAutocomplete.parts.respondent":
    "Defines the respondent of this survey part.",
  "surveyAutocomplete.label":
    "Defines the official label of the survey. This label is displayed in the collection and is not displayed for respondents.",
  "surveyAutocomplete.description":
    "Defines the description of the survey that provides additional context about the survey in the JSON. The description is not displayed to respondents.",
  "surveyAutocomplete.surveyType":
    "Defines whether the survey is an {epro} or {eclinro} survey.",
  "surveyAutocomplete.surveySubtype":
    "Determines whether the survey is a standard, diary, or training survey.",
  "surveyAutocomplete.diarySettings":
    "Creates a container to hold and define the parameters for diary surveys.",
  "surveyAutocomplete.diarySettings.diaryLabel":
    "The label of this diary which is displayed on the To Do page for respondents.",
  "surveyAutocomplete.diarySettings.actionLabel":
    "Additional label or call-to-action for this diary which is displayed on the To Do page for respondents.",
  "surveyAutocomplete.diarySettings.description":
    "Additional information or instructions that are displayed to the respondent.",
  "surveyAutocomplete.diarySettings.addNewDescription":
    "Description displayed with the action to start a new as-needed diary.",
  "surveyAutocomplete.diarySettings.showResponses":
    "Determines whether respondents can view responses of their completed surveys",
  "surveyAutocomplete.diarySettings.summaryBlocks":
    "The block in this survey that is used to summarize an instance of this survey. Example: time block that indicates when the activity occurred.",
  "surveyAutocomplete.languageOverride":
    "Overrides the default language setting, allowing an {eclinro} to use patient languages instead of site languages.",
  "surveyAutocomplete.licenseText":
    "Defines the licensing and copyright information of the survey, if applicable.",
  "surveyAutocomplete.licenseImage":
    "Creates a container to define and hold the survey license image URL and description, if applicable.",
  "surveyAutocomplete.licenseImage.image":
    "Defines the URL for the image uploaded to Studio.",
  "surveyAutocomplete.licenseImage.description":
    "Defines the description of the image that can be read by screen readers for blind or low-vision respondents.",
  "surveyAutocomplete.additionalDetails":
    "Defines the details or licensing information for the survey, if applicable.",
  "surveyAutocomplete.overtNavigation":
    "Determines whether the survey displays navigation controls for moving between questions.",
  "surveyAutocomplete.reviewPrompt":
    "Determines whether a prompt is displayed at the end of the survey to instruct the respondent to review their responses before submitting.",
  "surveyAutocomplete.scores": "Creates an array to define scores.",
  "surveyAutocomplete.conditions":
    "Creates a container to define and hold conditions.",
  "surveyAutocomplete.sections": "Creates a container for a survey section.",
  "surveyAutocomplete.sections.repeatSettings":
    "Creates a container to hold and define the settings for repeating sections.",
  "surveyAutocomplete.sections.repeatSettings.questionNumber":
    "Defines the number that is displayed before the heading.",
  "surveyAutocomplete.sections.repeatSettings.heading":
    "Defines the heading for this group of repeating questions.",
  "surveyAutocomplete.sections.repeatSettings.summaryBlock":
    "Defines the block in this section whose response is used to summarize a set of repeating questions.",
  "surveyAutocomplete.sections.repeatSettings.minEntry":
    "Defines the minimum number of responses required.",
  "surveyAutocomplete.sections.repeatSettings.maxEntry":
    "Defines the maximum number of responses that can be added.",
  "surveyAutocomplete.sections.blocks.imageType":
    "Specifies the type of interactive image.",
  "surveyAutocomplete.validations":
    "Creates a container to define and hold validations.",
  "surveyAutocomplete.validations.name":
    "Defines the unique name of the validation.",
  "surveyAutocomplete.validations.function":
    "Defines the validation logic. See help documentation for supported operations.",
  "surveyAutocomplete.validationSettings":
    "Creates a container to define and hold the block's validation settings parameters.",
  "surveyAutocomplete.validationSettings.validation":
    "Refers to a validation configured in the validations array.",
  "surveyAutocomplete.validationSettings.message":
    "Error message displayed to the user if the validation logic evaluates to false.",
  "scheduleAutocomplete.start.delay.value":
    "Defines the amount of time delayed, based on configured units.",
  "scheduleAutocomplete.start.delay.unit":
    "Defines the unit type of the delay.",
  "scheduleAutocomplete.start.delay":
    "Creates a container to define and hold the offset amount from the Start Event.",
  "scheduleAutocomplete.start.startEvents":
    "Defines the event or events that trigger the start of the schedule.",
  "scheduleAutocomplete.start.startRules":
    "Defines the rule or rules that trigger the start of the schedule.",
  "scheduleAutocomplete.end.endEvents":
    "Defines the event or events that trigger the end of the schedule.",
  "scheduleAutocomplete.available.duration.value":
    "Defines the length of the duration in configured units.",
  "scheduleAutocomplete.available.duration.unit":
    "Defines the unit type of the duration.",
  "scheduleAutocomplete.available.type": "Defines the schedule type.",
  "scheduleAutocomplete.available.duration":
    "Creates a container to define and hold the period of time when the survey is available.",
  "scheduleAutocomplete.available.startTime":
    "Defines the time when the survey's availability begins.",
  "scheduleAutocomplete.available.endTime":
    "Defines the time when the survey's availability ends.",
  "scheduleAutocomplete.available.expected":
    "Defines an expected window for the submission.",
  "scheduleAutocomplete.available.expected.endTime":
    "Defines the end time of the expected window.",
  "scheduleAutocomplete.available.expected.endDayOffset":
    "Defines the number of days the end time is offset by.",
  "scheduleAutocomplete.available.expected.duration":
    "Creates a container to define and hold the period of time when the survey is expected.",
  "scheduleAutocomplete.available.expected.duration.value":
    "Defines the length of the duration in configured units.",
  "scheduleAutocomplete.available.expected.duration.unit":
    "Defines the unit type of the duration.",
  "scheduleAutocomplete.available.endDayOffset":
    "Defines the number of days the end time is offset by.",
  "scheduleAutocomplete.available.recurrenceRule":
    "Defines how often the schedule recurs.",
  "scheduleAutocomplete.available.startMultiple":
    "Determines if users can start multiple as needed surveys at the same time",
  "scheduleAutocomplete.available.partialWindow":
    "Defines whether the schedule will start when within a partial window.",
  "scheduleAutocomplete.notifications.offset.value":
    "Defines the offset amount in configured units.",
  "scheduleAutocomplete.notifications.offset.unit":
    "Defines the unit type of the offset.",
  "scheduleAutocomplete.notifications.surveyPart":
    "Defines the survey part that this notification applies to.",
  "scheduleAutocomplete.notifications.template":
    "Defines the notification template that will be delivered.",
  "scheduleAutocomplete.notifications.name":
    "Defines the unique name of the notification schedule.",
  "scheduleAutocomplete.notifications.type":
    "Defines the type of the notification.",
  "scheduleAutocomplete.notifications.numMissed":
    "Defines the number of surveys that must be missed to send the notification.",
  "scheduleAutocomplete.notifications.offset":
    "Creates a container to define how much time before the due date the notification should be delivered.",
  "scheduleAutocomplete.notifications.recurrenceRule":
    "Defines how often the notification recurs.",
  "scheduleAutocomplete.notifications.defaultDeliveryTime":
    "Defines the time when the notification is delivered.",
  "scheduleAutocomplete.name": "Defines the unique name of the schedule.",
  "scheduleAutocomplete.description":
    "Defines a description that is contained within the JSON. Not shown to participants.",
  "scheduleAutocomplete.exportDetail":
    "Defines additional schedule details that will be included in adherence and survey data exports.",
  "scheduleAutocomplete.location":
    "Defines the location where the participant or caregiver survey should be completed.",
  "scheduleAutocomplete.groups":
    "Defines the groups that the schedule should apply to.",
  "scheduleAutocomplete.start":
    "Creates a container to define and hold the schedule's beginning.",
  "scheduleAutocomplete.end":
    "Creates a container to define and hold the schedule's ending.",
  "scheduleAutocomplete.available":
    "Creates a container to define and hold the schedule's availability.",
  "scheduleAutocomplete.notifications":
    "Creates a container to define a notification schedule.",
  "scheduleAutocomplete.timepointLabel":
    "Defines the value that is dynamically displayed within the survey display name when used with the {{timepointLabel}} token.",
  "timezoneType.utc": "UTC",
  "timezoneType.local": "Local",
}
